{
    "logo": "Logo Cefabile",
    "add": "Aggiungere",
    "all": "Tutto",
    "edit": "Modificare",
    "create": "Creare",
    "delete": "Eliminare",
    "previous": "Precedente",
    "next": "Prossimo",
    "search": "Ricerca",
    "loading": "Caricamento...",
    "reload": "Ricaricare",
    "cancel": "Cancellare",
    "copy": "Copia",
    "save": "Salva",
    "saveAndFinish": "Salva e termina",
    "saveAndContinue": "Salva e continua",
    "saved": "Salvato",
    "done": "Fatto",
    "back": "Indietro",
    "play": "Giocare",
    "pause": "Pausa",
    "success": "Successo",
    "continue": "Continuare",
    "options": "Opzioni",
    "share": "Condividere",
    "finish": "Fine",
    "finishEdit": "Fine Modifica",
    "advancedOptions": "Visualizza opzioni avanzate",
    "authenticating": "Autenticazione in corso...",
    "skipToMain": "Vai al contenuto principale",
    "skip": "Saltare",
    "close": "Vicino",
    "notFound": "Pagina non trovata",
    "notFoundDescription": "Oh no! Abbiamo cercato nel mare e non riusciamo a trovare la pagina!",
    "exitSetup": "Esci dalla configurazione",
    "experimental": "Sperimentale",
    "letGetStarted": "Cominciamo!",
    "exploreInputControls": "Esplora i controlli di input",
    "when": "Quando io...",
    "thenMacro": "Cephable correrà...",
    "controls": "Controlli",
    "welcome": "Benvenuto.",
    "beta": "beta",
    "macroEmpty": "Non ci sono macro che corrispondono a questi criteri.",
    "you": "Voi",
    "step": "Fare un passo",
    "steps": "Passi",
    "learnMore": "Saperne di più",
    "dangerZone": "Zona pericolosa",
    "connected": "Collegato",
    "notConnected": "Non connesso",
    "connectAndLearn": "Connettiti e impara",
    "tryAgain": "Riprova",
    "by": "Di: {{value}}",
    "noName": "- nessun nome -",
    "details": "Dettagli",
    "controlFeed": "Controllo Feed",
    "mobileApp": {
        "title": "Applicazione mobile"
    },
    "dashboard": {
        "title": "Pannello di controllo"
    },
    "wifi": {
        "disconnected": "Il Wi-Fi è disconnesso.",
        "connected": "La connessione Wi-Fi è attiva.",
        "description": "Connettiti al Wi-Fi per consentire a Cephable di funzionare con le tue connessioni e il tuo software. Potresti avere una capacità limitata di utilizzare i tuoi controlli attuali."
    },
    "signalR": {
        "disconnected": "La sincronizzazione è interrotta.",
        "action": "Riconnetti",
        "description": "Sembra esserci un problema con la sincronizzazione di Cephable. Ciò causerà problemi nel salvataggio delle impostazioni o nella comunicazione con altre connessioni.",
        "disconnectedDevice": "Impossibile sincronizzare con {{name}}.",
        "disconnectedDeviceDescription": "Sembra che ci sia un problema di sincronizzazione dovuto all'autenticazione o alla connettività Internet. Non è possibile inviare o ricevere dati in remoto. È necessario controllare entrambi i lati della connessione.",
        "connected": "La sincronizzazione è connessa.",
        "connectedDescription": "Cephable si sincronizza correttamente e dovrebbe comunicare con le tue connessioni ed estensioni come previsto.",
        "swap": "Passa alla connessione del dispositivo locale",
        "unlinkedDevice": "Connessione rimossa.",
        "unlinkedDeviceDescription": "Questa connessione è stata scollegata dal tuo account.",
        "featureRestricted": "Le funzionalità Crea e automatizza non sono disponibili per le connessioni remote.",
        "featureRestrictedDescription": "Questa funzionalità non è attualmente disponibile per le connessioni remote. Passa alla connessione al dispositivo locale per sfruttare appieno le potenzialità di creazione e automazione del tuo lavoro."
    },
    "billing": {
        "title": "Fatturazione",
        "expires": "Prossima fatturazione: {{value}}",
        "isEmployeeAccess": {
            "title": "Professionale",
            "titleLong": "Professionista Cephable",
            "short": "Professionista",
            "description": "Cephable Professional offre agli utenti maggiore produttività, estendendo l'intelligenza artificiale locale e privata alle capacità generative.",
            "supportedFeatures": {
                "tag": "Tutto in Plus, plus",
                "features": [
                    "Flussi di lavoro di intelligenza artificiale su dispositivo",
                    "Gestione dell'organizzazione aziendale",
                    "restrizioni aziendali",
                    "Installazioni illimitate su diversi dispositivi.",
                    "Controlli dell'app pre-addestrati illimitati"
                ]
            }
        },
        "isDeveloperAccess": {
            "title": "Kit di sviluppo software",
            "titleLong": "SDK cefalico",
            "short": "Kit di sviluppo software",
            "description": "Gli SDK di Cephable consentono di integrare potenti controlli adattivi (voce, viso, testa e altro) nel software con un impatto minimo e il massimo vantaggio.",
            "supportedFeatures": {
                "tag": "Tutto in Plus, plus",
                "features": [
                    "Supporto per Windows e MacOS",
                    "SDK leggeri e integrabili per input vocali, facciali, oculari e di azioni rapide offline",
                    "Supporto API/webhook per azioni di output personalizzate",
                    "Documentazione per sviluppatori",
                    "Progetti campione",
                    "Trasforma i comandi in automazione e navigazione dei documenti",
                    "Portale per sviluppatori per la gestione di progetti, client di autorizzazione, tipi di dispositivi e altro ancora"
                ]
            }
        },
        "isStudentAccess": {
            "title": "Studente",
            "titleLong": "Istruzione Cefabile",
            "short": "Edu",
            "description": "Cephable Education supporta l'apprendimento personalizzato e le classi inclusive. Cephable funziona offline, funziona su dispositivo e non richiede integrazioni di terze parti.",
            "supportedFeatures": {
                "tag": "Tutto in Plus, plus",
                "features": [
                    "Installazioni di dispositivi illimitate",
                    "Controlli app pre-addestrati illimitati",
                    "Condivisione illimitata dei controlli delle app personalizzate"
                ]
            }
        },
        "viewProducts": "Visualizza i prodotti",
        "description": "Gestisci la fatturazione, i posti, gli upgrade degli abbonamenti, i rinnovi o le cancellazioni della tua organizzazione.",
        "view": "Gestisci la fatturazione",
        "isResellerAccess": {
            "title": "Rivenditore",
            "titleLong": "Rivenditore Cephable",
            "description": "Cephable Reseller è una licenza a pagamento che ti consente di creare nuove organizzazioni e assegnare chiavi di licenza. Ciò include l'utilizzo di Cephable con la tua suite software e il miglioramento della tua esperienza utente.",
            "short": "Rivenditore"
        },
        "error": "Contatta l'amministratore di sistema per gestire la fatturazione.",
        "included": "Incluso nella tua licenza {{licenseType}}.",
        "upgrade": {
            "description": "Esegui subito l'aggiornamento e porta i tuoi controlli a un livello superiore.",
            "action": "Aggiorna ora",
            "error": "Errore durante l'aggiornamento. Riprova più tardi.",
            "requiredDetail": "Per questa funzionalità è richiesta una licenza {{licenseType}}. Puoi sempre effettuare l'upgrade o iniziare una prova gratuita nelle Impostazioni Account.",
            "enableTextGeneration": "Genera contenuti utilizzando l'intelligenza artificiale e la tua voce.",
            "longDescription": "Passa a una licenza a pagamento per sbloccare tutte le funzionalità di Cephable. Dalla gestione di più dispositivi, ai controlli avanzati, alle integrazioni personalizzate, Cephable ha tutto ciò che ti serve per raggiungere il livello successivo di produttività.",
            "compare": "Confronta i piani",
            "enableAiDictation": {
                "title": "Passa alla dettatura intelligente",
                "description": "Esegui l'upgrade per sbloccare la dettatura avanzata dell'IA. Posso aggiungere punteggiatura, correggere le maiuscole e adattarmi al tuo stile, in modo che la tua scrittura risulti impeccabile senza sforzi aggiuntivi."
            },
            "enableAiWorkflows": "Aggiorna il tuo sistema per automatizzare le attività del desktop e del browser con i flussi di lavoro basati sull'intelligenza artificiale."
        },
        "isPlusAccess": {
            "title": "Più",
            "titleLong": "Cephable Plus",
            "short": "Più",
            "description": "Cephable Plus è pensato per gli utenti esperti che desiderano ottenere di più grazie a voce intelligente, dettatura intelligente, centinaia di controlli delle app e molto altro.",
            "supportedFeatures": {
                "tag": "Tutto ciò che è in Basic, più",
                "features": [
                    "Comandi vocali intelligenti (linguaggio naturale)",
                    "Dettatura intelligente (potenziata dall'IA)",
                    "Compiti intelligenti (Generazione, Traduzione, Riscrittura)",
                    "Centinaia di controlli per app pre-addestrati"
                ]
            }
        },
        "personal": {
            "short": "Di base",
            "title": "Di base",
            "titleLong": "Cephable Basic",
            "description": "Cephable Basic è gratuito per sempre ed è progettato per aiutarti a muoverti più velocemente, a esprimerti e a portare a termine i tuoi progetti, a modo tuo. Le funzionalità incluse nella versione Basic sono disponibili per tutti gli utenti.",
            "upgrade": {
                "title": "Porta i tuoi controlli a un livello superiore",
                "description": "Passa a Plus o Pro per sbloccare tutte le mie funzionalità. Più precisione. Più connessioni. Più controlli. Più potenza per portare la tua produttività a un livello superiore.",
                "featureHeading": "Ecco come posso aiutarti:",
                "control": "Ti guido più velocemente tra app e strumenti usando la tua voce o azioni rapide, senza interruzioni. Con Intelligent Voice possiamo semplicemente chattare.",
                "create": "Riscrivo, dettato, genero e traduco direttamente all'interno delle tue app, senza dover copiare, incollare o cambiare schermata.",
                "automate": "Eseguo attività intelligenti e azioni rapide che velocizzano il tuo flusso di lavoro. Dai comandi più semplici alle macro più complesse, posso occuparmi del lavoro più impegnativo, così puoi concentrarti sul lavoro che conta davvero.",
                "local": "Tutta IA locale. Nessuna elaborazione cloud."
            }
        },
        "mostPopular": "I più popolari",
        "subscription": {
            "options": "Opzioni di abbonamento",
            "monthly": "Paga mensilmente",
            "billedMonthly": "/mese",
            "yearly": "Paga annualmente",
            "billedYearly": "/anno"
        }
    },
    "organization": {
        "title": "Organizzazione",
        "titlePlural": "Organizzazioni",
        "titleLong": "Cephable Professional per le organizzazioni",
        "description": "Le organizzazioni sono gruppi di utenti che possono collaborare a progetti e condividere risorse. Qui puoi gestire il tuo team, i profili del team, la fatturazione e altro ancora.",
        "noAccess": {
            "title": "Accesso negato.",
            "description": "I tuoi permessi sono cambiati di recente e non hai più accesso a questa funzionalità. Se ritieni che si tratti di un errore, contatta l'amministratore della tua organizzazione."
        },
        "noOrg": {
            "title": "Nessuna licenza associata.",
            "description": "Al momento non sei associato a una licenza o a un gruppo di sviluppatori. L'accesso al portale è riservato agli utenti con una licenza Cephable a pagamento. Per sfruttare appieno il potenziale di Cephable, inizia una prova gratuita senza rischi."
        },
        "member": {
            "title": "Membro",
            "titlePlural": "Membri",
            "me": "La mia iscrizione",
            "description": "I membri sono utenti che fanno parte della tua organizzazione. Possono essere assegnati a ruoli diversi e avere accesso a parti diverse dell'organizzazione.",
            "edit": "Modifica membri",
            "removed": "Sei stato rimosso da una squadra.",
            "removedDescription": "Sei stato rimosso dal team. Non puoi più accedere all'organizzazione. Se ritieni che si tratti di un errore, contatta l'amministratore della tua organizzazione.",
            "updated": "Riuscito, l'iscrizione di {{value}} è stata aggiornata.",
            "error": "Errore durante l'aggiornamento dell'iscrizione a {{value}}.",
            "delete": "Riuscito, {{value}} è stato rimosso.",
            "deleteError": "Errore durante la rimozione di {{value}}.",
            "deleteConfirmation": {
                "title": "Sei sicuro di voler rimuovere questo membro?",
                "description": "Una volta rimosso questo membro, non avrà più accesso all'organizzazione. Puoi sempre invitarlo di nuovo in seguito.",
                "confirm": "Sì, rimuovi membro"
            },
            "viewAll": {
                "title": "Visualizza tutti i membri",
                "description": "Visualizza tutti i membri della tua organizzazione e gestisci i loro ruoli e autorizzazioni."
            },
            "seats": {
                "title": "Posti dei membri",
                "description": "Ogni membro della tua organizzazione conta come un posto. Il tipo di permessi che hanno può essere modificato dall'amministratore dell'organizzazione.",
                "stats": "posti su {{value}}",
                "max": "Posti massimi",
                "current": "Posti attuali",
                "limit": {
                    "title": "Raggiunto il numero massimo di posti",
                    "description": "Il tuo piano attuale ha raggiunto il limite di {{ maxSeats }} posti disponibili. Non puoi invitare altri membri. Contatta il tuo amministratore per aggiornare il piano o gestire l'assegnazione dei posti."
                },
                "updateLimit": {
                    "title": "Aggiorna il tuo piano per aggiungere più posti",
                    "description": "Il tuo piano attuale ha raggiunto il numero massimo di posti: {{ maxSeats }}. Esegui l'upgrade ora per sbloccare posti aggiuntivi e garantire che il tuo team possa continuare a crescere senza problemi.",
                    "action": "Piano di aggiornamento"
                },
                "maxSeatValue": "Numero massimo di posti: {{value}}"
            },
            "aboutMe": "Su di me",
            "loadError": "Errore durante il caricamento dei membri dell'organizzazione.",
            "orgTitle": "Membri di {{value}}",
            "emailExists": "L'email esiste già nell'organizzazione. Inserisci un indirizzo email diverso."
        },
        "invite": {
            "title": "Invitare",
            "titlePlural": "Invita",
            "description": "Gli inviti vengono inviati agli utenti per unirsi alla tua organizzazione. Puoi invitare gli utenti a unirsi alla tua organizzazione e assegnare loro ruoli diversi.",
            "edit": "Aggiungi un membro",
            "view": "Visualizza tutti gli inviti",
            "viewDescription": "Visualizza tutti gli inviti attuali che non sono stati accettati.",
            "new": "Invita un membro",
            "emailRequired": "L'email è obbligatoria",
            "emailInvalid": "L'email non è valida. Inserisci un indirizzo email valido.",
            "emailExists": "L'email ha già un invito dell'organizzazione. Inserisci un indirizzo email diverso.",
            "emailPlaceholder": "Inserisci l'indirizzo email",
            "expiration": "Scade",
            "delete": "Elimina invito",
            "confirm": "Sei sicuro di voler rimuovere questo invito?",
            "confirmLong": "Una volta eliminato questo invito, l'utente non potrà più unirsi all'organizzazione. Puoi sempre invitarlo di nuovo in seguito.",
            "accept": "Accetta invito",
            "stat": "inviti attivi",
            "noInvites": {
                "title": "Nessun invito.",
                "description": "Sembra che non ci siano inviti attivi per la tua organizzazione."
            },
            "acceptSuccess": {
                "title": "Benvenuti nel team.",
                "description": "Ti sei unito con successo all'organizzazione.",
                "action": "Visualizza la tua nuova organizzazione"
            },
            "acceptError": {
                "title": "Oops. Sembra che ci sia un problema.",
                "description": "Si è verificato un errore durante l'adesione all'organizzazione. Riprova più tardi. Se il problema persiste, contatta l'amministratore della tua organizzazione.",
                "action": "Torna alla homepage"
            },
            "send": {
                "success": "Invito a {{value}} inviato.",
                "error": "Errore durante l'invio dell'invito a {{value}}.",
                "title": "Invia invito"
            },
            "error": "Errore durante il caricamento degli inviti.",
            "orgTitle": "Inviti di {{value}}",
            "editDescription": "Crea un nuovo invito per un utente affinché si unisca alla tua organizzazione."
        },
        "role": {
            "title": "Ruolo",
            "titlePlural": "Ruoli",
            "description": "I ruoli sono i diversi livelli di accesso che un utente può avere nella tua organizzazione. Puoi assegnare ruoli diversi agli utenti per controllare cosa possono fare."
        },
        "isAdmin": {
            "title": "Amministratore",
            "description": "Gli amministratori hanno pieno accesso all'organizzazione e possono gestirne tutti gli aspetti.",
            "conflict": "Questo membro è un amministratore. Non hai l'autorizzazione per modificare i suoi ruoli."
        },
        "canViewMembers": {
            "title": "Visualizza i membri",
            "description": "Gli utenti con questa autorizzazione possono visualizzare tutti i membri dell'organizzazione."
        },
        "canInviteMembers": {
            "title": "Invita i membri",
            "description": "Gli utenti con questa autorizzazione possono invitare nuovi membri all'organizzazione e gestire gli inviti esistenti."
        },
        "canChangeMemberPermissions": {
            "title": "Cambia i ruoli dei membri",
            "description": "Gli utenti con questa autorizzazione possono modificare il ruolo degli altri membri dell'organizzazione."
        },
        "canRemoveMembers": {
            "title": "Rimuovi membri",
            "titleSingle": "Rimuovi membro",
            "action": "Rimuovere",
            "description": "Gli utenti con questa autorizzazione possono rimuovere altri membri dall'organizzazione.",
            "confirm": "Vuoi davvero rimuovere questo membro dall'organizzazione?",
            "confirmLong": "Una volta rimosso questo membro, non avrà più accesso all'organizzazione. Puoi sempre invitarlo di nuovo in seguito."
        },
        "canCreateAuthClients": {
            "title": "Crea progetti",
            "description": "Gli utenti con questa autorizzazione possono creare nuovi client di autenticazione e progetti per l'organizzazione."
        },
        "canManageBilling": {
            "title": "Gestisci la fatturazione",
            "description": "Gli utenti con questa autorizzazione possono gestire le impostazioni di fatturazione per l'organizzazione.",
            "error": "Non hai l'autorizzazione per gestire la fatturazione per questa organizzazione."
        },
        "metrics": {
            "title": "Metrica",
            "description": "Le metriche sono punti dati che ti aiutano a capire come la tua organizzazione utilizza Cephable.",
            "view": "Visualizza le metriche",
            "lineChart": {
                "title": "Connessioni simultanee medie",
                "description": "Questo grafico mostra la media delle connessioni contemporanee per i dati dell'organizzazione e del progetto nel tempo.",
                "max": "Numero massimo di connessioni: {{maxConnections}}",
                "project": "Totale del progetto",
                "org": "Organizzazione Totale"
            },
            "orgTitle": "Metriche di {{value}}",
            "manage": {
                "title": "Metriche delle prestazioni",
                "description": "Scarica o cancella le metriche delle prestazioni raccolte durante l'inferenza del modello."
            },
            "download": {
                "button": "Scarica le metriche",
                "success": "Il file delle metriche è stato salvato nella cartella Download.",
                "error": "Impossibile scaricare il file delle metriche.",
                "noFile": "Nessun file di metriche trovato. Prova prima a eseguire il modello."
            },
            "clear": {
                "button": "Metriche chiare",
                "success": "Le metriche sono state cancellate.",
                "error": "Impossibile cancellare il file delle metriche.",
                "confirm": {
                    "title": "Metriche di prestazione chiare",
                    "description": "Vuoi davvero cancellare tutte le metriche delle prestazioni registrate? Questa azione non può essere annullata.",
                    "cancel": "Cancellare",
                    "confirm": "Metriche chiare"
                }
            }
        },
        "projects": {
            "title": "Progetti",
            "description": "Utilizza Progetti per gestire l'accesso sicuro, configurare le interazioni con i dispositivi e semplificare il modo in cui le tue app inviano e ricevono comandi su diverse piattaforme.",
            "name": "Nome dell'app",
            "view": "Visualizza i progetti",
            "error": "Errore durante il caricamento dei progetti.",
            "stats": {
                "title": "Statistiche del progetto",
                "connections": "Connessioni totali",
                "all": {
                    "title": "Tutte le metriche del progetto",
                    "description": "Metriche aggregate per tutti i progetti associati a {{ orgName }}"
                },
                "card": "progetti su {{value}}",
                "users": "utenti totali da {{date}}",
                "avgUsers": "utenti medi mensili.",
                "concurrent": {
                    "title": "Media delle connessioni contemporanee negli ultimi {{days}} giorni",
                    "label": "Media simultanea",
                    "max": "Numero massimo di connessioni",
                    "overage": "Eccedenza",
                    "description": "Le connessioni simultanee sono il numero di utenti connessi al tuo progetto contemporaneamente. Questa metrica ti aiuta a capire quanti utenti stanno utilizzando la tua app contemporaneamente."
                }
            },
            "projectType": {
                "title": "Tipo di progetto",
                "description": "I tipi di progetto vengono utilizzati per categorizzare i tuoi progetti e aiutarci a scegliere gli SDK più adatti a te."
            },
            "accessDenied": {
                "generic": "Non hai accesso a questo progetto.",
                "title": "Accesso negato.",
                "description": "Non hai accesso per visualizzare, creare, modificare o eliminare progetti. Contatta il tuo amministratore per ottenere l'accesso."
            },
            "upgrade": {
                "title": "Aggiorna a Cephable SDK",
                "description": "Cephable può essere integrato direttamente nella tua app, gioco o servizio usando i nostri SDK. I progetti non sono attualmente disponibili con il tuo account. Se pensi che ci sia un errore, contatta support@cephable.com.",
                "shortDescription": "I progetti non sono attualmente disponibili con il tuo account. Contattaci per effettuare l'upgrade."
            },
            "limit": {
                "title": "Vuoi altri progetti?",
                "error": "Limite del progetto raggiunto.",
                "description": "Hai raggiunto il numero massimo di progetti per la tua organizzazione. Contatta il tuo amministratore per aggiornare il tuo account."
            },
            "create": {
                "title": "Crea progetto",
                "titleLong": "Cominciamo.",
                "first": {
                    "title": "Inizia il tuo progetto.",
                    "description": "Sembra che tu non abbia ancora creato un progetto. Le chiavi client e i dispositivi sono essenziali per proteggere la comunicazione tra le tue applicazioni e i nostri servizi. Con una chiave client, sarai in grado di integrare i controlli vocali e di movimento della testa nelle tue app in modo rapido e sicuro."
                },
                "details": {
                    "title": "Dettagli del progetto",
                    "description": "Crea un nuovo progetto per gestire l'autorizzazione della tua applicazione, le capacità del dispositivo e le integrazioni SDK. Segui i passaggi sottostanti per impostare interazioni sicure e personalizzabili per i tuoi utenti."
                }
            },
            "sdk": {
                "title": "Scarica l'SDK",
                "description": "Accedi al nostro potente SDK sviluppato per semplificare i controlli adattivi.",
                "select": {
                    "title": "Seleziona SDK",
                    "description": "Seleziona l'SDK che desideri utilizzare per questo progetto. I nostri SDK consentono un'integrazione fluida di controlli vocali e di movimento della testa adattivi su diverse piattaforme."
                }
            },
            "clients": {
                "title": "Autorizzazione Clienti",
                "configure": "Configurare il client di autorizzazione",
                "description": "I client di autorizzazione gestiscono l'accesso sicuro per le tue applicazioni. Definisci un client di autorizzazione per autenticare gli utenti e controllare le interazioni con la tua applicazione.",
                "settings": "Impostazioni di autorizzazione",
                "create": "Crea client di autorizzazione",
                "max": "Progetti massimi: {{value}}"
            },
            "secret": {
                "title": "Segreto del cliente",
                "created": "Il tuo segreto client è stato creato.",
                "description": "Il tuo segreto client verrà mostrato solo una volta. Copialo ora e conservalo in un luogo sicuro.<br> <br> Utilizzalo solo per il tuo sviluppo personale. Non condividerlo con servizi o applicazioni di terze parti.",
                "copy": "Copia segreto",
                "rotate": {
                    "title": "Ruota il segreto del cliente",
                    "description": "ATTENZIONE: questa azione revocherà il tuo segreto client esistente e ne creerà uno nuovo. Ciò richiederà di aggiornare tutto il tuo utilizzo esistente attraverso le tue app. Questa azione non può essere annullata.",
                    "error": "Errore durante la rotazione del segreto. Riprova più tardi."
                }
            },
            "key": {
                "title": "Chiave del cliente",
                "view": "Visualizza la chiave del cliente",
                "copy": "Copia chiave",
                "delete": {
                    "title": "Elimina la chiave client",
                    "description": "ATTENZIONE: questa azione rimuoverà la chiave client esistente e tutte le impostazioni correlate. Questa azione non può essere annullata.",
                    "error": "Errore durante l'eliminazione della chiave client.",
                    "success": "Il tuo progetto è stato eliminato."
                }
            },
            "tokenRedirect": {
                "title": "URL di reindirizzamento del token",
                "description": "Gli URL di reindirizzamento token sono gli endpoint in cui vengono inviati i token di accesso dopo il completamento dell'autenticazione. Questi URL consentono alla tua applicazione di ricevere in modo sicuro i token necessari per accedere ai dati e ai servizi utente."
            },
            "authRedirect": {
                "title": "URL di reindirizzamento del codice di autorizzazione",
                "description": "L'URL di reindirizzamento AuthCode è l'endpoint in cui vengono inviati i codici di autorizzazione dopo che un utente concede l'autorizzazione alla tua applicazione. Questo URL è essenziale nei flussi OAuth, poiché garantisce la trasmissione sicura del codice di autorizzazione dal server di autorizzazione alla tua app, consentendoti di richiedere token di accesso per conto dell'utente."
            },
            "scopes": {
                "title": "Ambiti",
                "configure": "Definisci gli ambiti",
                "titleLong": "Ambiti di autorizzazione API",
                "description": "Gli ambiti definiscono i permessi che questo client di autorizzazione avrà. Imposta gli ambiti per limitare l'accesso a dati e funzionalità specifici, assicurando che gli utenti ottengano solo l'accesso di cui hanno bisogno.",
                "manage": "Gestisci gli ambiti di autorizzazione"
            },
            "type": {
                "title": "Tipo di implementazione"
            },
            "deviceScopes": {
                "title": "Tipi di dispositivi associati",
                "titleLong": "Tipi di dispositivi consentiti",
                "configure": "Configurare i tipi di dispositivi consentiti",
                "action": "Aggiungi nuovo tipo di dispositivo",
                "descriptionShort": "Definisci quali tipi di dispositivi possono accedere a questo progetto.",
                "titles": "Tipi di dispositivi associati",
                "description": "Il tipo di dispositivo definisce i permessi e i livelli di accesso che un dispositivo ha all'interno della tua applicazione. Assegnando tipi di dispositivi specifici, puoi controllare le azioni e i dati a cui ogni dispositivo può accedere, assicurandoti che la tua applicazione rimanga sicura e conforme alle tue policy sulla privacy."
            },
            "deviceType": {
                "title": "Tipi di dispositivi",
                "description": "Un DeviceType definisce una categoria di dispositivi, specificandone le capacità di input/output e le funzionalità supportate (ad esempio, voce, gesti, tipi di controller). Garantisce che solo i dispositivi autorizzati possano interagire con un'applicazione.",
                "action": "Crea tipo di dispositivo",
                "name": "Nome del tipo di dispositivo",
                "descriptionLong": "Descrizione del tipo di dispositivo",
                "features": {
                    "title": "Supporta le funzionalità",
                    "description": "Definisci gli input e gli output supportati dalla tua app. Questo ci aiuta a ottimizzare l'esperienza utente su Cephable.",
                    "supportsVoiceInput": "Input vocale",
                    "supportsPhysicalInput": "Ingresso fisico",
                    "supportsKeyboardOutput": "Uscita tastiera",
                    "supportsPlayStationControllerOutput": "Controllore della PlayStation",
                    "supportsFaceInput": "Input facciale",
                    "supportsGestureInput": "Input gestuale",
                    "supportsXboxControllerOutput": "Controllore Xbox",
                    "supportsDigitalExtensions": "Estensioni digitali",
                    "supportsPhysicalExtensions": "Estensioni fisiche",
                    "supportsNintendoControllerOutput": "Controllore Nintendo",
                    "supportsGenericControllerOutput": "Uscita del controller generico"
                },
                "canAutoStart": {
                    "title": "Supporta l'avvio del controllo automatico",
                    "description": "[canAutoStart] se abilitato, gli SDK controlleranno le impostazioni utente e tenteranno di avviare immediatamente i controlli della telecamera o del microfono dopo l'accesso dell'utente."
                },
                "isSupported": {
                    "title": "Attivo",
                    "description": "[isSupported] Se disabilitato, Cephable non invierà, riceverà o riconoscerà più alcun dispositivo utente associato a questo. Equivale a deprecato."
                },
                "locale": {
                    "title": "Lingua predefinita",
                    "description": "[defaultLocale] Le impostazioni locali predefinite per questo tipo di dispositivo. Verranno utilizzate come lingua predefinita per il dispositivo.",
                    "support": "Supporta le lingue",
                    "warn": "** Sembra che tu abbia impostato i Controlli personalizzati. Assicurati di aver aggiornato i controlli personalizzati per le lingue associate.**",
                    "name": "{{lang}} - Nome del tipo di dispositivo",
                    "langDescription": "{{lang}} - Descrizione"
                },
                "customControls": {
                    "title": "Controlli personalizzati",
                    "object": "{{lang}} - Oggetto controlli personalizzati",
                    "description": "I controlli personalizzati sono un'opzione avanzata che consente agli utenti di impostare e modificare manualmente i controlli delle app associati a questo dispositivo. Se desideri che gli utenti controllino il tuo dispositivo direttamente da Cephable, devi registrare i controlli del tuo dispositivo qui. Consulta Cephable API per i dettagli completi sulle opzioni.",
                    "addControl": "Aggiungi controllo",
                    "empty": "Nessun controllo personalizzato disponibile al momento. Utilizza \"Aggiungi controllo\" per crearne il primo.",
                    "untitled": "Controllo senza titolo",
                    "controlId": "ID di controllo",
                    "controlIdHelp": "Identificativo univoco per questo controllo. Impostalo prima di salvare: non potrà essere modificato in seguito.",
                    "fallback": "Ricaderci",
                    "controlName": "Nome di controllo",
                    "controlDescription": "Codice di controllo",
                    "defaultCommandsLabel": "Comandi vocali predefiniti",
                    "defaultCommandsHelp": "Questi sono i comandi vocali predefiniti visualizzati dagli utenti per questo controllo nella lingua corrente.",
                    "sharedAcrossLanguages": "Condiviso in tutte le lingue",
                    "sharedAcrossLanguagesHelp": "La modifica di questi campi aggiorna il valore per tutte le lingue contemporaneamente.",
                    "iconUrl": "URL dell'icona",
                    "contextGroupName": "Gruppo di contesto",
                    "isProfileControl": "Controllo del profilo",
                    "isPrefixVoiceCommand": "Prefisso Comando vocale",
                    "allowWhenDictating": "Consenti durante la dettatura",
                    "allowsHold": "Consente di tenere premuto",
                    "isDeprecated": "Deprecato",
                    "requiresEmployeeAccess": "Richiede l'accesso del dipendente",
                    "requiresStudentAccess": "Richiede l'accesso per studenti",
                    "requiresGenericLicense": "Richiede licenza generica",
                    "requiresPlusAccess": "Richiede l'accesso Plus",
                    "allIncomplete": "Tutte le impostazioni locali presentano controlli personalizzati incompleti. Completare almeno una impostazione locale prima di salvare.",
                    "savedWithIncomplete": "Salvato. Impostazioni locali dei controlli personalizzati incomplete non salvate: {{incompleteLocales}}"
                },
                "success": {
                    "title": "Successo!",
                    "description": "Hai creato un nuovo tipo di dispositivo. {{name}} Ora puoi aggiornare l'ambito del dispositivo client di autorizzazione in base alle tue esigenze."
                },
                "id": "ID tipo dispositivo",
                "throttleRules": {
                    "title": "Regole del comando dell'acceleratore",
                    "description": "Configurare le regole di limitazione per controllare il flusso dei comandi e le restrizioni di input per questo tipo di dispositivo.",
                    "disableVoiceInput": "Disabilita l'input vocale",
                    "disableHotkeyInput": "Disabilita l'input tramite tasti di scelta rapida",
                    "disableCameraInput": "Disabilita l'input della telecamera",
                    "disableMultiInputs": "Disabilitare più input",
                    "maximumCommandsPerSecond": "Comandi massimi al secondo",
                    "maximumCommandsPerMinute": "Comandi massimi al minuto",
                    "maximumMacroLength": "Lunghezza massima della macro",
                    "jitter": {
                        "title": "Jitter temporale",
                        "description": "Aggiungi variazioni casuali alla durata delle pressioni prolungate e delle pause per creare schemi di input più naturali.",
                        "holdTimeJitterMin": "Variazione del tempo di mantenimento Min (ms)",
                        "holdTimeJitterMax": "Variazione massima del tempo di mantenimento (ms)",
                        "pauseTimeJitterMin": "Variazione del tempo di pausa Min (ms)",
                        "pauseTimeJitterMax": "Variazione massima del tempo di pausa (ms)"
                    },
                    "incompatibleActions": {
                        "title": "Gruppi di azione incompatibili",
                        "description": "Definisci gruppi di azioni che non possono coesistere nella stessa macro.",
                        "addGroup": "Aggiungi gruppo",
                        "removeGroup": "Rimuovi gruppo",
                        "addAction": "Aggiungi azione",
                        "removeAction": "Rimuovi azione",
                        "reason": "Motivo",
                        "reasonPlaceholder": "Perché queste azioni sono incompatibili",
                        "eventType": "Tipo di evento",
                        "key": "Chiave",
                        "customActionId": "ID azione personalizzata",
                        "emptyGroup": "Nessuna azione in questo gruppo. Aggiungi almeno due azioni."
                    },
                    "requiredPause": {
                        "title": "Pausa necessaria tra le azioni",
                        "description": "Definisci coppie di azioni che richiedono una pausa minima tra di loro nella stessa macro.",
                        "addRule": "Aggiungi regola",
                        "removeRule": "Rimuovi regola",
                        "actionA": "Azione A",
                        "actionB": "Azione B",
                        "minimumPause": "Pausa minima (ms)",
                        "bidirectional": "Bidirezionale",
                        "bidirectionalHelp": "Quando abilitata, la pausa è necessaria in entrambe le direzioni (A→B e B→A)."
                    },
                    "macroStepRules": {
                        "title": "Regole macro per i passaggi",
                        "holdTimeJitterMin": "Jitter di mantenimento Min (ms)",
                        "holdTimeJitterMax": "Jitter massimo di mantenimento (ms)"
                    }
                }
            },
            "originHost": {
                "title": "Origine Host",
                "description": "L'URL che fungerà da fonte primaria per le richieste e i dati durante le interazioni API."
            },
            "orgTitle": "Progetti di {{value}}"
        },
        "viewOrganization": "Visualizza Organizzazione",
        "update": "La tua organizzazione è stata aggiornata! Aggiornamento dell'app.",
        "error": "Errore durante il caricamento dell'organizzazione. Riprova più tardi.",
        "new": {
            "name": {
                "label": "Nome dell'organizzazione",
                "placeholder": "Inserisci il nome della tua organizzazione"
            },
            "description": {
                "label": "Descrizione dell'organizzazione",
                "placeholder": "Quali sono i tuoi obiettivi con Cephable Professional?"
            },
            "details": "Dettagli dell'organizzazione"
        },
        "expired": {
            "user": "Sembra che la tua licenza Cephable sia scaduta, quindi sei stato declassato alla versione gratuita Cephable Basic. Per rinnovarla, contatta l'amministratore della tua organizzazione.",
            "admin": "Sembra che la tua licenza Cephable sia scaduta, quindi sei stato declassato alla versione gratuita Cephable Basic. Rinnova la licenza per continuare a utilizzare le funzionalità avanzate oltre a Cephable Basic.",
            "multiple": "Sembra che le tue licenze Cephable siano scadute, quindi sei stato declassato alla versione gratuita Cephable Basic. Rinnova almeno una delle tue licenze per continuare a utilizzare le funzionalità avanzate oltre a Cephable Basic.",
            "dialog": {
                "title": "Seleziona un'organizzazione",
                "description": "Hai più organizzazioni associate al tuo account. Seleziona l'organizzazione che desideri rinnovare."
            },
            "title": "La tua licenza Cephable è scaduta",
            "titlePlural": "Le tue licenze Cephable sono scadute",
            "banner": "Sembra che la tua licenza Cephable sia scaduta, quindi sei passato alla versione gratuita Cephable Basic. Rinnovandola, avrai accesso a funzionalità come controlli vocali avanzati, attività intelligenti basate sull'intelligenza artificiale e molti controlli predefiniti per le app."
        },
        "orgName": "Nome dell'organizzazione",
        "menu": {
            "title": "Menu Organizzazione",
            "view": "Visualizza il menu",
            "expand": "Espandi Menu"
        },
        "settings": {
            "title": "Impostazioni dell'organizzazione",
            "description": "Gestisci la fatturazione, il nome, la descrizione e le risorse della tua organizzazione.",
            "view": "Visualizza impostazioni",
            "general": {
                "title": "Generale"
            },
            "resources": {
                "edit": "Modifica risorse",
                "description": "Utilizza l'editor Markdown sulla sinistra per aggiornare e formattare risorse utili per tutti i membri dell'organizzazione. Mentre digiti, l'anteprima sulla destra mostrerà come il tuo contenuto apparirà agli utenti. Puoi aggiungere titoli, elenchi, link e altri elementi di formattazione utilizzando la sintassi Markdown. Le modifiche saranno visibili ai membri una volta salvate."
            },
            "other": {
                "title": "Altre impostazioni",
                "description": "Gestisci la fatturazione, il nome, la descrizione e le risorse della tua organizzazione."
            }
        },
        "managed": {
            "title": "Organizzazione gestita",
            "titlePlural": "Organizzazioni gestite",
            "description": "Le organizzazioni gestite sono organizzazioni gestite da un rivenditore Cephable. I rivenditori possono gestire il tuo team, i profili del team, la fatturazione e altro qui.",
            "error": "Errore durante il caricamento delle organizzazioni gestite.",
            "empty": {
                "title": "Nessuna organizzazione gestita trovata.",
                "description": "Sembra che non ci siano organizzazioni gestite che corrispondono a questo criterio. Oppure le tue chiavi di licenza non sono ancora state attivate."
            },
            "titleShort": "Gestito"
        },
        "canManageChildOrganizations": {
            "title": "Gestire le organizzazioni secondarie",
            "description": "Gli utenti con questa autorizzazione possono creare e gestire organizzazioni figlio come amministratori."
        },
        "canViewAnalytics": {
            "title": "Visualizza analisi",
            "description": "Gli utenti con questa autorizzazione possono visualizzare le metriche e le analisi per l'organizzazione."
        },
        "create": "Crea nuova organizzazione",
        "orgCustomBillingUrl": {
            "title": "URL di fatturazione personalizzato",
            "description": "Questo è un URL personalizzato che verrà utilizzato per reindirizzare l'utente al tuo sistema di fatturazione (del rivenditore). Dovrebbe iniziare con 'https://' o 'mailTo:'"
        },
        "upgrade": {
            "existing": {
                "title": "Fai parte di una licenza esistente.",
                "description": "Per effettuare l'aggiornamento, clicca su `{{action}}` nel menu laterale."
            }
        },
        "restrictions": {
            "isGenAIDisabled": {
                "title": "AI generativa disabilitata",
                "description": "La tua organizzazione ha disabilitato l'accesso alle funzionalità di IA generativa. Contatta l'amministratore della tua organizzazione per ulteriori informazioni."
            },
            "isRemoteControlDisabled": {
                "title": "Sincronizzazione tra dispositivi disabilitata",
                "description": "La tua organizzazione ha disabilitato l'accesso alla sincronizzazione. Non potrai utilizzare la nostra app complementare né controllare dispositivi esterni. Contatta l'amministratore della tua organizzazione per ulteriori informazioni."
            }
        },
        "troubleshooting": {
            "title": "Risoluzione dei problemi",
            "editorDescription": "[Facoltativo] Questa è una sezione visibile a tutti gli utenti tramite la pagina dei dettagli della connessione sia nell'app mobile che in quella desktop di Cephable.",
            "description": "Se riscontri problemi con Cephable, prova a seguire i passaggi indicati di seguito per risolvere i problemi più comuni."
        },
        "onboarding": {
            "title": "Onboarding",
            "editorDescription": "[Facoltativo] L'onboarding viene visualizzato agli utenti quando questo tipo di dispositivo viene aggiunto al loro account. Questa è un'ottima opportunità per fornire istruzioni su come configurare e utilizzare il tipo di dispositivo con la tua applicazione."
        },
        "documents": "Documenti",
        "completionStatus": {
            "title": "Stato di completamento",
            "error": "",
            "complete": "Completare.",
            "incomplete": "Incompleto."
        },
        "metadata": {
            "title": "Metadati",
            "urlError": "L'URL deve iniziare con http:// o https://",
            "metatitle": {
                "label": "Meta titolo",
                "placeholder": "Inserisci un titolo breve"
            },
            "shortDescription": {
                "label": "Breve descrizione",
                "placeholder": "Inserisci una breve descrizione di anteprima (max 150 caratteri)"
            },
            "externalLink": {
                "label": "URL del collegamento esterno",
                "placeholder": "https://example.com/device-info",
                "description": "Un collegamento diretto a un sito web o a una risorsa esterna che fornisce maggiori informazioni sulla prima configurazione del dispositivo. Se lo utilizzi, non applicheremo il ribasso dell'elenco clienti."
            },
            "iconUrl": {
                "label": "URL dell'icona del dispositivo",
                "placeholder": "https://example.com/device-icon.png",
                "description": "Un collegamento diretto a un'immagine che rappresenta questo tipo di dispositivo. Questa icona verrà visualizzata nell'app Cephable e negli elenchi dei dispositivi."
            },
            "darkModeIconUrl": {
                "label": "URL dell'icona del dispositivo in modalità scura",
                "placeholder": "https://example.com/device-icon-dark.png",
                "description": "Un collegamento diretto a un'immagine che rappresenta questo tipo di dispositivo in modalità scura. Questa icona verrà visualizzata nell'app Cephable e negli elenchi dei dispositivi quando l'utente ha attivato la modalità scura."
            },
            "editorDescription": "Quando il tuo dispositivo viene selezionato per essere inserito nell'app Cephable come estensione o connessione, utilizziamo queste informazioni per mostrarle agli utenti che configurano nuove connessioni."
        },
        "client-listing": {
            "title": "Elenco clienti",
            "editorDescription": "Istruzioni dettagliate per i nuovi utenti su come configurare nuove connessioni con questo tipo di dispositivo. Questo contenuto di markdown verrà visualizzato nell'app Cephable quando gli utenti aggiungono una nuova connessione."
        },
        "canAccessOrganizationProfiles": {
            "title": "Visualizza i controlli dell'app Organizzazione",
            "description": "Gli utenti con questa autorizzazione possono visualizzare i controlli delle app dell'organizzazione associati a questa organizzazione."
        },
        "canEditOrganizationProfiles": {
            "title": "Gestisci i controlli delle app dell'organizzazione",
            "description": "Gli utenti con questa autorizzazione possono creare, modificare ed eliminare i controlli delle app dell'organizzazione associati a questa organizzazione."
        },
        "profiles": {
            "title": "Controlli dell'app dell'organizzazione",
            "description": "I controlli app dell'organizzazione sono profili condivisi per distribuire i controlli app all'interno dell'organizzazione o per condividerli con gli utenti dell'integrazione.",
            "view": "Visualizza i controlli dell'app Organizzazione",
            "editDescription": "Modifica i controlli dell'app dell'organizzazione per personalizzare le impostazioni.",
            "empty": "Nessun controllo dell'app dell'organizzazione trovato. Creane uno per iniziare.",
            "error": "Errore durante il caricamento dei controlli dell'app dell'organizzazione.",
            "titleShort": "Controlli dell'app"
        },
        "canViewAuthClients": {
            "title": "Visualizza i progetti",
            "description": "Gli utenti con questa autorizzazione possono visualizzare i client e i progetti autenticati per l'organizzazione."
        },
        "governance": {
            "title": "Governance",
            "orgTitle": "Governance del valore",
            "description": "Definisci le linee guida che regolano l'utilizzo dell'assistente Cephable da parte del tuo team.",
            "automation": {
                "title": "Regole di automazione",
                "description": "Controlla dove Cephable può automatizzare e fornisci istruzioni che ne modellano il comportamento per la tua organizzazione.",
                "rulesTitle": "Regole",
                "create": "Crea regola di automazione",
                "edit": "Modifica regola di automazione",
                "created": "Regola di automazione creata.",
                "updated": "Regola di automazione aggiornata.",
                "deleted": "Regola di automazione eliminata.",
                "loadError": "Impossibile caricare le regole di automazione.",
                "saveError": "Impossibile salvare la regola di automazione.",
                "deleteError": "Impossibile eliminare la regola di automazione.",
                "searchPlaceholder": "Regole di ricerca per app, sito web, richiesta o ambito",
                "promptOnly": "Istruzioni per l'assistente",
                "editorDescription": "Scegli il tipo di regola, eventualmente seleziona come destinazione un'app o un sito web e aggiungi istruzioni chiare per Cephable.",
                "validation": "Aggiungi un'app o un sito web, istruzioni per l'assistente vocale o entrambi.",
                "appOrDomain": {
                    "label": "App o sito web",
                    "helper": "Utilizza un nome di app o un dominio riconoscibile, come Slack, gmail.com o github.com."
                },
                "prompt": {
                    "label": "Istruzioni per l'assistente",
                    "helper": "Descrivi cosa Cephable dovrebbe o non dovrebbe fare. Assicurati che le istruzioni siano specifiche e attuabili."
                },
                "type": {
                    "label": "Tipo di regola",
                    "block": "Bloccare",
                    "allow": "Permettere"
                },
                "scope": {
                    "organization": "A livello di organizzazione",
                    "organizationDescription": "Applica questa regola a tutti i membri, attuali e futuri.",
                    "members": "Membri specifici",
                    "membersDescription": "Salva la regola, quindi assegnala solo ai membri che ne hanno bisogno."
                },
                "assign": "Assegnare i membri",
                "delete": {
                    "title": "Eliminare la regola di automazione?",
                    "description": "Questa operazione rimuove definitivamente la regola e tutte le assegnazioni ai membri che la utilizzano."
                },
                "empty": {
                    "title": "Nessuna regola di automazione ancora",
                    "description": "Crea una regola per definire i parametri di riferimento per il primo assistente della tua organizzazione."
                },
                "guidance": {
                    "block": {
                        "title": "Limita app e siti web",
                        "description": "Utilizza una regola di blocco con il nome dell'app o il dominio per impedire a Cephable di interagire con essa."
                    },
                    "prompt": {
                        "title": "Aggiungi il contesto dell'assistente",
                        "description": "Utilizzare le istruzioni dell'assistente per comunicare le politiche, i controlli richiesti o le modalità di lavoro sicure."
                    },
                    "scope": {
                        "title": "Scegliere l'ambito appropriato",
                        "description": "Applicare linee guida condivise a tutta l'organizzazione, oppure limitare le eccezioni a membri selezionati."
                    }
                },
                "assignment": {
                    "title": "Assegna la regola a un membro",
                    "description": "Gestisci l'assegnazione specifica del membro per {{value}}.",
                    "memberLabel": "Membro",
                    "apply": "Applica la regola",
                    "remove": "Rimuovi la regola",
                    "assigned": "Questa regola è assegnata al membro selezionato.",
                    "notAssigned": "Questa regola non è assegnata al membro selezionato.",
                    "applied": "Regola applicata al membro.",
                    "removed": "Regola rimossa per il membro.",
                    "loadError": "Impossibile caricare i membri dell'organizzazione.",
                    "statusError": "Impossibile caricare le regole di automazione di questo membro.",
                    "saveError": "Impossibile aggiornare l'assegnazione del membro."
                }
            },
            "moreControls": {
                "title": "Sono in arrivo ulteriori controlli di governance.",
                "description": "Questo hub si espanderà con controlli per le funzionalità che il tuo team potrà utilizzare e per i provider a cui potrà connettersi.",
                "skills": "Competenze",
                "mcp": "Strumenti MCP",
                "ai": "Porta la tua IA"
            }
        },
        "canManageGlobalAutomationRules": {
            "title": "Gestire la governance",
            "description": "Gli utenti con questa autorizzazione possono gestire le regole di automazione dell'organizzazione e le assegnazioni dei membri."
        }
    },
    "developer": {
        "title": "Sviluppatore",
        "titleLong": "Risorse per sviluppatori",
        "description": "Cephable può essere integrato direttamente nella tua app, gioco o servizio utilizzando i nostri SDK.",
        "sdk": {
            "title": "Esplora i nostri SDK",
            "description": "Forniamo SDK di prima classe progettati per integrare senza problemi il riconoscimento vocale e i controlli adattivi nelle tue applicazioni. I nostri strumenti sono realizzati per migliorare l'interazione dell'utente tramite controlli intuitivi e per promuovere l'accessibilità, assicurando che il tuo software possa essere utilizzato in modo più efficace da tutti gli utenti.",
            "javascript": {
                "title": "Javascript",
                "subtitle": "Sito web",
                "description": "Integra i controlli vocali e adattivi direttamente nelle tue applicazioni web.",
                "action": "Ottieni il Pacchetto NPM"
            },
            "net": {
                "title": ".NET",
                "subtitle": "Applicazioni Windows",
                "description": "Sfrutta la potenza di .NET per creare applicazioni con i nostri SDK WPF e WinUI3.",
                "actionCore": "Ottieni il Pacchetto Core",
                "actionWpf": "Ottieni il Pacchetto WPF"
            },
            "android": {
                "title": "Android",
                "subtitle": "Dispositivi mobili",
                "description": "Applicazioni Android progettate per facilitare le capacità vocali e di movimento della testa.",
                "action": "Ottieni Android SDK"
            },
            "more": {
                "title": "Di più",
                "description": "Non trovi quello che ti serve? Contattaci e ti aiuteremo.",
                "action": "Richiedi un SDK"
            },
            "docs": {
                "title": "Documentazione",
                "description": "Esplora la documentazione dettagliata, i progetti di esempio e le guide per iniziare a sviluppare con Cephable.",
                "action": "Visualizza documenti"
            }
        },
        "demo": {
            "title": "Dimostrazioni",
            "titleLong": "Prova i nostri SDK in azione",
            "description": "Scopri la potenza delle nostre tecnologie di controllo vocale e dei movimenti della testa attraverso le nostre applicazioni campione. Dai giochi interattivi alle app dinamiche per dispositivi mobili e web, ogni esempio dimostra la versatilità e l'efficacia dei nostri SDK. Esplora questi esempi per ottenere spunti e ispirazione per integrare accessibilità avanzata ed esperienze immersive nei tuoi progetti.",
            "game": {
                "title": "Gioco 2048",
                "subtitle": "Sito web",
                "description": "Migliora il gameplay tradizionale con controlli vocali e movimenti della testa adattivi.",
                "action": "Gioca al gioco"
            },
            "unity": {
                "title": "Unità",
                "subtitle": "Sviluppo del gioco",
                "description": "Scopri come i controlli adattivi possono essere sfruttati nei giochi per offrire un'esperienza utente più coinvolgente.",
                "action": "Ottieni il campione"
            },
            "samples": "Documenti ed esempi",
            "other": {
                "title": "Altre demo",
                "description": "Scopri in prima persona come Cephable può migliorare la tua applicazione, il tuo gioco o il tuo dispositivo.",
                "action": "Visualizza altre demo"
            },
            "web": {
                "title": "Esempi di Web SDK",
                "subtitle": "Sito web",
                "description": "Integrazione semplice di tutte le nostre funzionalità principali nelle applicazioni web.",
                "action": "Prova l'SDK"
            },
            "docs": {
                "title": "Documentazione per sviluppatori ed esempi",
                "description": "Esplora la documentazione dettagliata, i progetti di esempio e le guide per iniziare a sviluppare con Cephable.",
                "action": "Visualizza documenti"
            }
        },
        "other": {
            "title": "Altre risorse",
            "description": "Se non trovi ciò di cui hai bisogno nei nostri SDK, prova a lavorare direttamente con le nostre API o contatta la community per ricevere aiuto, ispirazione e supporto.",
            "api": {
                "title": "API",
                "description": "Le nostre API ti consentono di interagire direttamente con Cephable. Puoi usare le nostre API per creare integrazioni personalizzate."
            },
            "support": {
                "title": "Supporto",
                "description": "Non trovi ciò di cui hai bisogno? Contatta la nostra community tramite Discord.",
                "action": "Unisciti a Discord"
            }
        }
    },
    "customControls": {
        "title": "Controlli globali e del dispositivo",
        "prefixDisclaimer": "Questo è un controllo del prefisso: ascolterà le parole dopo il comando e poi cercherà le corrispondenze nella frase seguente.",
        "allowPausedDisclaimer": "Questo controllo funziona anche quando il microfono è in pausa.",
        "resetControls": {
            "title": "Ripristina controlli",
            "description": "La lingua della tua voce è cambiata dall'ultima volta che hai aggiornato i tuoi controlli. Nota: questo reimposterà i tuoi controlli in modo che corrispondano a {{language}} e potresti perdere tutti i comandi personalizzati. Vuoi davvero reimpostare?",
            "confirm": "Sì, ripristina i controlli",
            "error": "Si è verificato un errore durante la reimpostazione dei controlli. Riprova più tardi."
        },
        "conflictIndicators": {
            "warn": "Avvertimento: ",
            "title": "Rilevati conflitti nella configurazione di input",
            "globalControls": "Conflitti di configurazione del controllo globale",
            "deviceControls": "Conflitti di configurazione del controllo del dispositivo",
            "usedInput": "viene utilizzato come input per",
            "description": "Alcuni degli input per i controlli globali e dispositivo che stai utilizzando sono utilizzati anche in uno o più controlli app. Ciò potrebbe causare conflitti quando si utilizza Cephable. Quando ciò accade, daremo sempre la preferenza al controllo app rispetto al controllo globale o dispositivo.",
            "item": "L&#39;input <strong>{{value}}</strong> viene utilizzato nei controlli dell&#39;app: ",
            "globalDescription": "I seguenti controlli globali presentano input in conflitto con i controlli dell'app.",
            "deviceDescription": "I seguenti controlli del dispositivo presentano input in conflitto con i controlli dell'app."
        },
        "globalControls": {
            "title": "Controlli globali",
            "empty": "Non hai ancora controlli globali. Clicca qui sotto per crearne uno.",
            "edit": "Modifica controlli globali",
            "description": "I controlli globali sono controlli sempre disponibili, indipendentemente dai controlli dell'app o dal dispositivo che stai utilizzando. Alcuni funzionano anche quando i controlli del microfono o della fotocamera sono in pausa."
        },
        "deviceControls": {
            "title": "Controlli del dispositivo",
            "empty": "Non hai ancora controlli dispositivo. Fai clic qui sotto per crearne uno.",
            "edit": "Modifica controlli dispositivo",
            "controls": {
                "cephable-open-app": {
                    "success": "Apri app: {{value}}",
                    "error": "Impossibile trovare l'app: {{value}}"
                },
                "cephable-close-app": {
                    "commands": ["vicino"],
                    "name": "Chiudi l'app per nome",
                    "description": "Utilizza questo comando con i comandi vocali per chiudere un'app sul tuo computer in base al nome.",
                    "success": "Chiudi app: {{value}}",
                    "error": "Impossibile trovare l'app: {{value}}"
                },
                "cephable-minimize-focused-app": {
                    "commands": ["minimizzare"],
                    "name": "Riduce a icona l'app attualmente in evidenza.",
                    "description": "Utilizzare questo comando con i comandi vocali per ridurre a icona l'app attualmente in evidenza.",
                    "success": "Riduci al minimo il successo delle app mirate!",
                    "error": "Errore durante la riduzione a icona dell'app selezionata."
                },
                "cephable-maximize-focused-app": {
                    "commands": ["massimizzare"],
                    "name": "Massimizza l'app attualmente in evidenza.",
                    "description": "Utilizza questo comando con i comandi vocali per mettere a fuoco al massimo l'app corrente.",
                    "success": "Massimizza il successo della tua app mirata!",
                    "error": "Errore durante la riduzione a icona dell'app selezionata."
                },
                "cephable-generate-text": {
                    "commands": ["generare"],
                    "name": "Generare il testo fornendo il prompt che segue questo comando.",
                    "description": "Utilizza questo comando con i comandi vocali seguito dal tuo prompt per generare del testo correlato."
                },
                "cephable-stop-generate-text": {
                    "commands": [
                        "interrompere la generazione",
                        "interrompere la generazione",
                        "annulla genera",
                        "annullare la generazione"
                    ],
                    "name": "Interrompere la generazione del testo.",
                    "description": "Utilizzare questo comando con i controlli vocali per interrompere la generazione di testo"
                },
                "cephable-open-panel": {
                    "commands": ["mostra pannello"],
                    "name": "Aprire il pannello Cephable",
                    "description": "Utilizzare questo comando con i comandi vocali per aprire il pannello Cephable."
                },
                "cephable-close-panel": {
                    "commands": ["nascondi pannello"],
                    "name": "Nascondi il pannello Cephable",
                    "description": "Utilizzare questo comando con i comandi vocali per nascondere o ridurre a icona il pannello Cephable."
                },
                "cephable-close-focused-app": {
                    "commands": ["corrente di chiusura"],
                    "name": "Chiude l'app attualmente in evidenza.",
                    "description": "Utilizzare questo comando con i comandi vocali per chiudere l'app attualmente in focus.",
                    "success": "Chiusura dell'app corrente riuscita!",
                    "error": "Errore durante la chiusura dell'app corrente."
                },
                "cephable-rewrite-text": {
                    "commands": ["riscrivere"],
                    "name": "Riscrivi il testo fornendo il prompt che segue questo comando.",
                    "description": "Utilizza questo comando con i comandi vocali seguito dal prompt per riscrivere il testo attualmente evidenziato."
                },
                "cephable-summarize-text": {
                    "commands": ["riassumere"],
                    "name": "Riassumere il testo fornendo il prompt che segue questo comando.",
                    "description": "Utilizza questo comando con i comandi vocali seguito dal prompt per riassumere il testo attualmente evidenziato."
                },
                "cephable-translate-text": {
                    "commands": ["tradurre"],
                    "name": "Traduci il testo fornendo il prompt che segue questo comando.",
                    "description": "Utilizza questo comando con i comandi vocali seguito dalla tua richiesta per tradurre il testo attualmente evidenziato."
                },
                "cephable-click-by-name": {
                    "commands": ["rubinetto", "colpo", "navigare verso", "andare a"],
                    "name": "Tocca l'elemento per nome",
                    "description": "Tocca un elemento sulla pagina in base al suo nome, ad esempio \"tocca salva\", per fare clic su un pulsante denominato \"salva\". Questo è equivalente al mouse vocale, che permette di cliccare sugli elementi tramite comandi vocali anziché utilizzando il mouse."
                },
                "cephable-automate": {
                    "commands": [
                        "automatizzare",
                        "provare a",
                        "avere cefabile",
                        "eseguire un flusso di lavoro per",
                        "lavorare su"
                    ],
                    "name": "Avvia un flusso di lavoro AI descrivendo un'attività dopo questo comando.",
                    "description": "Utilizza questo comando con i comandi vocali seguito da un'attività, come \"automatizza l'invio di un'email al mio team\", e Cephable la eseguirà come un flusso di lavoro basato sull'intelligenza artificiale."
                }
            },
            "description": "I controlli dispositivo sono legati al dispositivo o alla connessione specifici che stai utilizzando. Sono disponibili senza bisogno di aggiungerli ai controlli dell'app e sono particolarmente utili per funzionalità o eventi supportati solo su determinati dispositivi."
        },
        "warn": "Il microfono non è stato avviato. Devi avviare il microfono per usare i controlli globali e del dispositivo.",
        "changeProfile": {
            "success": "Cambia i controlli dell'app: {{value}}",
            "error": "Impossibile trovare i controlli dell'app: '{{value}}'"
        },
        "descriptionShort": "I controlli globali e dei dispositivi sono azioni sempre disponibili, progettate per funzionare su qualsiasi software. I controlli globali, come \"Interrompi fotocamera\", sono a livello di sistema e indipendenti dall'app, mentre i controlli dei dispositivi sono personalizzati per ogni connessione e sbloccano funzionalità più avanzate rispetto ai controlli delle app standard.",
        "description": "I controlli globali e dei dispositivi sono azioni sempre disponibili, progettate per funzionare su qualsiasi software. I controlli globali, come \"Interrompi fotocamera\", sono a livello di sistema e indipendenti dall'app, mentre i controlli dei dispositivi sono personalizzati in base alla connessione di ciascun dispositivo e sbloccano funzionalità più avanzate rispetto ai controlli delle app standard. Attualmente, questi controlli sono accessibili tramite comandi vocali, ma in futuro aggiungeremo il supporto per altri input.",
        "noDevice": "Questo passaggio utilizza un'estensione personalizzata che non hai configurato per il tuo account. Aggiungi l'estensione per sbloccare questo passaggio."
    },
    "notifications": {
        "title": "Notifiche",
        "center": "Centro notifiche",
        "empty": "Al momento non hai notifiche. Controlla di nuovo un'altra volta.",
        "seen": "Visto",
        "markAsRead": "Segna come letto",
        "view": "Visualizza tutte le notifiche {{value}}"
    },
    "unsaved": {
        "title": "Ci sono modifiche non salvate.",
        "description": "Hai modifiche non salvate. Vuoi davvero uscire da questa pagina?",
        "cancel": "Esci senza salvare",
        "confirm": "Salva ed esci"
    },
    "login": {
        "welcome": "Benvenuti a Cephable!",
        "subtitle": "Controlla la tua tecnologia alle <strong>tue</strong> condizioni.",
        "create": "Creare un account",
        "signIn": "Registrazione",
        "loading": "Reindirizzamento per l'accesso...",
        "error": "Si è verificato un errore durante l'accesso. Accedi di nuovo.",
        "existingAccount": "Hai già un account?",
        "description": "Controlla. Crea. Automatizza. Cephable: la tua IA personale per comandi rapidi, bozze contestualizzate e flussi di lavoro automatizzati. Nessun elaborazione cloud. Solo un'assistenza impeccabile che ti segue ovunque."
    },
    "home": {
        "title": "Casa",
        "startControls": "Accendilo!",
        "manage": "Configurare",
        "profileGenerate": {
            "title": "Oops. Sembra che non hai ancora alcun controllo app.",
            "description": "Affinché Cephable possa controllare il tuo computer, dobbiamo sapere cosa vuoi controllare. Puoi creare controlli app da zero o farti aiutare a crearne uno usando il nostro generatore di controlli."
        }
    },
    "wizard": {
        "description": "Cephable utilizzerà quindi queste informazioni per generare controlli che potrai esaminare e provare!",
        "includeDefaultKeysQuestion": "Includere comandi vocali predefiniti per i tasti e i clic del mouse?",
        "placeholderAppName": "Microsoft Word, Minecraft, YouTube, Codice, ecc.",
        "noOptionsText": "Inizia a digitare per trovare un'app che desideri controllare",
        "generate": "Genera controlli",
        "complete": {
            "title": "Bene, abbiamo finito!",
            "description": "Fai clic sul pulsante qui sotto per visualizzare i controlli che abbiamo generato. Sarai in grado di modificare manualmente, aggiungere o rimuovere qualsiasi aspetto per perfezionarlo per te stesso.",
            "viewControls": "Guarda i miei controlli"
        },
        "error": {
            "emptyInput": "Seleziona almeno un metodo di input",
            "emptyApp": "Inserisci almeno un nome di app",
            "generatingProfile": "Errore durante la generazione dei controlli dell'app"
        },
        "loading": {
            "title": "Stiamo mettendo insieme tutti i pezzi",
            "description": "Questo può richiedere fino a circa un minuto. Non lasciare questa pagina o tornare indietro, altrimenti smetterà di generare."
        },
        "selectedTips": {
            "title": "Suggerimento n. {{count}}",
            "previous": "Suggerimento precedente",
            "next": "Suggerimento successivo",
            "two": "Puoi controllare la sensibilità dei tuoi input nella sezione \"Expression Control Settings\" del pannello principale. Questo ti consente di perfezionare ulteriormente i modi in cui Cephable interpreta gli input specifici per te. E Cephable migliora nel tempo man mano che lavora con te!",
            "three": "Dopo averlo impostato, hai ancora il controllo completo sulla configurazione. Ti diamo una baseline, ma in qualsiasi momento puoi cambiare la mappatura tra ciò che fai e ciò che fa sul computer.",
            "four": "Puoi stampare i tuoi controlli per averne una copia fisica mentre usi Cephable. Sappiamo che è tutto nuovo e ci vuole un po' per abituarsi. La pratica rende migliori!",
            "one": "Sapevi che puoi usare Cephable su un dispositivo per controllarne un altro? Scarica Cephable sul tuo cellulare, tablet o anche su un altro computer e scegli la connessione che desideri controllare (magari questa). I tuoi profili personali e di input saranno identici su tutti! Assicurati solo che Cephable sia in esecuzione sul tuo dispositivo e sulle tue connessioni."
        },
        "steps": {
            "one": "Passaggio 1. Digita il nome dell'app che desideri controllare.",
            "two": "Passaggio 2. Conferma i controlli di input che desideri utilizzare:",
            "three": "Passaggio 3. (facoltativo)",
            "threeContinued": "Descrivi le azioni specifiche che vorresti impostare per i comandi che usi comunemente o per i quali hai una forte preferenza. Per favore usa un inglese semplice come quelli sottostanti"
        },
        "title": "Genera controlli app",
        "titleLong": "Generare un controllo app",
        "try": "Prova il generatore di controllo",
        "placeholder": "Assicurati che i comandi vocali siano brevi.\n\nVoglio poter dire \"avanti\" per passare alla diapositiva successiva della presentazione.\n\nVoglio usare il movimento della testa per spostare il cursore e i comandi vocali per modificare le scorciatoie.\n\nAggiungi pulsanti di azione rapida per tutti i movimenti e le abilità dei miei personaggi."
    },
    "macros": {
        "title": "Controllare",
        "titlePlural": "Controlli",
        "description": "I controlli contengono un input (un'azione che fai come inclinare la testa) e i passaggi che Cephable eseguirà dopo che l'azione di input è stata registrata. Puoi usare i controlli per creare una combinazione di passaggi che vengono attivati da un singolo input.",
        "new": "Crea un nuovo controllo",
        "newDescription": "Crea un nuovo controllo per combinare più passaggi e input.",
        "add": "Aggiungi controllo",
        "create": "Crea un controllo",
        "name": {
            "title": "Nome del controllo",
            "question": "Come vuoi chiamare questo controllo?",
            "description": "Assegna un nome al tuo controllo, così potrai ritrovarlo facilmente in seguito.",
            "placeholder": "azione che questo controllo sta eseguendo come \"saltare\" o \"ingrandire\""
        },
        "empty": "Non hai ancora alcun controllo. Clicca qui sotto per crearne uno.",
        "copySuffix": "{{name}}_copia"
    },
    "event": {
        "title": "Fare un passo",
        "titlePlural": "Passi",
        "previewSummaryPlural": "{{first}} e {{total}} altri eventi",
        "add": "Aggiungi passaggio",
        "stepType": "Tipo di passo",
        "select": "Seleziona il tipo di passaggio che desideri aggiungere.",
        "question": "Che tipo di azioni vuoi che Cephable esegua?",
        "setup": "Configura il tuo Step",
        "description": "I passaggi sono le azioni che Cephable eseguirà dopo che l'input è stato attivato. È possibile aggiungere più passaggi a un controllo per creare una combinazione di azioni.",
        "expand": "Espandi per vedere il resto dei passaggi",
        "stepUp": "Sposta il passo avanti",
        "stepDown": "Spostare il passo verso il basso",
        "stepCopy": "Copia passaggio",
        "stepRemove": "Rimuovi passaggio",
        "insertStep": "Inserisci il passaggio qui sotto",
        "showOptions": "Mostra opzioni",
        "hideOptions": "Nascondi opzioni",
        "hold": "Tempo di attesa (in millisecondi)",
        "error": "Devi configurare il tuo passaggio.",
        "multiple": "Passaggi multipli",
        "deviceTypeCustomAction": {
            "title": "Azione dispositivo personalizzata"
        },
        "keyPress": {
            "title": "Premere il tasto o il pulsante",
            "short": "Premere",
            "fieldSet": "Tasti o pulsanti da premere",
            "label": "Tasto o pulsante",
            "holdTime": "Tempo di mantenimento del tasto (in millisecondi)",
            "description": "Premere un tasto della tastiera senza utilizzare la tastiera.",
            "longDescription": "Questa funzione simula la pressione di un tasto sulla tastiera. Ad esempio, se hai difficoltà a premere i tasti fisici, puoi usare un comando vocale o un altro metodo di input per \"premere\" virtualmente un tasto.",
            "example": "Pronuncia \"Invio\" per inviare un'e-mail senza premere fisicamente il tasto Invio.",
            "timing": "Tempo di pressione dei tasti",
            "tap": "Rubinetto",
            "tapLong": "Pulsante Tocca",
            "latch": "Fermo",
            "latchLong": "Tenere premuto fino al rilascio",
            "hold": "Presa",
            "holdLong": "Tenere premuto per un certo periodo di tempo",
            "toggle": "Attiva/disattiva",
            "toggleLong": "Attiva/disattiva azione",
            "release": "Rilascia",
            "releaseLong": "Rilascia azione",
            "latchLabel": "Tieni premuto <strong>{{value}}</strong> finché non viene rilasciato",
            "tapLabel": "Tocca <strong>{{value}}</strong>",
            "pressLabel": "Premi <strong>{{value}}</strong> per <strong>{{time}}</strong> millisecondi",
            "remove": "Rimuovi pressione tasto",
            "add": "Aggiungi tasto/pulsante da premere"
        },
        "keyRelease": {
            "title": "Rilasciare la chiave o il pulsante",
            "short": "Pubblicazione",
            "selected": "Chiavi selezionate per il rilascio",
            "description": "Rilascia un tasto della tastiera che hai tenuto premuto.",
            "longDescription": "Questa funzione simula il rilascio di un tasto sulla tastiera. Dovrebbe essere utilizzata insieme a una pressione di tasto mantenuta indefinitamente. Ad esempio, se hai difficoltà a premere tasti fisici, puoi usare un comando vocale o un altro metodo di input per \"rilasciare\" virtualmente un tasto.",
            "example": "Per interrompere la corsa, pronunciare \"Stop\" dopo aver detto \"Attiva/disattiva esecuzione\".",
            "label": "Rilascia <strong>{{value}}</strong>",
            "add": "Aggiungi chiave/pulsante per rilasciare",
            "remove": "Rimuovi rilascio chiave"
        },
        "keyToggle": {
            "title": "Tasto o pulsante di attivazione/disattivazione",
            "short": "Attiva/disattiva",
            "selected": "Tasti selezionati per attivare/disattivare",
            "description": "Con un solo comando puoi accendere o spegnere un tasto della tastiera come se fosse un interruttore della luce.",
            "longDescription": "Questo attiva o disattiva la funzione di un tasto, come un interruttore. È utile per i tasti che vuoi tenere premuti per un periodo di tempo indeterminato. Puoi usarlo per mantenere la stessa azione sia per la pressione del tasto che per il rilascio o l'arresto del tasto.",
            "example": "Pronuncia \"Toggle Run\" per iniziare a correre. Pronuncia \"Toggle Run\" per smettere di correre.",
            "label": "Attiva/disattiva <strong>{{value}}</strong>",
            "add": "Aggiungi tasto/pulsante per attivare/disattivare",
            "remove": "Rimuovi tasto di attivazione/disattivazione"
        },
        "pause": {
            "title": "Pausa",
            "description": "Aggiungere un breve ritardo tra le azioni.",
            "longDescription": "Questa funzione consente di inserire un breve ritardo tra le azioni, essenziale in situazioni in cui un'azione deve essere completata completamente prima che inizi la successiva. Ad esempio, se si utilizza un comando per rendere il testo in grassetto in un documento, potrebbe essere necessario aprire prima un menu contestuale. La funzione Pausa concede abbastanza tempo all'apertura e all'attivazione del menu contestuale prima di procedere al passaggio successivo, assicurando un funzionamento fluido e senza errori.",
            "example": "Immagina di modificare un documento usando i comandi vocali. Dici \"Formatta testo\", che apre un menu contestuale. Quindi, dopo una breve pausa per consentire al menu di apparire completamente, dici \"Grassetto\" per applicare la formattazione in grassetto al testo selezionato. La funzione Pausa assicura che il menu contestuale sia pronto a ricevere il tuo comando successivo.",
            "label": "Pausa per <strong>{{value}}</strong> millisecondi"
        },
        "type": {
            "title": "Tipo",
            "field": "Frase da digitare",
            "placeholder": "frase digitata",
            "question": "Che testo vuoi digitare?",
            "description": "Scrivi il testo come se usassi una tastiera.",
            "longDescription": "Questo imita la digitazione di una stringa di testo, simile alla digitazione su una tastiera. È ideale per immettere testo più lungo senza dover premere ogni tasto. Se si desidera immettere testo in modo dinamico, è possibile utilizzare la funzione Dettatura.",
            "example": "Pronuncia \"Nome\" per digitare \"Ciao, mi chiamo Ellen Ripley.\" in una finestra di chat.",
            "label": "Tipo <strong> {{value}} </strong>"
        },
        "mouseMove": {
            "title": "Muovi il mouse",
            "description": "Spostare il puntatore sullo schermo.",
            "longDescription": "Sposta il cursore o il puntatore dello schermo senza un mouse fisico. Ciò è particolarmente utile per gli utenti con mobilità limitata delle mani. Ciò è utile per il controllo preciso del movimento del mouse, necessario in alcuni giochi. Se vuoi simulare tutti i movimenti del mouse utilizzando il movimento della testa, puoi provare 'Movimento della testa per il controllo del mouse' nelle impostazioni della telecamera.",
            "example": "Pronuncia \"Sposta il mouse a destra\" per spostare il cursore a destra di 100 px.",
            "moveX": "Spostamento del mouse a sinistra/destra dei pixel",
            "numberMoveX": "Numero di pixel da spostare a sinistra/destra",
            "moveY": "Spostamento del mouse su/giù Pixel",
            "numberMoveY": "Numero di pixel da spostare su/giù",
            "label": "Sposta il mouse <strong> {{value}} </strong>",
            "command": "Spostamento del mouse: {{command}}",
            "commandLabel": "Movimento del mouse",
            "startCommand": "Avvio movimento mouse",
            "stopCommand": "Movimento del mouse Interrompi"
        },
        "joystickMove": {
            "title": "Spostare i joystick",
            "description": "Usa un joystick per spostare gli oggetti sullo schermo.",
            "longDescription": "Questa funzione simula il movimento di un joystick. Ad esempio, se hai difficoltà a usare un joystick fisico, puoi usare un comando vocale o un altro metodo di input per muovere virtualmente un joystick.",
            "example": "Pronuncia \"Sposta il joystick a sinistra\" per spostare il joystick a sinistra di 100 px.",
            "prefix": "Muovi il joystick sinistro",
            "left": "Joystick sinistro",
            "leftX": "X sinistro",
            "leftY": "Y sinistro",
            "right": "Joystick destro",
            "rightX": "X destro",
            "rightY": "Y destro",
            "x": "Forza dell'asse X",
            "y": "Forza dell'asse Y",
            "moveXLabel": "Sposta X: {{value}}",
            "moveYLabel": "Sposta Y: {{value}}",
            "labelLeft": "Muovi il joystick sinistro",
            "labelRight": "Muovi il joystick a destra",
            "latch": "Latch manterrà la posizione finché non la rilascerai utilizzando il comando 'Stop All'."
        },
        "playAudio": {
            "title": "Riproduci audio",
            "placeholder": "frase di affermazione che Cephable dirà",
            "description": "Riproduci un suono, una parola o una frase.",
            "longDescription": "Questa funzione consente agli utenti di convertire frasi digitate in parole pronunciate. È particolarmente utile per le persone che potrebbero avere difficoltà a parlare. Digitando una frase, la funzione PlayAudio articola il testo ad alta voce utilizzando la sintesi vocale. Questo può aiutare nella comunicazione o in situazioni in cui un utente deve trasmettere informazioni verbalmente ma preferisce o richiede un'alternativa all'uso della propria voce.",
            "example": "Sorridi per riprodurre la parola \"Ciao\".",
            "label": "Pronuncia <strong>\"{{value}}\"</strong>"
        },
        "stopOutputs": {
            "title": "Interrompi tutte le uscite",
            "titleLong": "Interrompere tutti gli output (rilasciare tutti i tasti e i pulsanti, interrompere tutti i movimenti del mouse, interrompere tutta la digitazione)",
            "description": "Interrompere tutte le azioni in corso, come la pressione di tasti.",
            "longDescription": "Interrompere immediatamente tutti gli output o le azioni in corso. Questa è una funzione di sicurezza o di comodità per interrompere qualsiasi processo. Lo faremo automaticamente per te quando chiudi o metti in pausa i controlli della telecamera o del microfono.",
            "example": "Pronunciare \"Stop\" per interrompere tutte le uscite.",
            "label": "Arrestare tutte le uscite e rilasciare i tasti"
        },
        "custom": {
            "title": "Costume"
        },
        "options": {
            "moveUp": "Spostarsi verso l'alto",
            "moveDown": "Sposta giù",
            "moveLeft": "Spostati a sinistra",
            "moveRight": "Spostati a destra",
            "copyStep": "Copia passaggio",
            "removeStep": "Rimuovi passaggio"
        },
        "directions": {
            "up": "Su",
            "down": "Giù",
            "left": "Sinistra",
            "right": "Giusto"
        }
    },
    "expression": {
        "title": "Espressione del viso",
        "titlePlural": "Espressioni del viso",
        "label": "Espressione / Gesto",
        "start": "Avvia i controlli di espressione",
        "startSmiling": {
            "title": "Inizia a sorridere",
            "description": "Se inizi a non sorridere e poi inizi a sorridere, questo controllo si attiverà. Nota: usare questo controllo negli stessi controlli dell'app del controllo Apri/chiudi bocca potrebbe causare conflitti."
        },
        "stopSmiling": {
            "title": "Smettila di sorridere",
            "description": "Se stai sorridendo e poi smetti di sorridere, questo controllo si attiverà. Nota: usare questo controllo negli stessi controlli dell'app del controllo Apri/chiudi bocca potrebbe causare conflitti."
        },
        "eyebrows": {
            "title": "Alza le sopracciglia",
            "description": "Se sollevi entrambe le sopracciglia dalla posizione di riposo di base, questo controllo si attiverà."
        },
        "openMouth": {
            "title": "Bocca aperta",
            "description": "Se la tua bocca è chiusa (o se la tua linea di base è leggermente aperta) e apri di più la bocca, questo controllo si attiverà. Nota: usare questo controllo negli stessi controlli dell'app del controllo del sorriso potrebbe causare conflitti."
        },
        "closeMouth": {
            "title": "Chiudi la bocca",
            "description": "Se la tua bocca è aperta e la chiudi completamente, questo controllo si attiverà. Nota: usare questo controllo negli stessi controlli dell'app del controllo del sorriso potrebbe causare conflitti."
        },
        "description": "Arricchisci la tua esperienza digitale con le espressioni facciali. Usa gesti come alzare le sopracciglia, sorridere e altri movimenti per controllare senza problemi il puntatore del mouse, eseguire azioni o personalizzare le tue interazioni."
    },
    "head": {
        "title": "Movimento della testa",
        "titlePlural": "Movimenti della testa",
        "label": "Movimento della testa/corpo",
        "question": "Che tipo di movimento vuoi utilizzare?",
        "tilt": {
            "title": "Inclinazione della testa",
            "left": {
                "title": "Inclina la testa a sinistra",
                "description": "Se si guarda la telecamera e si inclina la testa verso sinistra, questo controllo si attiverà."
            },
            "right": {
                "title": "Inclina la testa a destra",
                "description": "Se si guarda la telecamera e si inclina la testa verso destra, questo controllo si attiverà."
            },
            "back": {
                "title": "Inclinare la testa all'indietro",
                "description": "Se si guarda la telecamera e si inclina la testa all'indietro e si guarda in alto, questo controllo si attiverà."
            },
            "forward": {
                "title": "Inclinare la testa in avanti",
                "description": "Se si guarda la telecamera e si inclina la testa in avanti e si guarda verso il basso, questo controllo si attiverà."
            },
            "description": "Inclina la testa verso sinistra o verso destra per un controllo migliore o per navigare con il mouse."
        },
        "turn": {
            "title": "Girare la testa",
            "left": {
                "title": "Girare la testa a sinistra",
                "description": "Se stai guardando la telecamera e giri la testa guardando verso sinistra, questo controllo si attiverà."
            },
            "right": {
                "title": "Girare la testa a destra",
                "description": "Se stai guardando la telecamera e giri la testa guardando verso destra, questo controllo si attiverà."
            },
            "description": "Ruota la testa verso sinistra o verso destra per un controllo migliore o per navigare con il mouse."
        },
        "lean": {
            "title": "Testa inclinata",
            "left": {
                "title": "Testa inclinata a sinistra",
                "description": "Se stai guardando la telecamera e ti pieghi verso sinistra in modo che il tuo viso sia più a sinistra nell'inquadratura, questo controllo si attiverà."
            },
            "right": {
                "title": "Testa inclinata a destra",
                "description": "Se stai guardando la telecamera e ti sporgi verso destra in modo che il tuo viso sia più a destra nell'inquadratura, questo controllo si attiverà."
            },
            "back": {
                "title": "Appoggia la testa all'indietro",
                "description": "Se stai guardando la telecamera e ti sporgi all'indietro in modo che il tuo viso sia più lontano dalla telecamera, questo controllo si attiverà."
            },
            "forward": {
                "title": "Piegare la testa in avanti",
                "description": "Se stai guardando la telecamera e ti sporgi in avanti in modo che il tuo viso sia più vicino alla telecamera, questo controllo si attiverà."
            },
            "up": {
                "title": "Muovi il corpo verso l'alto",
                "description": "Se stai guardando la telecamera e muovi la testa verso l'alto allungando il collo o muovendo tutto il corpo verso l'alto, questo controllo si attiverà."
            },
            "down": {
                "title": "Sposta il corpo verso il basso",
                "description": "Se stai guardando la telecamera e muovi la testa verso il basso, contraendo il collo, abbassandoti o abbassando tutto il corpo, questo controllo si attiverà."
            },
            "center": {
                "title": "Centra la tua testa",
                "description": "Se si guarda la telecamera e si riporta la testa nella posizione centrale, in corrispondenza della linea di base, questo controllo verrà attivato."
            },
            "description": "Inclina la testa verso sinistra o verso destra per un controllo migliore o per navigare con il mouse."
        },
        "description": "Controlla il tuo dispositivo o la tua connessione con movimenti della testa come inclinare, annuire o ruotare. Utilizzando la fotocamera del tuo dispositivo, Cephable garantisce un'esperienza privata e intuitiva per un controllo avanzato o la navigazione tramite mouse."
    },
    "voice": {
        "title": "Controllo vocale",
        "titlePlural": "Comandi vocali",
        "placeholder": "La voce o la frase che Cephable ascolterà",
        "question": "Quale affermazione o frase vuoi dire per questo controllo?",
        "when": "Quando dico...",
        "say": "Dì '{{value}}'",
        "load": {
            "fail": {
                "title": "{{language}} Controlli vocali non disponibili",
                "description": "Oh no! Non siamo riusciti a caricare {{language}} per i comandi vocali. Controlla la tua connessione Internet e riprova. Utilizzeremo l'inglese (Stati Uniti) finché la connessione non verrà ripristinata."
            }
        },
        "description": "L'attivazione del microfono sblocca comandi vocali intelligenti e naturali, consentendo agli utenti di interagire senza problemi con il proprio computer attraverso applicazioni e software. È possibile parlare in modo naturale per eseguire comandi o dettare testo, creando un'esperienza intuitiva e senza sforzo."
    },
    "motion": {
        "title": "Controllo del movimento",
        "titlePlural": "Controlli di movimento",
        "question": "Che tipo di movimento vuoi utilizzare con un telefono o un tablet?",
        "start": "Avvia i controlli di movimento",
        "settings": "Impostazioni di movimento",
        "descriptionShort": "Inclina, ruota o agita il dispositivo per controllare Cephable.",
        "description": "I controlli di movimento ti consentono di trasformare il movimento del tuo telefono o tablet nella Companion App in controlli per il tuo dispositivo. Inclina o scuoti il telefono in diverse direzioni per creare nuovi output.",
        "up": {
            "title": "Inclina il tuo dispositivo verso l'alto",
            "description": "Se il dispositivo è appoggiato su una superficie e lo si inclina verso l'alto, questo controllo si attiverà."
        },
        "down": {
            "title": "Inclina il tuo dispositivo verso il basso",
            "description": "Se il dispositivo è appoggiato su una superficie e lo si inclina verso il basso in modo che sia rivolto lontano da sé, questo controllo si attiverà."
        },
        "left": {
            "title": "Inclina il tuo dispositivo verso sinistra",
            "description": "Se il dispositivo è appoggiato su una superficie piana e lo si inclina verso sinistra, questo controllo si attiverà."
        },
        "right": {
            "title": "Inclina il tuo dispositivo verso destra",
            "description": "Se il dispositivo è appoggiato su una superficie piana e lo si inclina verso destra, questo controllo si attiverà."
        },
        "shake": {
            "title": "Scuoti il tuo dispositivo",
            "description": "Se scuoti il dispositivo, questo controllo si attiverà."
        },
        "edit": {
            "title": "Modifica impostazioni movimento",
            "description": "Modifica le impostazioni del controllo del movimento per stabilire quanto devi muovere il telefono durante la corsa nell'app complementare",
            "sensitivity": {
                "title": "Impostazioni di sensibilità del controllo del movimento",
                "description": "La sensibilità indica a Cephable quanto devi inclinare il tuo dispositivo per attivare un controllo. Maggiore è il valore (più a destra sul cursore), maggiore è la sensibilità e quindi meno devi inclinare per attivare il controllo."
            },
            "tilt": {
                "title": "Sensibilità all'inclinazione",
                "description": "Questi valori determinano quanto è necessario inclinare il dispositivo verso l'alto, verso il basso, verso sinistra e verso destra affinché un input venga riconosciuto."
            },
            "mouse": {
                "title": "Controlli di movimento per il movimento del mouse",
                "description": "Determina se e come desideri utilizzare i controlli di movimento per muovere il mouse invece di attivare i controlli",
                "enable": {
                    "title": "Abilita i controlli di movimento per il movimento del mouse",
                    "description": "Se questa opzione è attivata, per muovere il mouse verranno utilizzati alcuni dei controlli di movimento anziché i controlli di attivazione.",
                    "option": "Utilizzare i controlli di movimento per il movimento del mouse?"
                },
                "invert": {
                    "title": "Inverti il movimento del mouse",
                    "description": "Per l'asse X: se è attivato, spostando il mouse a sinistra si sposterà a destra e spostando il mouse a destra si sposterà a sinistra. Per l'asse Y: se è attivato, spostando il mouse in basso si sposterà in alto e spostando il mouse in alto si sposterà in basso.",
                    "x": "Invertire il movimento del mouse sull'asse X?",
                    "y": "Invertire il movimento del mouse sull'asse Y?"
                }
            }
        }
    },
    "keys": {
        "title": "Tasto o pulsante",
        "titlePlural": "Tasti o pulsanti",
        "label": "Tasto/pulsante esterno",
        "question": "Quale tasto o pulsante vuoi premere?",
        "edit": "Modifica tasti e pulsanti",
        "defaultOption": "Includere comandi vocali predefiniti per i tasti e i clic del mouse?",
        "description": "I tasti e i pulsanti consentono di associare i diversi controlli di input alle pressioni dei pulsanti della tastiera e del controller.",
        "then": "Cephable premerà...",
        "empty": "Non ci sono controlli chiave che corrispondono a questi criteri.",
        "backspace": "Indietro",
        "delete": "Eliminare",
        "enter": "Entrare",
        "space": "Barra spaziatrice",
        "tab": "Scheda",
        "shift": "Spostare",
        "ctrl": "Ctrl",
        "leftCtrl": "Ctrl sinistro",
        "rightCtrl": "Ctrl destro",
        "leftShift": "Spostamento a sinistra",
        "rightShift": "Spostamento a destra",
        "alt": "Tutto",
        "leftAlt": "Alt sinistro",
        "escape": "Fuga",
        "up": "Freccia su",
        "down": "Freccia giù",
        "left": "Freccia sinistra",
        "right": "Freccia a destra",
        "command": "Comando",
        "caps": "Blocco maiuscole",
        "reset": {
            "title": "Reimposta le associazioni dei tasti",
            "confirm": "Ripristinare tutte le associazioni dei tasti?",
            "confirmDescription": "Scegli come ripristinare le associazioni dei tasti. Questa azione non può essere annullata senza salvare.",
            "confirmButton": "Reimposta le associazioni dei tasti",
            "defaultOption": "Ripristina i valori predefiniti per la lingua corrente",
            "emptyOption": "Ripristina a vuoto (cancella tutti i comandi)"
        }
    },
    "talkback": {
        "title": "Risposta",
        "question": "Cosa vuoi che dica Cephable?",
        "description": "Imposta i controlli che faranno parlare Cephable per te. Puoi assegnare i controlli alle diverse frasi che vuoi che vengano pronunciate.",
        "thenMacro": "allora Cefabile dirà...",
        "empty": "Non ci sono controlli Talkback che corrispondono a questi criteri.",
        "add": "Aggiungi un nuovo controllo Talkback",
        "remove": "Rimuovi controllo Talkback",
        "edit": "Modifica controlli Talkback",
        "deprecatedNotice": "Talkback è ora integrato direttamente nei controlli app primari. I controlli app hanno alcuni eventi talkback più vecchi che devono essere aggiornati."
    },
    "dictation": {
        "title": "Dettatura",
        "question": "Quale frase dovrebbe attivare la modalità dettatura?",
        "thenMacro": "Cephable...",
        "empty": "Non ci sono controlli di dettatura che corrispondono a questi criteri.",
        "type": "tipo",
        "edit": "Modifica frasi di dettatura",
        "remove": "Rimuovi frase dettatura",
        "add": "Aggiungi una nuova frase di dettatura",
        "on": "Dettatura",
        "off": "Comandi",
        "onboarding": {
            "tourLabel": "Dettatura",
            "learn": "Scopri come usare la modalità dettatura per convertire i tuoi discorsi in testo senza usare le mani.",
            "welcome": {
                "title": "Dettatura",
                "description": "La dettatura ti permette di parlare in modo naturale e di sentire le parole digitate mentre parli. È come avere un assistente personale che digita tutto quello che dici."
            },
            "microphone": {
                "title": "Accendi il microfono",
                "description": "Per prima cosa, accendi il microfono. Fai clic sull'interruttore del microfono nel pannello Cephable."
            },
            "activate": {
                "title": "Avvia la modalità di dettatura",
                "description": "La voce si avvia in modalità comando. Per avviare la dettatura, pronuncia \"Avvia dettatura\" o fai clic sul pulsante Dettatura. Attiviamo ora la modalità dettatura."
            },
            "speaking": {
                "title": "Fai clic su un documento o un campo e inizia a parlare",
                "description": "La dettatura trascriverà in tempo reale ciò che dici. Fai clic su un campo di testo o un documento e inizia a parlare. Ad esempio, pronuncia: \"Ecco come usare la modalità dettatura\"."
            },
            "pauseResume": {
                "title": "Mettere in pausa la dettatura",
                "description": "Hai bisogno di una pausa senza disattivare la dettatura? Basta dire \"Metti in pausa la dettatura\". Puoi riprendere la dettatura in qualsiasi momento premendo di nuovo \"Avvia dettatura\". Puoi personalizzare ulteriormente questa funzione con i controlli globali e del dispositivo sempre attivi."
            },
            "stop": {
                "title": "Interruzione della dettatura",
                "description": "Devi tornare ai controlli dell'app? Basta dire \"Interrompi dettatura\". Questo interromperà la modalità dettatura e ti riporterà alla modalità comando. Puoi riprendere in qualsiasi momento premendo nuovamente \"Avvia dettatura\"."
            },
            "complete": {
                "title": "Congratulazioni!",
                "description": "Ecco fatto! Ora puoi dettare, mettere in pausa, riprendere e passare dalla modalità dettatura a quella di comando. La dettatura è un potente strumento per la digitazione a mani libere. Usala per scrivere email, documenti o qualsiasi altra cosa tu debba digitare ad alta voce."
            }
        },
        "description": "La dettatura ti permette di parlare in modo naturale e di sentire le parole digitate mentre parli. È come avere un assistente personale che digita tutto quello che dici."
    },
    "face": {
        "title": "Espressione del viso",
        "titlePlural": "Espressioni del viso",
        "try": "Prova i controlli delle espressioni facciali",
        "question": "Che tipo di espressione facciale vuoi usare?",
        "descriptionShort": "Per controlli più efficaci, utilizza diversi movimenti del viso.",
        "description": "Le espressioni facciali fanno parte dei Controlli Espressione. Ti permettono di usare diversi movimenti del viso per controlli avanzati. Puoi usare il movimento delle sopracciglia, della bocca e altro ancora per creare output diversi."
    },
    "other": {
        "title": "Altro",
        "titlePlural": "Altri controlli",
        "label": "Altro controllo",
        "placeholder": "altro comando sperimentale",
        "question": "Quale comando aggiuntivo desideri utilizzare? Questi comandi sono in genere per connessioni non Cephable che non rientrano in altre categorie. Possono anche funzionare come comandi vocali quando pronunci la parola o la frase specificata. Nota: questi controlli sono sperimentali e potrebbero non essere completamente supportati.",
        "description": "Altri controlli sono sperimentali e potrebbero non essere completamente supportati. Possono essere utilizzati per connessioni non Cephable o come comandi vocali quando si pronuncia la parola o la frase specificata."
    },
    "support": {
        "title": "Supporto",
        "profiles": "Introduzione ai controlli delle app",
        "question": "Non hai ancora trovato quello che ti serve?",
        "more": "Scopri di più su Cephable.com con guide dettagliate, tutorial, video e altro ancora."
    },
    "community": {
        "title": "Unisciti alla comunità",
        "description": "Ottieni supporto, condividi idee o diventa membro delle community di Cephable.",
        "discord": "Comunità Discord",
        "facebook": "Gruppo Facebook"
    },
    "resources": {
        "title": "Risorse utili",
        "description": "Trova le risposte alle tue domande sulle caratteristiche e le funzioni di Cephable.",
        "guides": "Guide passo dopo passo"
    },
    "feedback": {
        "title": "Feedback",
        "description": "Raccontaci la tua esperienza con Cephable.",
        "contact": "Contattaci",
        "feature": "Suggerisci una funzionalità",
        "bug": "Segnala un problema"
    },
    "settings": {
        "title": "Impostazioni",
        "general": "Impostazioni generali dell'app",
        "description": "Questa è la tua tela su cui personalizzare la tua esperienza, perfezionando i tuoi controlli.",
        "orgTitle": "Impostazioni di {{value}}",
        "advanced": {
            "title": "Impostazioni avanzate",
            "description": "Fai clic qui per accedere alle impostazioni avanzate per l'IA, i controlli dell'app, le connessioni, le estensioni e altro ancora."
        },
        "quick": "Ecco le impostazioni contestuali per il pannello. Utilizzale per personalizzare la tua esperienza attuale."
    },
    "account": {
        "title": "Account",
        "menu": "Menu utente",
        "settings": "Impostazioni dell'account",
        "description": "Aggiorna le informazioni chiave per rimanere in contatto con Cephable.",
        "usernameLabel": "Nome utente:",
        "emailLabel": "E-mail:",
        "password": {
            "change": "Cambiare la password",
            "description": "Aggiorna la tua password per proteggere il tuo account.",
            "old": "Vecchia password",
            "current": "La tua password attuale",
            "new": "Nuova password",
            "desired": "La nuova password desiderata",
            "confirm": "Conferma la nuova password",
            "update": "Aggiorna password"
        },
        "isEmailVerified": {
            "title": "L'email non è verificata.",
            "description": "La tua email non è verificata. Controlla la tua email per un link di verifica.",
            "resend": "Invia di nuovo l'email",
            "success": "Ti abbiamo inviato una nuova email di verifica.",
            "error": "Si è verificato un errore durante l'invio dell'email di verifica. Riprova più tardi.",
            "org": "Il tuo indirizzo email non è verificato. È necessario per accedere ai dettagli della licenza. Controlla la tua email per un link di verifica.",
            "titleAlt": "Verifica il tuo indirizzo email",
            "descriptionLong": "Benvenuto su Cephable! Un'email di verifica è stata inviata a {{email}}. Controlla la posta in arrivo o la cartella spam e clicca sul link. Se non lo vedi, puoi inviare nuovamente l'email di verifica.",
            "appBlock": "Ci sei quasi! Un'email di verifica è stata inviata a {{email}}. Controlla la tua posta in arrivo e clicca sul link per verificare il tuo indirizzo email. Se non lo vedi, controlla la cartella spam."
        },
        "signout": {
            "title": "Disconnessione",
            "question": "Sei sicuro di voler uscire?",
            "confirm": "Sì, esci",
            "warn": {
                "title": "Stai per uscire.",
                "description": "Sembra che tu sia stato inattivo per un po'. Per motivi di sicurezza, ti disconnetteremo tra XX secondi. Se vuoi rimanere connesso, clicca su \"Resta connesso\" qui sotto.",
                "confirm": "Rimani connesso",
                "cancel": "Esci ora"
            },
            "description": "Una volta effettuata la disconnessione, questa connessione verrà rimossa dal tuo account e non sarà più visibile dall'app complementare o da altre connessioni.",
            "confirmDescription": "Ti disconnettiamo e rimuoviamo questa connessione"
        },
        "marketing": {
            "title": "Preferenze e-mail",
            "description": "Aggiorna le tue preferenze e-mail per ricevere aggiornamenti e novità da Cephable.",
            "marketing": "Email di marketing",
            "optIn": "Vorrei ricevere tutorial, suggerimenti, aggiornamenti e newsletter per migliorare la mia esperienza con Cephable"
        },
        "error": {
            "save": "Errore durante il salvataggio delle impostazioni dell'account.",
            "password": "Errore durante l'aggiornamento della password.",
            "signout": "Errore durante la disconnessione.",
            "old": "È richiesta la vecchia password.",
            "new": "È richiesta una nuova password.",
            "match": "Le password non corrispondono.",
            "marketing": "Errore durante l'aggiornamento delle preferenze e-mail.",
            "userPreferences": "Errore durante il salvataggio delle preferenze utente."
        },
        "success": {
            "save": "Impostazioni account salvate.",
            "password": "Password aggiornata.",
            "marketing": "Preferenze e-mail aggiornate.",
            "userPreferences": "Preferenze utente aggiornate."
        },
        "userPreferences": {
            "title": "Preferenze utente",
            "description": "Aggiorna le tue preferenze per creare l'esperienza Cephable più adatta a te.",
            "warningOptOut": "Nascondi gli avvisi quando salvo o aggiorno i controlli dell'app",
            "enableTranscribeTask": "Abilita l'attività di trascrizione del file sperimentale nel pannello Cephable",
            "enableGamepadSupport": "Abilita il supporto del gamepad per il driver locale e l'emulazione del controller Xbox",
            "enableMetrics": "Abilita l'output delle metriche di utilizzo per i test delle prestazioni. Potrai scaricare i log.",
            "enableCameraControls": "Abilita i controlli della fotocamera nel pannello Cephable"
        },
        "delete": {
            "title": "Elimina account",
            "description": "Puoi eliminare definitivamente il tuo account e rimuovere ogni riferimento alle tue informazioni personali. Quando elimini il tuo account, le tue connessioni verranno rimosse e non funzioneranno più né saranno più registrate sul tuo account; i controlli dell'app e tutte le impostazioni andranno persi. Questa procedura non può essere annullata.",
            "button": "Elimina definitivamente l'account",
            "confirmation": "Sei sicuro di voler eliminare il tuo account?",
            "note": "Questa azione è irreversibile.",
            "confirm": "Sì, elimina il mio account"
        },
        "communication": {
            "title": "Preferenze di comunicazione"
        },
        "name": {
            "title": "Nome visualizzato"
        },
        "email": {
            "title": "Indirizzo email",
            "description": "Il tuo indirizzo email registrato"
        }
    },
    "appSettings": {
        "description": "Queste impostazioni si applicano solo a questa app. Se vuoi modificare le impostazioni dell'app Cephable su un altro computer o dispositivo mobile, modifica le impostazioni in quell'app.",
        "autostart": {
            "title": "Avvia automaticamente Cephable",
            "description": "Con questa impostazione attivata, l'app Cephable si avvierà automaticamente quando effettui l'accesso al tuo dispositivo. Se hai anche controlli vocali ed espressivi automatici, anche questi si avvieranno subito.",
            "question": "Avvio automatico dell'app Cephable?"
        },
        "position": {
            "topLeft": "In alto a sinistra",
            "top": "Centro superiore",
            "topRight": "In alto a destra",
            "bottom": "Centro in basso",
            "bottomLeft": "In basso a sinistra",
            "bottomRight": "In basso a destra",
            "label": "Seleziona la posizione di avanzamento dei comandi",
            "description": "Seleziona dove desideri che il feed dei comandi appaia sullo schermo."
        },
        "micPosition": {
            "title": "Posizione della finestra di input del microfono",
            "description": "Seleziona la posizione sullo schermo in cui desideri posizionare i controlli del microfono per la voce e la dettatura.",
            "label": "Seleziona la posizione della finestra di input del microfono"
        },
        "cameraPosition": {
            "title": "Posizione della finestra di input della telecamera",
            "description": "Seleziona dove desideri posizionare sullo schermo i controlli della telecamera per il movimento del viso e della testa.",
            "label": "Seleziona la posizione della finestra di input della telecamera"
        },
        "theme": {
            "title": "Tema",
            "description": "Scegli un tema adatto al tuo stile.",
            "label": "Seleziona un tema",
            "light": "Leggero",
            "dark": "Buio",
            "system": "Utilizzare le impostazioni di sistema del sistema operativo"
        },
        "overlay": {
            "title": "Feed di comando",
            "description": "Il feed di comando mostrerà i diversi controlli che usi e quali controlli sono stati inviati al tuo computer. È click-through ma sarà sempre in cima alle altre finestre. Con questa impostazione attivata, l'app Cephable mostrerà e sarà sempre in cima alle altre finestre e applicazioni.",
            "question": "Mostrare il feed dei comandi?"
        },
        "transparent": {
            "title": "Trasparenza del feed dei comandi",
            "description": "Determina l'opacità del testo. Più basso è il valore, più trasparente sarà il feed."
        },
        "panelAutoHide": {
            "title": "Pannello Cephable con Nascondimento Automatico",
            "delay": "Ritardo prima di nascondersi",
            "denominator": "secondi",
            "time": "{{value}} secondi"
        },
        "title": "Impostazioni generali dell'app",
        "scale": {
            "description": "Regola le dimensioni del testo in tutta l'app.",
            "label": "Dimensione del testo",
            "small": "Piccolo",
            "large": "Grande"
        },
        "panelScale": {
            "description": "Regola le dimensioni del pulsante del pannello compresso.",
            "label": "Dimensioni del pulsante del pannello"
        },
        "aiNewFiles": {
            "title": "Cartella per i nuovi file AI",
            "description": "Scegli dove l'agente AI salva i nuovi file per impostazione predefinita, a meno che tu non indichi una posizione specifica. Se viene lasciata l'impostazione predefinita, i nuovi file vengono salvati in una cartella «Cephable-Work» nella tua cartella home, creata automaticamente al primo utilizzo.",
            "selectButton": "Seleziona la cartella",
            "clearButton": "Usa la cartella predefinita",
            "current": "I nuovi file vengono salvati in: {{folder}}",
            "default": "I nuovi file vengono salvati nella cartella predefinita «Cephable-Work» nella tua cartella home.",
            "openButton": "Apri la cartella",
            "openError": "Impossibile aprire la cartella. Potrebbe essere stata spostata o eliminata."
        },
        "aiWorkspace": {
            "title": "Cartella dell'area di lavoro AI",
            "description": "Scegli una cartella che l'agente AI sul dispositivo utilizzerà per trovare, leggere e modificare file e per eseguire comandi. Per impostazione predefinita, l'agente può accedere all'intero computer.",
            "selectButton": "Seleziona la cartella",
            "clearButton": "Utilizzare l'intero computer",
            "current": "Cartella corrente dell'area di lavoro:",
            "none": "Nessuna cartella di lavoro selezionata. L'agente AI può accedere all'intero computer.",
            "restrictQuestion": "Limita l'agente IA a questa sola cartella",
            "restrictDescription": "Quando questa opzione è abilitata, gli strumenti di file e di comando dell'agente AI non possono leggere o modificare alcun file al di fuori della cartella selezionata."
        },
        "documentTemplates": {
            "title": "Modelli di documenti",
            "description": "Scegli un file modello da cui l'agente AI partirà per creare nuovi documenti. Lascia l'opzione predefinita di Cephable per applicare lo stile predefinito del marchio Cephable. Word, PowerPoint ed Excel hanno ciascuno il proprio modello.",
            "word": "Modello Word",
            "wordDescription": "Modello di partenza per l'agente di intelligenza artificiale per i nuovi documenti Word (.docx).",
            "powerpoint": "Modelli PowerPoint",
            "powerpointDescription": "Modello di partenza per l'agente di intelligenza artificiale per le nuove presentazioni PowerPoint (.pptx).",
            "excel": "Modello Excel",
            "excelDescription": "Modello di partenza per l'agente di intelligenza artificiale per le nuove cartelle di lavoro di Excel (.xlsx).",
            "selectButton": "Seleziona File",
            "clearButton": "Utilizza le impostazioni predefinite di Cephable",
            "current": "Modello: ",
            "default": "Utilizzo del modello predefinito integrato di Cephable con lo stile del marchio."
        },
        "automationBrowser": {
            "title": "Visibilità del browser di automazione",
            "description": "Quando l'agente AI utilizza il browser Cephable (ricerca web, Google Docs/Sheets/Slides, Gmail, Drive), normalmente viene eseguito in background in modo nascosto per non interromperti. Attiva questa opzione per vederlo in azione.",
            "question": "Mostrare il browser di automazione mentre l'IA è in funzione?"
        }
    },
    "input": {
        "title": "Ingresso",
        "titlePlural": "Controlli di input",
        "explore": "Esplora i controlli di input",
        "descriptionShort": "Esplora i vari controlli di input che Cephable utilizza per creare un'esperienza digitale migliore per te.",
        "typeLabel": "Tipo di controllo di input",
        "toolTip": "Questo utilizza {{alt}}",
        "remove": "Rimuovi controllo input",
        "filter": "Filtra per tipo di input",
        "select": "Seleziona un input",
        "question": "Che tipo di input vuoi utilizzare?",
        "add": "Aggiungi input",
        "addMore": "Aggiungi un altro input",
        "removeItem": "Rimuovi elemento {{index}}",
        "item": "Elemento {{index}}: {{label}}",
        "duplicate": "Non sono ammessi elementi duplicati.",
        "maximum": "Sono consentiti al massimo {{maxItems}} articoli.",
        "description": "I controlli di input sono i diversi metodi utilizzati per controllare il dispositivo, come la voce, i movimenti della testa, le espressioni facciali e altre connessioni. Esplora i diversi controlli di input qui sotto per saperne di più."
    },
    "time": {
        "soon": "Prossimamente",
        "now": "Ora",
        "today": "Oggi",
        "yesterday": "Ieri",
        "minutesAgo": "{{count}} minuto fa",
        "minutesAgo_plural": "{{count}} minuti fa",
        "daysAgo": "{{count}} giorni fa",
        "daysAgo_plural": "{{count}} giorni fa",
        "monthsAgo": "{{count}} mese fa",
        "monthsAgo_plural": "{{count}} mesi fa",
        "yearsAgo": "{{count}} anno fa",
        "yearsAgo_plural": "{{count}} anni fa",
        "minutesAhead": "in {{count}} minuti",
        "todayAhead": "più tardi oggi",
        "tomorrow": "Domani",
        "daysAhead": "tra {{count}} giorni",
        "monthsAhead": "tra {{count}} mesi",
        "yearsAhead": "in {{count}} anni"
    },
    "peripherals": {
        "empty": "Nessuna periferica rilevata",
        "switch": "Interruttore",
        "keyboard": "Tastiera",
        "gamepad": "Controllo dei giochi",
        "companionApp": "App complementare",
        "available": "Disponibile per l'uso",
        "error": "Controlla le tue impostazioni."
    },
    "camera": {
        "windowTitle": "Controlli della fotocamera Cephable",
        "title": "Telecamera",
        "titlePlural": "Telecamere",
        "settings": "Impostazioni della fotocamera",
        "start": "Avvia la fotocamera",
        "restart": "Riavvia la fotocamera",
        "descriptionShort": "Permette l'espressione del viso e il movimento della testa.",
        "description": "Utilizza la fotocamera per rilevare le espressioni del viso e i gesti del corpo come controlli diversi.",
        "empty": "Nessuna telecamera trovata.",
        "search": "Cerca per nome della telecamera",
        "loading": "Caricamento dei controlli della telecamera...",
        "error": "Errore imprevisto durante il caricamento dei controlli della fotocamera. Controlla la tua fotocamera e riprova.",
        "manage": {
            "title": "Fai clic per visualizzare e gestire i dettagli delle tue telecamere.",
            "description": ""
        },
        "detected": {
            "face": "Volto rilevato.",
            "noFace": "Nessun volto rilevato. Regola la telecamera o la posizione e riprova.",
            "command": "Rilevato: {{command}}"
        },
        "permission": {
            "title": "Autorizzazioni della fotocamera richieste",
            "description": "Devi autorizzare Cephable a utilizzare la tua fotocamera per usare i controlli del viso e del corpo.",
            "button": "Apri Impostazioni Permessi",
            "no": "Nessun accesso alla telecamera",
            "help": "Cephable ha bisogno di accedere alla tua fotocamera per usare i controlli di espressione e della testa. Vai su <strong>Impostazioni di sistema</strong>  <strong>Privacy</strong>  <strong>Fotocamera</strong> e abilita Cephable per accedere alla tua fotocamera."
        },
        "controls": {
            "startData": "Registrazione dei dati del viso avviata. Premi di nuovo la scorciatoia mentre sei nella finestra della fotocamera per interrompere la registrazione e scaricare.",
            "downloadData": "Registrazione interrotta, download dei dati",
            "paused": "Controlli della telecamera in pausa.",
            "pause": "Pausa controlli telecamera",
            "resume": "Riprendi i controlli della telecamera",
            "resumed": "Ripristino dei controlli della telecamera.",
            "linesOn": "Attiva le linee del viso",
            "linesOff": "Disattiva le linee del viso",
            "linesToggle": "Attiva/disattiva il disegno delle linee del viso",
            "noDeviceTitle": "Nessuna telecamera rilevata che possa essere utilizzata con Cephable.",
            "noDeviceDescription": "È necessario collegare una fotocamera compatibile con le app mobili.",
            "noDeviceConnectedDescription": "Il controllo della telecamera serve come anteprima dell'interfaccia. Nessun passaggio verrà eseguito correttamente. Collega questo dispositivo companion a un altro, per avviare i comandi.",
            "lines": "Linee del viso"
        },
        "switch": {
            "title": "Cambia telecamera",
            "description": "Seleziona una telecamera diversa da utilizzare per i controlli del viso e del corpo.",
            "select": "Seleziona la fotocamera",
            "next": "Prossima telecamera",
            "nextLong": "Passa alla telecamera successiva",
            "empty": "Non sono state trovate altre telecamere.",
            "search": "Cerca per nome della telecamera"
        },
        "baseline": {
            "title": "Linea di base",
            "description": "La linea di base è la posizione predefinita del tuo viso e del tuo corpo che Cephable usa per determinare i tuoi movimenti. Puoi aggiornare e reimpostare la linea di base qui.",
            "update": "Aggiorna la linea di base",
            "reset": "Ripristina linea di base",
            "updated": "Baseline aggiornata",
            "tooltip": "Fai clic per aggiornare la tua linea di base alla tua posizione di riposo attuale."
        },
        "edit": {
            "title": "Modifica impostazioni fotocamera",
            "description": "Puoi perfezionare le impostazioni per gli input che richiedono una telecamera, in modo che si adattino meglio alle tue esigenze.",
            "autoStart": {
                "title": "Avvia automaticamente la fotocamera",
                "option": "Avvio automatico della telecamera e dei controlli della testa/espressione?",
                "description": "Con questa impostazione attivata, il controller avvierà la fotocamera, consentendoti di utilizzare le espressioni facciali e i controlli dei movimenti della testa non appena l'app si avvia. Se questa impostazione è disattivata, devi toccare il pulsante \"Avvia fotocamera\" nella pagina di connessione."
            },
            "head": {
                "title": "Sensibilità al movimento della testa",
                "description": "La sensibilità indica a Cephable quanto lontano devi muoverti per attivare un controllo. Maggiore è il valore (più a destra sullo slider), maggiore è la sensibilità e quindi meno devi muoverti per attivare il controllo.",
                "tilt": {
                    "title": "Sensibilità all'inclinazione della testa",
                    "description": "Questi valori determinano quanto è necessario inclinare la testa verso l'alto, verso il basso, verso sinistra e verso destra per attivare i controlli",
                    "up": "Sensibilità inclinazione verso l'alto",
                    "down": "Sensibilità inclinazione verso il basso",
                    "left": "Sensibilità inclinazione a sinistra",
                    "right": "Sensibilità inclinazione a destra",
                    "scaleHigh": "Leggera inclinazione",
                    "scaleLow": "Grande inclinazione"
                },
                "turn": {
                    "title": "Sensibilità alla rotazione della testa",
                    "description": "Questi valori determinano quanto è necessario girare la testa a sinistra e a destra per attivare i controlli",
                    "left": "Sensibilità svolta a sinistra",
                    "right": "Sensibilità di svolta a destra",
                    "scaleHigh": "Leggera svolta",
                    "scaleLow": "Grande svolta"
                },
                "lean": {
                    "title": "Sensibilità all'inclinazione della testa",
                    "description": "Questi valori determinano quanto è necessario inclinare la testa in avanti e indietro per attivare i controlli",
                    "forward": "Sensibilità di inclinazione in avanti",
                    "back": "Sensibilità di appoggio",
                    "right": "Sensibilità di inclinazione a destra",
                    "left": "Sensibilità inclinata a sinistra",
                    "scaleHigh": "Leggera inclinazione",
                    "scaleLow": "Grande magro"
                },
                "duck": {
                    "title": "Sensibilità di inclinazione/salita della testa",
                    "description": "Questi valori determinano quanto è necessario abbassare o alzare la testa per attivare i controlli",
                    "down": "Sensibilità al piumino d'anatra",
                    "up": "Aumenta la sensibilità",
                    "scaleHigh": "Leggero spostamento",
                    "scaleLow": "Grande spostamento"
                }
            },
            "face": {
                "title": "Sensibilità all'espressione del viso",
                "description": "La sensibilità indica a Cephable quanto esagerata deve essere l'espressione per attivare un controllo. Maggiore è il valore (più a destra sullo slider), maggiore è la sensibilità e quindi meno è necessario muoversi per attivare il controllo.",
                "eyebrow": {
                    "title": "Sensibilità delle sopracciglia",
                    "description": "Questi valori determinano quanto è necessario alzare o abbassare le sopracciglia per attivare i controlli",
                    "up": "Aumenta la sensibilità delle sopracciglia",
                    "scaleHigh": "Lieve aumento",
                    "scaleLow": "Grande aumento"
                },
                "mouth": {
                    "title": "Sensibilità della bocca",
                    "description": "Questi valori determinano quanto è necessario aprire o chiudere la bocca per attivare i controlli",
                    "open": "Sensibilità della bocca aperta",
                    "close": "Sensibilità della bocca chiusa",
                    "smile": "Sensibilità al sorriso",
                    "scaleHigh": "Leggermente aperto",
                    "scaleLow": "Grande Aperto",
                    "closeScaleHigh": "Leggermente Chiuso",
                    "closeScaleLow": "Ben chiuso",
                    "smileScaleHigh": "Un leggero sorriso",
                    "smileScaleLow": "Grande sorriso"
                }
            },
            "mouse": {
                "title": "Movimento della testa per i controlli del mouse",
                "description": "Determina se e come desideri utilizzare i controlli dei movimenti della testa per muovere il mouse invece di attivare altri output.",
                "enable": {
                    "title": "Abilita il movimento della testa per i controlli del mouse",
                    "description": "Se questa opzione è attivata, per muovere il mouse verranno utilizzati alcuni controlli dei movimenti della testa anziché i controlli dei trigger.",
                    "option": "Utilizzare i controlli della testa per il movimento del mouse?"
                },
                "input": {
                    "title": "Tipo di input del mouse",
                    "description": "Seleziona il tipo di gesti della testa che vuoi assegnare ai controlli del mouse. Ad esempio, Inclinazione della testa significa che puoi inclinare la testa a sinistra e a destra per muovere il mouse a sinistra e a destra, Rotazione della testa significa che puoi girare la testa a sinistra e a destra per muovere il mouse e Inclinazione della testa significa che puoi inclinarti a sinistra e a destra per muovere il mouse.",
                    "option": "Seleziona il tipo di input",
                    "optionLong": "Seleziona il tipo di movimento della testa che desideri utilizzare per controllare il mouse."
                },
                "invert": {
                    "title": "Inverti il movimento del mouse",
                    "description": "Se è attivato, la direzione in cui muovi la testa sarà invertita rispetto alla direzione in cui si muove il mouse. Per l'asse X: se è attivato, spostandoti a sinistra sposterai il mouse a destra e spostandoti a destra lo sposterai a sinistra. Per l'asse Y: se è attivato, spostandoti verso il basso sposterai il mouse verso l'alto e spostandoti verso l'alto lo sposterai verso il basso.",
                    "x": "Invertire il movimento del mouse sull'asse X?",
                    "y": "Invertire il movimento del mouse sull'asse Y?"
                },
                "mode": {
                    "title": "Modalità di spostamento del mouse",
                    "description": "Seleziona il modo in cui desideri che il cursore reagisca ai movimenti della testa."
                },
                "speed": {
                    "title": "Velocità del mouse",
                    "description": "Determina la velocità costante a cui vuoi che si muova il cursore.",
                    "fast": "Veloce",
                    "slow": "Lento"
                },
                "linear": {
                    "title": "Movimento lineare del mouse",
                    "description": "Se questa opzione è attivata, il cursore si muove solo lungo linee rette orizzontali o verticali, facilitando la navigazione in quelle specifiche direzioni senza alcuno spostamento diagonale.",
                    "option": "Utilizzare il movimento lineare del mouse?"
                },
                "accelerationRate": {
                    "title": "Ritardo di risposta all'accelerazione del mouse",
                    "description": "Numero di millisecondi necessari affinché la velocità del mouse aumenti."
                },
                "accelerationCurve": {
                    "title": "Curva di accelerazione del mouse",
                    "description": "Regola la velocità con cui la velocità del cursore aumenta in relazione al movimento della testa.",
                    "linear": "Lineare",
                    "exponential": "Esponenziale",
                    "sublinear": "Sub-lineare"
                },
                "maximumSpeed": {
                    "title": "Velocità massima del mouse",
                    "description": "Determina il numero massimo di pixel che il cursore può spostare al secondo."
                },
                "off": {
                    "title": "Spento",
                    "description": "Il movimento del mouse è disabilitato."
                },
                "steadyGlide": {
                    "title": "Scivolata costante",
                    "description": "Quando si muove la testa oltre un certo punto, il cursore scivola continuamente in quella direzione a velocità costante."
                },
                "speedBoost": {
                    "title": "Aumento della velocità",
                    "description": "Il cursore inizia a muoversi più velocemente quanto più a lungo tieni la testa in una posizione. Più a lungo tieni ferma la testa, più velocemente il cursore accelera."
                },
                "dynamicGlide": {
                    "title": "Scivolamento dinamico",
                    "description": "La velocità del cursore aumenta in base a quanto muovi la testa. Più muovi la testa, più velocemente scivola il cursore."
                },
                "proportionalSpeed": {
                    "title": "Velocità proporzionale",
                    "description": "Il cursore segue la punta del tuo naso in modo proporzionale alle dimensioni dello schermo."
                },
                "disabled": "Questa funzionalità è disabilitata per le connessioni e le estensioni remote."
            }
        },
        "stop": "Ferma la telecamera",
        "show": "Mostra la telecamera",
        "hide": "Nascondi telecamera",
        "warn": "I controlli della fotocamera non sono stati avviati. Avvia la fotocamera per consentire i controlli del viso e del corpo.",
        "draw": {
            "error": "Errore durante il caricamento del feed della telecamera. Controlla la telecamera e riprova."
        },
        "select": "Seleziona la telecamera che desideri associare per ottenere controlli avanzati tramite riconoscimento facciale, corpo e pulsanti di azione rapida.",
        "extension": {
            "title": "Estensione: Fotocamera",
            "enabledTitle": "Abilita i controlli della fotocamera",
            "enabledDescription": "Con questa impostazione attivata, Cephable utilizzerà la fotocamera per rilevare i movimenti del viso e della testa, consentendoti di controllare il dispositivo con espressioni e gesti, incluso l'utilizzo dei movimenti della testa come mouse."
        },
        "live": "VIVERE",
        "paused": "La telecamera si è fermata"
    },
    "microphone": {
        "windowTitle": "Comandi vocali Cephable",
        "title": "Microfono",
        "titlePlural": "Microfoni",
        "settings": "Impostazioni del microfono",
        "start": "Avvia microfono",
        "stop": "Ferma il microfono",
        "descriptionShort": "Abilita comandi vocali e dettatura.",
        "description": "Utilizza il microfono integrato per abilitare i comandi vocali e la dettatura.",
        "select": "Seleziona il microfono che desideri associare per ottenere controlli avanzati tramite la voce.",
        "empty": "Nessun microfono trovato.",
        "search": "Cerca per nome del microfono",
        "manage": {
            "title": "Fai clic per visualizzare e gestire i dettagli dei tuoi microfoni.",
            "description": ""
        },
        "permission": {
            "title": "Autorizzazioni microfono richieste",
            "description": "Per utilizzare i comandi vocali, devi autorizzare Cephable a utilizzare il tuo microfono.",
            "button": "Apri Impostazioni Permessi",
            "no": "Nessun accesso al microfono",
            "help": "Cephable ha bisogno di accedere al tuo microfono per usare i comandi vocali. Vai su <strong>Impostazioni di sistema</strong>  <strong>Privacy</strong>  <strong>Microfono</strong> e abilita Cephable per accedere al tuo microfono."
        },
        "controls": {
            "loadingDetail": "Potrebbero volerci alcuni minuti.",
            "pause": "Pausa dei controlli vocali",
            "paused": "Controlli in pausa.",
            "resume": "Riprendi i controlli vocali",
            "dictationPlay": "Avvia la modalità di dettatura",
            "dictationPause": "Interrompi modalità dettatura",
            "prompt": "Inizia a parlare per vedere i tuoi comandi vocali qui...",
            "dictationPrompt": "Inizia a parlare per digitare ciò che dici...",
            "latency": "Rilevata latenza elevata. Valuta la possibilità di chiudere alcune applicazioni che potrebbero consumare troppe risorse.",
            "noDeviceConnectedDescription": "Il controllo del microfono serve come anteprima dell'interfaccia. Nessun passaggio verrà eseguito correttamente. Collega questo dispositivo companion a un altro, per avviare i comandi.",
            "status": {
                "loadingModel": "Caricamento modello vocale...",
                "paused": "In pausa.",
                "dictating": "Dettare.",
                "optimistic": "Ottimista:",
                "listening": "Ascolto:",
                "thinking": "Pensiero...",
                "loadingPhiModel": "Caricamento del modello di generazione del testo...",
                "generatingText": "Generazione in corso...",
                "preparingPhiModel": "Preparazione del modello di generazione del testo...",
                "permission": "Controllo delle autorizzazioni del microfono...",
                "typing": "Sto scrivendo..."
            },
            "generatingTextDetail": "Interrompere la generazione cambiando app o dicendo \"interrompi generazione\"",
            "command": "Comando",
            "contextual": "Contestuale",
            "send": "Inviare",
            "typedInputLabel": "Digita un comando o un testo da inviare",
            "listeningPlaceholder": "Ascolto...",
            "dictationListeningPlaceholder": "Ascolto...",
            "pausedPlaceholder": "Pausa vocale..."
        },
        "edit": {
            "title": "Modifica impostazioni microfono",
            "autoStart": {
                "title": "Microfono ad avvio automatico",
                "option": "Microfono ad avvio automatico",
                "description": "All'accensione del dispositivo, la funzione si attiva automaticamente per l'ascolto dei comandi vocali. Se disattivata, toccare \"Avvia ascolto\" per attivarla."
            },
            "optimistic": {
                "title": "Comandi vocali più veloci e ottimistici",
                "option": "Comandi vocali più veloci e ottimistici",
                "description": "Rende i comandi vocali più veloci e reattivi, ma meno tolleranti. Utilizza la modalità Standard se desideri il supporto per la dettatura o una maggiore flessibilità. Nota: la modalità Ottimista potrebbe attivarsi accidentalmente se non pronunci i comandi in modo preciso."
            },
            "confirm": {
                "title": "Ci sono modifiche non salvate.",
                "description": "Sono state rilevate modifiche non salvate. Vuoi salvare prima di uscire?"
            },
            "aiCommands": {
                "title": "Comandi vocali intelligenti",
                "description": "Pronuncia i comandi in modo naturale: l'IA di Cephable capisce cosa intendi senza bisogno di una corrispondenza esatta.",
                "option": "Comandi vocali intelligenti"
            },
            "aiDictation": {
                "title": "Dettatura intelligente e digitazione rapida",
                "description": "Funzione di riconoscimento vocale migliorata con punteggiatura automatica, nomi propri e struttura delle frasi. Pronuncia `digita [qualsiasi cosa]` per utilizzare la funzione Digitazione rapida e ottenere una dettatura più intelligente e naturale.",
                "option": "Dettatura intelligente e digitazione rapida"
            },
            "description": "Gestisci i comandi vocali e le impostazioni di dettatura per questa connessione."
        },
        "warn": "Il microfono non è stato avviato. Avviare il microfono per consentire i comandi vocali e la dettatura.",
        "devices": {
            "error": "Dispositivo di input del microfono non trovato."
        },
        "startDescription": "Attiva il microfono per iniziare ad ascoltare i comandi.",
        "modes": {
            "title": "Modalità",
            "generate": {
                "label": "Generare",
                "placeholder": "Descrivi cosa vuoi generare"
            },
            "rewrite": {
                "label": "Riscrivere",
                "placeholder": "Come dovrei riscrivere il testo?"
            },
            "translate": {
                "label": "Tradurre",
                "placeholder": "Tradurre in quale lingua?"
            },
            "automate": {
                "label": "Automatizzare",
                "placeholder": "Descrivi i passaggi che desideri automatizzare"
            },
            "auto": {
                "label": "Auto",
                "placeholder": "Digita qualsiasi cosa: Cephable sceglie la modalità migliore",
                "upgrade": "Cephable necessita di {{tier}} per eseguire tale azione."
            },
            "control": {
                "label": "Controllare",
                "placeholder": "Digita un comando o un testo da inviare"
            }
        },
        "context": {
            "add": "Aggiungi contesto",
            "title": "Aggiungi contesto",
            "highlighted": "Testo evidenziato",
            "clipboard": "Appunti",
            "other": "Altro…",
            "otherTitle": "Aggiungi contesto personalizzato",
            "otherPlaceholder": "Digita o incolla il contesto da utilizzare",
            "otherConfirm": "Aggiungere",
            "otherCancel": "Cancellare",
            "remove": "Rimuovi contesto",
            "required": "Il contesto è necessario per {{mode}}",
            "files": "File…",
            "folders": "Cartelle…",
            "removeAttachment": "Rimuovere l'allegato",
            "dropToAttach": "Trascina file o cartelle per allegarli come contesto"
        }
    },
    "localization": {
        "title": "Impostazioni della lingua",
        "titleShort": "Lingua",
        "description": "Scegli la lingua preferita dall'elenco delle lingue supportate.",
        "newUserDescription": "Seleziona la lingua preferita prima di continuare.",
        "edit": "Aggiorna lingua",
        "display": {
            "title": "Lingua di visualizzazione",
            "description": "Lingua visualizzata quando si usa Cephable. Ciò include elementi come menu, notifiche e controlli delle app visualizzati nella lingua scelta."
        },
        "voice": {
            "title": "Lingua del controllo vocale",
            "description": "Questa è la lingua utilizzata per riconoscere dettati e comandi vocali. Specificare la lingua aumenta la precisione degli input vocali.",
            "settings": {
                "title": "Riconoscimento vocale e lingua di visualizzazione",
                "description": "Regola le impostazioni della lingua per i controlli di visualizzazione e vocali. Questa opzione ti consente di selezionare le lingue preferite per il testo sullo schermo e le interazioni con il microfono, come i controlli vocali e la dettatura."
            }
        },
        "locales": {
            "en": "English - Inglese",
            "en-us": "English (US) - Inglese (Stati Uniti)",
            "es": "Español — Spagnolo",
            "fr": "Français – Francese",
            "it": "Italiano",
            "de": "Deutsch - Tedesco",
            "ja": "日本語 - Giapponese",
            "en-gb": "English (UK) - Inglese (Regno Unito)",
            "en-in": "English (India) - Inglese (India)"
        },
        "save": {
            "success": "Preferenze locali dell'utente salvate!",
            "error": "Errore durante il salvataggio delle preferenze locali dell'utente"
        },
        "profile": {
            "view": "Varianti",
            "title": "Linguaggio di controllo dell'app",
            "question": "Quale linguaggio di controllo dell'app desideri modificare?",
            "description": "Alcuni controlli delle app hanno varianti per lingue diverse. Passa a un'altra lingua per modificare e personalizzare.",
            "change": "Cambia lingua"
        },
        "unsupported": {
            "title": "Lingua non supportata {{locale}}",
            "description": "La lingua selezionata non è supportata. Scegli una lingua diversa."
        },
        "select": "Seleziona la lingua",
        "localesShort": {
            "en": "Inglese",
            "en-us": "Inglese (Stati Uniti)",
            "es": "spagnolo",
            "fr": "francese",
            "it": "Italiano",
            "de": "tedesco",
            "ja": "giapponese",
            "en-gb": "Inglese (Regno Unito)",
            "en-in": "Inglese (India)"
        }
    },
    "invalidNumber": "N / A",
    "upgrade": "Aggiornamento",
    "license": {
        "trial": {
            "subtitle": "Puoi invitare {{count}} colleghi a provare Cephable insieme a te.",
            "noUsersSubtitle": "Non hai più utenti di prova. Esegui l'upgrade a una licenza a pagamento per aggiungere altri utenti.",
            "expired": {
                "user": "L'aggiornamento gratuito a {{productName}} scade il giorno {{date}}. Per effettuare l'aggiornamento, contatta l'amministratore della tua organizzazione - {{admin}}.",
                "admin": "L'aggiornamento gratuito a {{productName}} scade il {{date}}.",
                "userLong": "Sembra che il tuo upgrade gratuito a {{productName}} sia scaduto. Per effettuare l'upgrade, contatta l'amministratore della tua organizzazione - {{admin}}.",
                "adminLong": "Sembra che il tuo aggiornamento gratuito a {{productName}} sia scaduto. Puoi aggiornare la tua licenza per continuare ad accedere alle funzionalità avanzate non disponibili in Cephable Basic."
            },
            "start": "Inizia una prova gratuita",
            "title": {
                "single": "Hai effettuato l'upgrade gratuito a {{productName}} con {{days}} giorni rimanenti",
                "multiple": "{{organization}} è in prova gratuita con {{days}} giorni rimanenti"
            },
            "upgrade": "Eseguendo l'aggiornamento, potrai continuare ad accedere a funzionalità quali controlli vocali avanzati, attività intelligenti basate sull'intelligenza artificiale e numerosi controlli predefiniti delle app."
        },
        "required": {
            "title": "È richiesta la licenza professionale Cephable",
            "description": "Sembra che tu stia utilizzando Cephable Basic, che non supporta l'uso commerciale di Cephable. Aggiorna a una licenza professionale per continuare a utilizzare l'app."
        },
        "upgrade": {
            "professional": "Aggiornamento alla Licenza Cephable Professional",
            "generic": {
                "title": "Aggiorna la Tua Esperienza Cephable",
                "description": "La piattaforma Cephable offre diversi prodotti per uso commerciale sul lavoro, a scuola o integrati in soluzioni native."
            },
            "fallback": {
                "title": "Errore durante il caricamento del portale di fatturazione",
                "description": "Impossibile caricare il portale di fatturazione. Clicca sul pulsante qui sotto per contattare sales@cephable.com per continuare con l'aggiornamento."
            }
        },
        "activate": {
            "question": "Hai già una chiave di licenza?",
            "button": "Attivare",
            "title": "Attiva la Chiave di Licenza",
            "description": "Inserisci la tua chiave di licenza per aggiornare Cephable. Se non ne hai una, inizia una prova gratuita o acquista una licenza.",
            "fieldLabel": "Chiave di Licenza",
            "placeholder": "NkmurBfZzFrmm9Kx",
            "success": "Congratulazioni. Il tuo account è stato aggiornato a {{license}}!",
            "invalid": {
                "key": "Chiave non valida. Assicurati di aver inserito la chiave corretta.",
                "empty": {
                    "key": "Chiave non valida. Assicurati di aver inserito un valore.",
                    "name": "Nome dell'organizzazione non valido. Assicurati di aver inserito un valore."
                }
            },
            "descriptionLong": "Inserisci la tua chiave di licenza per aggiornare Cephable. Se non ne hai una, inizia una prova gratuita o acquista una licenza."
        },
        "welcome": {
            "title": "Benvenuti a {{license}}.",
            "description": "Ti sei unito con successo a {{organization}}. {{description}}"
        },
        "redirect": {
            "title": "Reindirizzamento",
            "description": "Sei stato reindirizzato a un portale di fatturazione esterno. Si aprirà una nuova scheda nel tuo browser. Se non vieni reindirizzato entro pochi secondi, clicca sul pulsante qui sotto.",
            "error": "Errore di reindirizzamento della fatturazione",
            "external": "Reindirizzamento. Controlla il tuo browser."
        },
        "key": {
            "title": "Chiave di licenza",
            "titlePlural": "Chiavi di licenza",
            "description": "Una chiave di licenza è un identificatore univoco utilizzato per concedere l'accesso alle funzionalità Cephable Professional, Education o Developer.",
            "details": "Dettagli della chiave di licenza",
            "assigned": "Utilizzato il: {{date}}",
            "expires": "Scade il: {{date}}",
            "assign": "Assegna la chiave alla nuova organizzazione",
            "error": "Errore durante il caricamento della chiave di licenza.",
            "empty": {
                "title": "Nessuna chiave di licenza trovata.",
                "description": "Sembra che non ci siano chiavi di licenza che corrispondono a questo criterio. Oppure non hai ancora acquistato una chiave di licenza."
            },
            "product": {
                "title": "Acquistare",
                "titleLong": "Acquista chiavi di licenza",
                "description": "Acquista una chiave di licenza per sbloccare il pieno potenziale di Cephable. Visualizza i diversi piani e le opzioni di prezzo disponibili.",
                "action": "Acquista ora",
                "empty": {
                    "title": "Nessun prodotto trovato.",
                    "description": "Sembra che tu non abbia alcun prodotto. Contatta il nostro team di vendita o il tuo rappresentante per risolvere il problema."
                },
                "yearly": "Fatturato annualmente",
                "years": "Fatturato ogni {{value}} anni",
                "days": "Fatturato ogni {{value}} giorni",
                "Subscription": {
                    "title": "Sottoscrizione"
                },
                "MeteredConsumption": {
                    "title": "Consumo misurato"
                },
                "PayDown": {
                    "title": "Pagare in anticipo"
                },
                "OneTime": {
                    "title": "Una volta"
                }
            }
        },
        "pro": {
            "tag": "Professionista",
            "detail": "Questa è una funzionalità esclusiva di Cephable Professional",
            "requiredDetail": "Per questa funzionalità è richiesta una licenza Cephable Professional. Puoi effettuare l'upgrade o iniziare una prova gratuita nelle Impostazioni account"
        },
        "titlePlural": "Licenze"
    },
    "purchase": "Acquistare",
    "saveError": "Errore durante il salvataggio delle modifiche.",
    "description": "Descrizione",
    "expand": "Espandere",
    "expandMenu": "Espandi Menu",
    "editor": {
        "title": "Editor di markdown",
        "bold": "Grassetto",
        "italic": "Corsivo",
        "underline": "Sottolineare",
        "hr": "Regola orizzontale",
        "link": "Collegamento",
        "quote": "Citazione",
        "code": "Codice",
        "codeBlock": "Blocco di codice",
        "comment": "Commento",
        "image": "Immagine",
        "table": "Tavolo",
        "unordered-list": "Elenco non ordinato",
        "ordered-list": "Elenco ordinato",
        "checked-list": "Elenco controllato",
        "help": "Aiuto",
        "edit": "Modificare",
        "live": "Vivere",
        "preview": "Anteprima",
        "fullscreen": "A schermo intero",
        "placeholder": "Inserisci qui il testo Markdown...",
        "strikethrough": "Barrato"
    },
    "created": "Creato: {{value}}",
    "updated": "Aggiornato: {{value}}",
    "deleted": "Eliminato: {{value}}",
    "expires": "Scade: {{value}}",
    "expired": "Scaduto: {{value}}",
    "used": "Utilizzato: {{value}}",
    "results": "Risultati",
    "panel": {
        "title": "Pannello Cefabile",
        "question": "Pannello di avvio automatico?",
        "position": {
            "top": "Superiore",
            "right": "Giusto",
            "left": "Sinistra",
            "bottom": "Metter il fondo a ",
            "description": "Seleziona dove desideri che il pannello Cephable venga visualizzato sullo schermo.",
            "label": "Posizione"
        },
        "sections": {
            "description": "Scegli quali sezioni del pannello rendere visibili. Puoi nascondere le sezioni in base alle tue preferenze per sfruttare al meglio lo spazio del pannello.",
            "microphone": "Microfono e controlli vocali",
            "camera": "Controlli della telecamera e del viso/testa",
            "profile": "Controlli e anteprime delle app",
            "globalControls": "Controlli globali e del dispositivo",
            "tasks": "Compiti intelligenti",
            "buttons": "Pulsanti di azione rapida"
        },
        "titleShort": "Pannello",
        "description": "Questo è il pannello che rappresenta il centro di controllo principale. È sempre visibile e ti consente di controllare le tue app tramite comandi vocali, e altro ancora.",
        "reconnecting": "Riconnessione…",
        "reconnectRetry": "Riprova"
    },
    "resume": "Riprendere",
    "textGeneration": {
        "settings": "Impostazioni di generazione del testo",
        "edit": {
            "title": "Modifica impostazioni generazione testo",
            "description": "Puoi perfezionare le impostazioni della Generazione intelligente di testo per ottenere gli output migliori per te.",
            "autoStart": {
                "title": "Generazione automatica del testo di riscaldamento",
                "description": "Con questa impostazione attivata, Cephable AI preriscalda automaticamente i modelli di intelligenza artificiale utilizzati per le attività di creazione o automazione. Il preriscaldamento dei modelli ne velocizzerà le prestazioni, ma consumerà più risorse del computer. Disattivando questa impostazione si risparmieranno risorse, ma le attività potrebbero risultare più lente.",
                "option": "Modelli di intelligenza artificiale che generano testo con riscaldamento automatico?"
            },
            "prompt": {
                "title": "Informazioni aggiuntive per la generazione di testo",
                "description": "Inserisci dettagli aggiuntivi da utilizzare con l'IA di Cephable per generare testo. Utilizza questo campo per inserire le preferenze per il tono, lo stile di scrittura o altri dettagli.",
                "field": "Richiesta aggiuntiva",
                "placeholder": "ad esempio, usa un tono amichevole, scrivi come un professionista, sii succinto e diretto. Quando scrivi codice, lascia commenti ponderati ma non troppi, ecc."
            },
            "enableTextGen": {
                "title": "Abilita la generazione intelligente del testo",
                "description": "Con questa impostazione attivata, Cephable AI può redigere, riscrivere, riassumere e tradurre contenuti, oppure automatizzare azioni desktop nelle tue applicazioni.",
                "option": "Utilizzare la generazione intelligente di testo?"
            },
            "terminate": {
                "title": "Clear AI Resources",
                "description": "Fai clic per cancellare le risorse utilizzate per le attività di creazione o automazione. In questo modo verranno liberate risorse sul computer, ma queste attività potrebbero risultare più lente al successivo utilizzo.",
                "button": "Risorse chiare",
                "success": "Cancellazione delle risorse di generazione del testo.",
                "confirm": {
                    "title": "Clear AI Resources",
                    "description": "Sei sicuro di voler cancellare le risorse utilizzate per le attività di creazione o automazione? In questo modo verranno liberate risorse sul computer, ma queste attività potrebbero risultare più lente al successivo utilizzo.",
                    "confirm": "Sì, risorse chiare",
                    "cancel": "Cancellare"
                }
            },
            "clearModelCache": {
                "title": "Cancella la cache dei modelli di IA",
                "description": "In questo modo verrà liberato spazio di archiviazione sul computer e verrà scaricato nuovamente il modello attualmente selezionato.",
                "button": "Cancella e scarica di nuovo",
                "success": "File del modello locale eliminati.",
                "confirm": {
                    "title": "Cancella e scarica nuovamente la cache del modello AI",
                    "description": "Sei sicuro di voler cancellare la cache del modello AI ed eliminare i file dal tuo sistema? Il modello attualmente selezionato verrà scaricato nuovamente automaticamente.",
                    "confirm": "Sì, cancella e scarica di nuovo",
                    "cancel": "Cancellare"
                },
                "error": "Errore durante l'eliminazione dei file del modello locale."
            },
            "enableHistory": {
                "title": "Abilita cronologia generazione testo",
                "description": "Se questa impostazione è attivata, Cephable AI utilizzerà la cronologia di generazione del testo per generare testo con il contesto dell'azione precedente.",
                "option": "Utilizzare la cronologia di generazione del testo?"
            },
            "modelSelection": {
                "title": "Modello di intelligenza artificiale",
                "description": "Scegli la famiglia di modelli di intelligenza artificiale e le dimensioni compatibili con questo dispositivo. I modelli più grandi producono risultati migliori, ma consumano più risorse. Scarica più modelli per passare rapidamente da uno all'altro.",
                "family": "Famiglia modello",
                "size": "Dimensioni del modello",
                "downloaded": "Scaricato",
                "downloading": "Download in corso…",
                "download": "Scaricamento",
                "delete": "Elimina il download",
                "unavailable": "Non supportato su questo dispositivo",
                "requiresBetterDevice": "Questo modello richiede un dispositivo più potente per funzionare.",
                "selectPrompt": "Seleziona un modello",
                "noModels": "Al momento non sono disponibili modelli compatibili con questo dispositivo.",
                "deleteConfirm": {
                    "title": "Eliminare il modello scaricato?",
                    "description": "In questo modo si libera spazio sul disco. Potrai scaricarlo di nuovo in seguito."
                },
                "notDownloaded": "Questo modello è stato selezionato ma non è ancora stato scaricato. Fai clic su Scarica per utilizzarlo.",
                "readyToUse": "Scaricato — pronto all'uso",
                "offlineNoModels": "Non sei connesso a Internet e su questo dispositivo non sono ancora stati salvati modelli. Connettiti per visualizzare e scaricare i modelli disponibili.",
                "offlineDownloadUnavailable": "Non sei connesso a Internet, quindi questo modello non può essere scaricato. Connettiti a Internet per scaricarlo oppure passa a un modello che hai già scaricato.",
                "license": {
                    "upgrade": "Richiede un aggiornamento della licenza",
                    "blockedNeedsDownload": "Questo modello richiede {{license}}. Scarica un modello precedente o esegui l'aggiornamento per continuare."
                },
                "notEnoughSpace": "Spazio insufficiente sul dispositivo",
                "notEnoughSpaceDetail": "Richiede {{required}} ma su questo dispositivo è disponibile solo {{free}}. Libera spazio e riprova.",
                "fallback": {
                    "alert": "Viene utilizzato {{fallback}} al posto di {{preferred}}, il che richiede un aggiornamento.",
                    "active": "{{preferred}} richiede {{license}}. {{fallback}} viene utilizzato al suo posto finché non si sceglie un modello diverso o si effettua un aggiornamento."
                }
            }
        },
        "prompt": {
            "systemPrompt": "Genera SOLO il testo richiesto, senza spiegazioni, commenti o divagazioni. Non sono ammessi markdown o spiegazioni non richiesti. Per il codice, genera solo codice grezzo: senza delimitatori, tag di linguaggio o spiegazioni. Non spiegare cosa hai fatto.",
            "appName": "Al momento stai generando testo per {{appName}}.",
            "userPreferences": "Rispettare le seguenti preferenze utente su come desidera che venga generato il testo: {{userPreferences}}."
        },
        "translatePrompt": {
            "systemPrompt": "Traduci il seguente testo in {{language}}. Visualizza SOLO il testo tradotto. Nessuna spiegazione, nessun preambolo, nessuna formattazione Markdown, nessuna barriera di codice, nessuna nota, nessuna osservazione tra parentesi sulla traduzione. Mantieni la formattazione. Per il codice: traduci solo commenti e stringhe, preserva la sintassi esattamente.",
            "userPreferences": "Rispettare le seguenti preferenze utente su come desidera che venga generato il testo: {{userPreferences}}.",
            "genericUserPrompt": "Traduci: {{userRequestText}}"
        },
        "disabled": {
            "title": "Le attività intelligenti sono disabilitate",
            "description": "Sembra che tu abbia disabilitato le attività intelligenti. Aggiorna per sbloccare la generazione di testo, la riscrittura e altro ancora nelle impostazioni."
        },
        "skipTyping": {
            "complete": "Generazione completata e pronta per essere copiata negli appunti."
        },
        "summarizePrompt": {
            "systemPrompt": "Riassumi in modo conciso il testo fornito. Può far parte di un documento più ampio. Non utilizzare la formattazione Markdown o i blocchi di codice. Pubblica SOLO il riassunto: nessun preambolo, etichette, spiegazione o commento, e non descrivere le operazioni eseguite.",
            "userPreferences": "Rispetta le preferenze dell'utente relative alla modalità di generazione del testo: {{userPreferences}}.",
            "summarizeInstructions": "Istruzioni: {{summarizeInstructions}}.",
            "userPrompt": "Riepilogo: {{userRequestText}}"
        },
        "rewritePrompt": {
            "systemPrompt": "Riscrivi o riformatta il testo fornito come indicato. In caso di riformattazione (ad esempio, elenchi, tabelle, modifiche alla struttura), conserva esattamente le parole originali. In caso di riscrittura (ad esempio, tono, stile, lunghezza), conserva il significato ma non necessariamente le parole. Questo testo può far parte di un documento più ampio. Mantieni la formattazione del testo di partenza: se il testo sorgente è già in Markdown o codice, conservalo. Altrimenti, non introdurre la formattazione Markdown (titoli, grassetto, elenchi puntati, delimitatori di codice) a meno che le istruzioni non richiedano esplicitamente un elenco, una tabella o una struttura simile. Pubblica SOLO il risultato finale, senza preamboli, etichette, titoli, spiegazioni o commenti.",
            "userPreferences": "Rispetta le preferenze dell'utente relative alla modalità di generazione del testo: {{userPreferences}}.",
            "rewriteInstructions": "Istruzioni: {{rewriteInstructions}}."
        }
    },
    "profile": {
        "title": "Controlli dell'app",
        "titlePlural": "Controlli dell'app",
        "titlePreview": "Anteprima dei controlli",
        "previous": "Controlli app precedenti",
        "manage": "Gestisci i controlli delle app",
        "view": "Visualizza controlli",
        "edit": "Modifica controlli app",
        "add": "Aggiungi controlli app",
        "create": "Crea controlli app",
        "warn": "Per poter utilizzare i controlli dell'app, è necessario che la fotocamera o il microfono siano attivi.",
        "descriptionShort": "Scopri i diversi modi in cui Cephable ti aiuta a controllare i tuoi dispositivi e software.",
        "name": "Nome dell'app",
        "nameQuestion": "Come vuoi chiamare questi controlli dell'app?",
        "newName": "Nuovi controlli dell'app",
        "search": "Cerca i controlli dell'app per nome",
        "searchLong": "Cerca i controlli dell'app per nome o descrizione",
        "keyboardAndMouse": "Tastiera e mouse",
        "genericController": "Controllore del gamepad",
        "keyboardMouseAndController": "Tastiera, mouse e controller",
        "permissionError": "Non hai l'autorizzazione per utilizzare questi controlli dell'app.",
        "set": {
            "title": "Sembra che non hai ancora impostato i controlli dell'app.",
            "cta": "Imposta i controlli dell'app",
            "empty": {
                "auto": "Passa a un'altra app per vedere i controlli",
                "select": "Seleziona un controllo per iniziare",
                "none": "Nessun controllo dell'app trovato"
            },
            "description": "I controlli delle app consentono a Cephable di sapere cosa ascoltare e quali azioni intraprendere. Puoi cambiare i controlli delle app in qualsiasi momento dalla homepage o dalle impostazioni di connessione."
        },
        "summary": {
            "title": "Riepilogo dei controlli dell'app",
            "descriptionLong": "Ecco i dettagli di questi controlli app. Puoi cercare controlli, azioni e altro per vedere cosa puoi fare con questi controlli app.",
            "description": "Ottieni un riepilogo di questi controlli dell'app, inclusi i controlli disponibili, le personalizzazioni, i dettagli e altro ancora.",
            "view": "Visualizza il riepilogo dei controlli dell'app",
            "filter": "Filtra per tipo di input",
            "placeholder": "Cerca nomi di controllo..."
        },
        "copy": {
            "title": "Copia controlli app",
            "duplicate": "Controlli app duplicati",
            "question": "Creare una copia?",
            "description": "Vuoi creare una nuova copia di questi controlli app? Si aprirà una nuova finestra con questi controlli app copiati, ma non verranno aggiunti al tuo account finché non li salvi.",
            "confirm": "Sì, crea una copia",
            "profileSuffix": "{{name}} (copia)"
        },
        "new": {
            "title": "Crea nuovi controlli app",
            "description": "Crea controlli da zero o lascia che l'intelligenza artificiale all'avanguardia generi controlli personalizzati, consentendoti di usare app e software senza sforzo, usando la voce, i gesti della testa e del viso.",
            "note": "Consigliato per utenti avanzati.",
            "scratch": "Crea da zero"
        },
        "advancedOptions": "Opzioni di controllo avanzate",
        "delete": {
            "title": "Elimina i controlli dell'app",
            "titleLong": "Elimina questi controlli dell'app",
            "description": "Puoi eliminare questi controlli app cliccando su \"Elimina controlli app\".",
            "confirm": "Sei sicuro di voler eliminare questi controlli dell'app?",
            "confirmLong": "Una volta eliminati questi controlli app, non potrai più tornarci. Vuoi davvero eliminare questi controlli app?",
            "confirmButton": "Sì, elimina questi controlli dell'app"
        },
        "current": "Controlli attuali",
        "loading": "Caricamento controlli...",
        "null": "Non hai ancora controlli app. Clicca qui sotto per crearne uno.",
        "nullButton": "Crea i tuoi primi controlli app",
        "preview": "Anteprima",
        "features": "Caratteristiche",
        "byline_public": "Di: Cephable Team",
        "byline_shared": "Condiviso da: Comunità Cephable",
        "share": {
            "title": "Condividi i controlli dell'app",
            "previewTitle": "Anteprima dei controlli delle app condivise",
            "description": "Condividi questi controlli dell'app con altri in modo che possano averne una copia e personalizzarli!",
            "descriptionLong": "Condividi questi controlli app con altri in modo che possano ottenere una copia e personalizzarli da lì! Scegli come vuoi condividere, quindi crea un collegamento da inviare ad altri.",
            "add": "Crea un collegamento di condivisione",
            "confirm": "Condividi questo URL",
            "link": "Condividi collegamento",
            "copy": "Copia collegamento",
            "copied": "Copiato!",
            "usage": "Quantità di utilizzo",
            "created": "Creato {{value}}",
            "expiration": {
                "title": "Scadenza",
                "once": "Consentire solo un utilizzo",
                "unlimited": "Consentire un utilizzo illimitato",
                "no": "Nessuna scadenza",
                "date": "Data di scadenza",
                "dateDescription": "Scadenza in una data specifica"
            },
            "manage": "Gestisci i link di condivisione precedenti",
            "empty": "Non sono state create condivisioni per questi controlli dell'app."
        },
        "swap": {
            "title": "Controlli di scambio",
            "titleLong": "Scambia i controlli delle tue app",
            "descriptionShort": "Utilizza diversi controlli dell'app in base al programma o al software che stai utilizzando.",
            "description": "È possibile alternare i diversi controlli delle app in base al programma o al software in uso."
        },
        "autoProfileSwitching": {
            "title": "Commutazione automatica del controllo",
            "alerts": {
                "disabled": "La commutazione automatica del controllo è disattivata.",
                "temporarilyDisabled": "La commutazione automatica del controllo è temporaneamente disattivata.",
                "enabled": "La commutazione automatica del controllo è attivata.",
                "error": "Errore durante il salvataggio delle preferenze di commutazione del controllo automatico"
            },
            "associatedPrograms": {
                "add": "Aggiungi un nuovo programma associato",
                "description": {
                    "personal": "Scegli il software o i programmi che vuoi connettere a questi controlli. Questo supporta la commutazione automatica dei controlli, in cui Cephable commuta automaticamente questi controlli delle app per adattarli al programma corrente che stai utilizzando.",
                    "short": "Seleziona il software o i programmi che desideri connettere a questi controlli."
                },
                "edit": "Modifica programmi associati",
                "noOptionsText": "Inizia a digitare per trovare i programmi associati",
                "profileLabel": "Controlli dell'app:",
                "remove": "Rimuovi programma associato",
                "title": "Programmi associati",
                "when": "Cephable cambierà automaticamente i controlli della mia app in {{profileName}} quando utilizzo...",
                "emptySearch": "Non ci sono programmi associati a questi controlli.",
                "error": "Errore durante il salvataggio dei programmi associati. Riprova più tardi.",
                "emptyError": "Rilevato programma associato vuoto. Rimuoverlo prima di continuare."
            },
            "commandOverlay": {
                "command": "Cambiare i controlli dell'app: {{value}}"
            },
            "description": "La commutazione automatica dei controlli consente a Cephable di adattarsi perfettamente al tuo flusso di lavoro. Se attivata, Cephable regolerà contestualmente i controlli dell'app in base al programma o al software in uso. Se disattivata, puoi cambiare manualmente i controlli dell'app utilizzando il pulsante \"Cambia controlli\" o i comandi globali."
        },
        "error": {
            "noMatch": "Nessun controllo app corrisponde alla tua ricerca.",
            "load": "Errore durante il caricamento dei controlli dell'app.",
            "add": "Errore durante l'aggiunta dei controlli dell'app.",
            "delete": "Errore durante l'eliminazione dei controlli dell'app.",
            "audioEventsWithEmptyCommands": "Mancano dei controlli nel tuo talk back. Controlla i controlli del tuo talk back per assicurarti di compilarlo completamente.",
            "conflicts": "Errore durante il salvataggio dei controlli dell'app a causa di conflitti.",
            "save": "Errore durante il salvataggio dei controlli dell'app. Riprova.",
            "device": "Controllo app non valido per questa connessione. Provane un altro."
        },
        "conflictIndicators": {
            "errorTitle": "Errore durante il salvataggio dei controlli dell'app a causa di conflitti",
            "warningTitle": "Controlli dell'app salvati con avvisi",
            "subtitle": "I controlli dell'app creati presentano alcune configurazioni che potrebbero creare conflitti.",
            "profileNameErrors": "Conflitto di nomi dei controlli app",
            "emptyControlsMapped": "Nomi di input vuoti",
            "emptyControlsMappedDescription": "Aggiungi un comando vocale, un'espressione facciale, un'inclinazione della testa o un altro comando al tuo input.",
            "emptyKeybindingControlsMapped": "Nomi di input vuoti per le combinazioni di tasti",
            "emptyKeybindingControlsMappedDescription": "Aggiungi un comando vocale, un'espressione facciale, un'inclinazione della testa o un altro comando all'input per le associazioni di tasti.",
            "duplicateNameTitle": "Nome dei controlli app duplicati",
            "duplicateNameDescription": "Hai già un controllo app con lo stesso nome. Cambia il nome prima di continuare.",
            "emptyNameTitle": "Nome dei controlli dell'app vuoto",
            "emptyNameDescription": "I controlli dell'app devono avere un nome, ad esempio Gioco 1, Spotify, Word, ecc.",
            "macrosReleaseKeysMissingTitle": "Uscite con tasti non rilasciati",
            "macrosReleaseKeysMissingDescription": "Aggiungere una chiave di sblocco o interrompere tutti i passaggi per evitare che i tasti rimangano incastrati.",
            "duplicateInputCommandMacroTitle": "Input di controllo identici",
            "duplicateCommandsDescription": "Si prega di rimuovere o modificare i comandi di input duplicati.",
            "duplicateInputCommandBindingsTitle": "Input di controllo identici per le associazioni di tasti",
            "conflictIndicatorDisplayString": "{{container}} : {{commandOrKeyName}} con {{commandOrEventType}}",
            "duplicateMacroNames": "Nomi di controllo duplicati",
            "duplicateMacroNamesDescription": "Si prega di rimuovere o modificare uno dei nomi di controllo identici.",
            "warningIgnore": "Ignorare",
            "warningDoNotShowAgain": "Non mostrare più gli avvisi",
            "macrosVoiceCommandConflictWithDictationTitle": "Controlla i comandi vocali come le parole chiave della dettatura",
            "keybindingsVoiceCommandConflictWithDictationTitle": "I comandi vocali delle associazioni di tasti sono gli stessi delle parole chiave della dettatura",
            "macrosVoiceCommandConflictWithDictationDescription": "I tuoi input vocali attiveranno la dettatura e i comandi vocali.",
            "keybindingsVoiceCommandConflictWithDictationDescription": "I tuoi input vocali attiveranno la dettatura e la pressione dei tasti.",
            "macrosVoiceCommandConflictWithGenerationTitle": "I comandi vocali di controllo sono gli stessi delle parole chiave di generazione",
            "keybindingsVoiceCommandConflictWithGenerationTitle": "I comandi vocali delle associazioni di tasti sono gli stessi delle parole chiave di generazione",
            "macrosVoiceCommandConflictWithGenerationDescription": "I tuoi input vocali attiveranno la generazione e i comandi vocali.",
            "keybindingsVoiceCommandConflictWithGenerationDescription": "I tuoi input vocali attiveranno la generazione e la pressione dei tasti.",
            "duplicateAssociatedProgramNames": "Nomi di programmi associati duplicati",
            "duplicateAssociatedProgramNamesDescription": "Si prega di rimuovere o modificare uno dei programmi identici associati.",
            "emptyEvent": {
                "title": "Passaggi mancanti",
                "description": "Ci sono dei passaggi mancanti nei tuoi controlli. Questo potrebbe portare Cephable a non eseguire un'azione quando dai un comando."
            },
            "warningDetails": "Visualizza tutti i conflitti"
        },
        "success": {
            "save": "Controlli dell'app salvati.",
            "add": "Aggiunti controlli app.",
            "delete": "Controlli dell'app eliminati.",
            "share": "Condividi il collegamento creato e copiato negli appunti",
            "shareDelete": "Link di condivisione eliminato.",
            "generate": "Controlli dell'app generati."
        },
        "warning": "Controlli dell'app salvati con avvisi",
        "customize": "Personalizza i controlli dell'app",
        "custom": "{{name}} (personalizzato)",
        "description": "I controlli app sono un insieme di controlli che puoi utilizzare per gestire il tuo dispositivo o la tua connessione. Puoi creare più controlli app e passare da uno all'altro quando vuoi."
    },
    "publicProfiles": {
        "toolbar": "Esplora i controlli delle app",
        "title": "Esplora i controlli delle app",
        "offline": {
            "title": "Impossibile caricare i controlli dell'app pubblica",
            "description": "Sembra che tu sia offline. Puoi comunque usare i controlli dell'app, ma non sarai in grado di caricare nuovi controlli dell'app pubblici.",
            "confirm": "Va bene"
        },
        "announcement": "{{count}} Sono stati caricati nuovi controlli app",
        "description": {
            "personal": "Sono disponibili controlli app pubblici per aiutarti a iniziare rapidamente a usare Cephable sulle tue app preferite. Puoi usare i controlli predefiniti, personalizzarli in base alle tue esigenze o creare controlli app personalizzati completamente nuovi da zero.",
            "pro": "Sono disponibili controlli app pubblici per aiutarti a iniziare rapidamente a usare Cephable sulle tue app preferite. Puoi usare i controlli predefiniti, personalizzarli in base alle tue esigenze o creare controlli app personalizzati completamente nuovi tramite il generatore di controlli."
        },
        "team": "Squadra Cefabile"
    },
    "publicTag": "Pubblico",
    "tray": {
        "panel": "Pannello di attivazione/disattivazione",
        "dashboard": "Mostra dashboard",
        "quit": "Smettila di Cephable"
    },
    "generate": "Generare",
    "stop": "Fermare",
    "clear": "Chiaro",
    "rewrite": "Riscrivere",
    "translate": "Tradurre",
    "smartTasks": {
        "title": "Compiti intelligenti",
        "show": "Mostra attività intelligenti",
        "description": "Le attività intelligenti sono le diverse attività che l'intelligenza artificiale di Cephable può svolgere per te. Queste attività sono basate sull'intelligenza artificiale integrata nel dispositivo e possono essere utilizzate per creare testi, riassumere, riscrivere, tradurre, prendere appunti e chattare con i documenti.",
        "generateText": {
            "title": "Genera testo",
            "description": "Crea contenuti di testo in base ai tuoi input o ai tuoi prompt.",
            "label": "Descrivi cosa vuoi generare"
        },
        "summarizeText": {
            "title": "Riassumere il testo",
            "description": "Ricava informazioni utili da testi lunghi e crea brevi riassunti o evidenzia i punti chiave.",
            "directions": "Inserisci il testo da riassumere, altrimenti Cephable utilizzerà automaticamente il testo evidenziato.",
            "titleShort": "Riassumere",
            "write": "Scrivi un riassunto",
            "label": "Come vorresti riassumere o condensare il testo?",
            "outputLabel": "Il tuo riepilogo apparirà qui.",
            "inputLabel": "Inserisci il testo da condensare"
        },
        "rewriteText": {
            "title": "Riscrivi il testo",
            "description": "Evidenzia il testo in un'altra app in cui stai scrivendo, quindi torna qui e descrivi come vuoi che venga riscritto.",
            "label": "Descrivi come vuoi riscrivere il testo",
            "inputLabel": "Inserisci il testo da riscrivere"
        },
        "translateText": {
            "title": "Traduci testo",
            "description": "Inserisci il testo da tradurre, altrimenti Cephable utilizzerà automaticamente il testo evidenziato.",
            "label": "Inserisci il testo da tradurre",
            "languageLabel": "Lingua da tradurre"
        },
        "noteTaker": {
            "title": "Prenditore di appunti",
            "description": "Lascia che Cephable registri e trascriva localmente le tue riunioni o conversazioni"
        },
        "documentChat": {
            "title": "Chat sui documenti",
            "description": "Interagisci con i documenti e interrogali per ottenere informazioni rapide."
        },
        "highlightText": {
            "title": "Usa il testo evidenziato",
            "description": "Cephable può utilizzare automaticamente il testo evidenziato in qualsiasi app per eseguire operazioni come riassumere, riscrivere o tradurre. Puoi anche inserire il testo manualmente, se preferisci.",
            "label": "Inserisci il testo da utilizzare",
            "placeholder": "Puoi anche evidenziare il testo in un'altra app e tornare qui per utilizzarlo.",
            "noTextFound": "Nessun testo trovato. Seleziona il testo in un'altra app oppure incollalo nel campo e riprova."
        },
        "pasteText": {
            "title": "Incolla il testo",
            "description": "Cephable può utilizzare automaticamente il testo copiato negli appunti per eseguire attività come riassumere, riscrivere o tradurre. Puoi anche inserire il testo manualmente, se preferisci.",
            "label": "Inserisci il testo da utilizzare",
            "placeholder": "Puoi anche evidenziare il testo in un'altra app e tornare qui per utilizzarlo."
        },
        "clearCache": "Se riscontri problemi durante la generazione, cancella la cache e le risorse dalle impostazioni di generazione del testo e riprova.",
        "transcribeAudio": {
            "title": "Trascrivi audio",
            "description": "Converti file audio o video in testo utilizzando la trascrizione AI.",
            "inputMethod": "Scegli il metodo di input",
            "localFile": "File locale",
            "url": "URL",
            "selectFile": "Seleziona file audio/video",
            "urlLabel": "URL audio/video",
            "transcribe": "Trascrivere",
            "result": "Risultato della trascrizione",
            "invalidFileType": "Seleziona un file audio o video valido (mp3, wav, ogg, mp4, webm, mov, avi)",
            "error": "Errore di trascrizione",
            "history": {
                "title": "Cronologia della trascrizione",
                "description": "Visualizza e gestisci le trascrizioni salvate.",
                "viewHistory": "Visualizza cronologia",
                "empty": "Nessuna trascrizione ancora. Inizia a trascrivere per costruire la tua storia!",
                "titleLabel": "Titolo (facoltativo)",
                "titlePlaceholder": "Inserisci un titolo per questa trascrizione",
                "textLabel": "Testo di trascrizione",
                "confirmDelete": "Sei sicuro di voler eliminare questa trascrizione?"
            }
        },
        "aiWorkflows": {
            "description": "Automatizza le attività del tuo desktop e del tuo browser con l'intelligenza artificiale. Descrivi semplicemente cosa vuoi realizzare e guarda Cephable eseguire le azioni per te.",
            "label": "Descrivi cosa vuoi realizzare",
            "status": {
                "idle": "In attesa delle tue istruzioni...",
                "initializing": "Preparando tutto...",
                "planning": [
                    "Fare un piano...",
                    "Analizziamo la tua richiesta...",
                    "Mappatura dei passaggi...",
                    "Organizzazione del flusso di lavoro...",
                    "Preparazione della strategia...",
                    "Creare un piano d'azione...",
                    "Scoprire il modo migliore per aiutarti...",
                    "Determinare come affrontare questo...",
                    "Analisi della tua richiesta in corso...",
                    "Pianificazione dell'esecuzione..."
                ],
                "thinking": [
                    "Pensiero...",
                    "Analisi della tua richiesta in corso...",
                    "Scoprire il modo migliore per aiutarti...",
                    "Decidere cosa fare dopo...",
                    "Elaborazione dei passaggi precedenti...",
                    "Stiamo lavorando alla tua richiesta...",
                    "Recupero dettagli in corso...",
                    "Revisione del piano...",
                    "Considerando le opzioni...",
                    "Creare, valutare, decidere..."
                ],
                "waitingForUser": "Il tuo contributo è necessario per continuare.",
                "completed": "Successo!",
                "failed": "La tua richiesta non è andata a buon fine: {{message}}",
                "canceled": "La tua richiesta è stata annullata.",
                "terminated": "Fermo. Attendo istruzioni...",
                "thinkingInteractive": [
                    "Considerando il passo successivo...",
                    "Rivediamo cosa abbiamo fatto finora...",
                    "Decidere cosa fare dopo...",
                    "Analizzando i risultati...",
                    "Pianificando la continuazione...",
                    "Valutando le opzioni...",
                    "Cercando di capire qual è il passo successivo migliore...",
                    "Stiamo lavorando alla parte successiva della tua richiesta...",
                    "Stiamo lavorando ai prossimi passi...",
                    "Elaborazione dei risultati del passaggio precedente..."
                ],
                "tools": {
                    "click_element_by_index": {
                        "executing-start": "Cliccando sul pulsante corrispondente...",
                        "executing-complete": "Ho cliccato su {{params.index}}."
                    },
                    "click_element": {
                        "executing-start": "Cliccando sul numero evidenziato...",
                        "executing-complete": "Ho cliccato su {{params.elementName}}."
                    },
                    "copy_selection": {
                        "executing-start": "Raccolta del contesto...",
                        "executing-complete": "Ho il contesto pronto per la parte successiva della tua richiesta."
                    },
                    "draft_email": {
                        "executing-start": "Bozza di un'e-mail...",
                        "executing-complete": "Ho scritto una bozza di email su {{params.subject}}."
                    },
                    "execute_app_action": {
                        "executing-start": "Esecuzione di {{params.actionName}}...",
                        "executing-complete": "{{params.actionName}} completato."
                    },
                    "find_all_text": {
                        "executing-start": "Ricerca di tutto il contesto rilevante su {{params.searchText}}...",
                        "executing-complete": "Ho trovato tutto il contesto rilevante su {{params.searchText}}."
                    },
                    "find_and_select_text": {
                        "executing-start": "Ricerca e selezione del contesto rilevante su {{params.searchText}}...",
                        "executing-complete": "Ho trovato e selezionato il contesto pertinente su {{params.searchText}}."
                    },
                    "generate_text": {
                        "executing-start": "Creazione di contenuti...",
                        "executing-progress": "Creazione di contenuti...{{progress}}%",
                        "executing-complete": "Ho creato il contenuto richiesto."
                    },
                    "get_all_interactive_elements": {
                        "executing-start": "Scansione per ottenere più contesto...",
                        "executing-complete": "Capisco con cosa posso interagire."
                    },
                    "get_all_text_elements_content": {
                        "executing-start": "Leggendo per avere più contesto...",
                        "executing-complete": "Ho capito quali contenuti testuali sono disponibili."
                    },
                    "get_all_text_elements_names": {
                        "executing-start": "Leggendo per avere più contesto...",
                        "executing-complete": "Ho capito quali contenuti testuali sono disponibili."
                    },
                    "get_available_profile_actions": {
                        "executing-start": "Verifica quali controlli sono disponibili in questa app...",
                        "executing-complete": "Ho capito cosa posso fare con questa app."
                    },
                    "get_document_content": {
                        "executing-start": "Leggendo per avere più contesto...",
                        "executing-complete": "Ho il contesto pronto per la parte successiva della tua richiesta."
                    },
                    "get_installed_apps": {
                        "executing-start": "Decidere quale app è rilevante per la tua richiesta...",
                        "executing-complete": "So quali app posso usare."
                    },
                    "get_running_app_names": {
                        "executing-start": "Decidere quale app è rilevante per la tua richiesta...",
                        "executing-complete": "So quali app posso usare."
                    },
                    "get_selected_text": {
                        "executing-start": "Lettura del contenuto selezionato...",
                        "executing-complete": "Ho un contesto sul contenuto selezionato."
                    },
                    "get_stored_content": {
                        "executing-start": "Raccolta del contesto...",
                        "executing-complete": "Ho il contesto pronto per la parte successiva della tua richiesta."
                    },
                    "keyboard_shortcut": {
                        "executing-start": "Raccolta del contesto...",
                        "executing-complete": "Ho il contesto pronto per la parte successiva della tua richiesta."
                    },
                    "open_app": {
                        "executing-start": "Apertura di {{params.appName}}...",
                        "executing-complete": "Ho aperto {{params.appName}}."
                    },
                    "open_webpage": {
                        "executing-start": "Apertura di {{params.url}}...",
                        "executing-complete": "Ho aperto {{params.url}}."
                    },
                    "paste_content": {
                        "executing-start": "Scrivere...",
                        "executing-complete": "Ho finito di scrivere."
                    },
                    "respond_to_user": {
                        "executing-start": "Completamento della richiesta in corso...",
                        "executing-complete:": "Ho completato la tua richiesta."
                    },
                    "search_browser": {
                        "executing-start": "Ricerca sul Web di {{params.query}}...",
                        "executing-complete": "Ho cercato sul web {{params.query}}."
                    },
                    "select_all_text": {
                        "executing-start": "Selezione di tutto il testo...",
                        "executing-complete": "Ho selezionato tutto il testo."
                    },
                    "summarize_text": {
                        "executing-start": "Riassumendo il testo...",
                        "executing-progress": "Riassumendo...{{progress}}%",
                        "executing-complete": "Ho riassunto il testo."
                    },
                    "translate_text": {
                        "executing-start": "Traduzione del testo in {{params.targetLanguage}}...",
                        "executing-progress": "Traduzione in corso...{{progress}}%",
                        "executing-complete": "Ho tradotto il testo in {{params.targetLanguage}}."
                    },
                    "type_stored_content": {
                        "executing-start": "Scrivere...",
                        "executing-complete": "Ho finito di scrivere."
                    },
                    "type_text": {
                        "executing-start": "Scrivere...",
                        "executing-complete": "Ho finito di scrivere."
                    },
                    "unknown": {
                        "executing-start": "Ho riscontrato un problema, provando una strategia diversa...",
                        "executing-complete": "Ho provato una strategia diversa."
                    },
                    "append_to_file": {
                        "executing-start": "Aggiunta al file...",
                        "executing-complete": "Ho aggiunto del contenuto al file."
                    },
                    "copy_path": {
                        "executing-start": "Copia in corso...",
                        "executing-complete": "L'ho copiato."
                    },
                    "create_directory": {
                        "executing-start": "Creazione della cartella in corso...",
                        "executing-complete": "Ho creato la cartella."
                    },
                    "delete_path": {
                        "executing-start": "Eliminazione in corso...",
                        "executing-complete": "L'ho cancellato."
                    },
                    "edit_user_file": {
                        "executing-start": "Modifica del file in corso...",
                        "executing-complete": "Ho modificato il file."
                    },
                    "get_file_info": {
                        "executing-start": "Controllo del file in corso...",
                        "executing-complete": "Ho controllato il file."
                    },
                    "list_directory": {
                        "executing-start": "Elenco delle cartelle...",
                        "executing-complete": "Ho elencato la cartella."
                    },
                    "move_path": {
                        "executing-start": "Trasloco...",
                        "executing-complete": "L'ho spostato."
                    },
                    "open_path": {
                        "executing-start": "Apertura...",
                        "executing-complete": "L'ho aperto."
                    },
                    "read_user_file": {
                        "executing-start": "Lettura del file in corso...",
                        "executing-complete": "Ho letto il file."
                    },
                    "run_command": {
                        "executing-start": "Esecuzione di un comando...",
                        "executing-complete": "Ho eseguito il comando."
                    },
                    "search_files": {
                        "executing-start": "Ricerca dei file in corso...",
                        "executing-complete": "Ho trovato i file corrispondenti."
                    },
                    "search_in_files": {
                        "executing-start": "Ricerca all'interno dei file...",
                        "executing-complete": "Ho cercato all'interno dei file."
                    },
                    "write_user_file": {
                        "executing-start": "Scrittura del file...",
                        "executing-complete": "Ho scritto il file."
                    }
                },
                "networkError": "Connessione persa durante il download del modello. Controlla la tua connessione Internet e riprova inviando un messaggio o riavviando l'app.",
                "executing-org-block": "Impossibile utilizzare {{params.toolName}} perché l'interazione con {{params.appOrDomain}} è bloccata dall'organizzazione.",
                "executing-destructive-block": "L'interazione con {{params.elementName}} è bloccata. Si prega di rivedere ed eseguire questa azione manualmente.",
                "executing-type-focus-block": "Ho riscontrato un problema durante la scrittura del contenuto. È stato copiato negli appunti, si prega di incollarlo manualmente.",
                "executing-permission-block": "Ho riscontrato un problema nell'accesso al file.",
                "stopped": "Fermato.",
                "unsupportedOSVersion": "Il tuo sistema macOS è obsoleto, aggiornalo e riprova."
            },
            "ready": {
                "waiting": "AI Workflows è pronto. In attesa delle tue istruzioni.",
                "execute": "AI Workflows è pronto. A partire dalla tua richiesta..."
            },
            "start": "Inizio",
            "progress": "Lavorando...",
            "title": "I tuoi flussi di lavoro di IA sono pronti",
            "steps": {
                "thinking": "Pensiero",
                "tool": "Attrezzo",
                "details": "Dettagli",
                "chunkProgress": "parte {{attuale}} del {{totale}}",
                "output": "Produzione",
                "showMore": "Mostra altro",
                "showLess": "Mostra meno"
            },
            "prefix": "Flusso di lavoro:",
            "files": {
                "sectionTitle": "File",
                "open": "Aprire",
                "openFile": "Apri il file",
                "openFolder": "Apri la cartella",
                "openError": "Impossibile aprire \"{{name}}\". Potrebbe essere stato spostato o eliminato."
            },
            "input": {
                "other": "Altro…",
                "otherPlaceholder": "Digita la tua risposta",
                "submit": "Inviare"
            },
            "continue": {
                "label": "Continuare",
                "placeholder": "Chiedi a Cephable di fare di più con questo risultato…"
            },
            "retry": {
                "label": "Riprova"
            },
            "context": {
                "approaching": "Questa conversazione si sta allungando ({{percent}}% della memoria dell'IA utilizzata). I messaggi più vecchi potrebbero essere presto eliminati.",
                "trimmed": "Questa conversazione ha raggiunto il limite di memoria dell'IA, quindi potrebbe iniziare a dimenticare i messaggi precedenti. Avvia un nuovo flusso di lavoro per ripristinare la situazione."
            },
            "approval": {
                "title": "Conferma azione",
                "approve": "Approvare",
                "reject": "Rifiutare",
                "edit": "Modificare",
                "deletePath": "Eliminare questo file/cartella? Questa operazione è permanente.",
                "runCommand": "Eseguire questo comando shell?",
                "movePath": "Spostare/rinominare questo percorso? Potrebbe sovrascrivere la destinazione.",
                "confirmDelete": "Eliminare",
                "confirmRun": "Esegui il comando",
                "confirmMove": "Mossa",
                "badgeDestructive": "Distruttivo",
                "badgeCaution": "Attenzione"
            },
            "browser": {
                "sectionTitle": "Sito web",
                "view": "Visualizza il browser",
                "open": "Aprire",
                "openError": "Impossibile aprire il browser."
            }
        },
        "generatedByAI": "Basato sull'intelligenza artificiale integrata nel dispositivo, si prega di verificarne l'accuratezza.",
        "networkError": "Connessione persa durante il download del modello. Controlla la tua connessione Internet e riprova inviando un messaggio o riavviando l'app.",
        "genericError": "Si è verificato un errore imprevisto. Riprova.",
        "download": {
            "title": "Scarica i modelli di intelligenza artificiale per sbloccare ulteriori funzionalità.",
            "description": "Per utilizzare le attività intelligenti, è necessario scaricare un modello locale sul dispositivo. Questo garantisce che i dati rimangano privati e non vengano mai inviati al cloud.",
            "confirm": "Scaricamento",
            "cancel": "Non adesso"
        },
        "runningInBackground": {
            "generate": "Generazione in background...",
            "rewrite": "Riscrittura in background...",
            "translate": "Traduzione in background...",
            "summarize": "Riassumendo il contesto...",
            "generic": "In esecuzione in background..."
        }
    },
    "inputMethod": "Metodo di input:",
    "hotkey": {
        "title": "Pulsante di azione rapida",
        "titlePlural": "Pulsanti di azione rapida",
        "titlePanel": "Azioni rapide",
        "label": "Nome visualizzato del pulsante di azione rapida",
        "placeholder": "Nome da visualizzare",
        "question": "Come vorresti chiamare questo pulsante?",
        "when": "Quando tocco...",
        "description": "I pulsanti di azione rapida sono pulsanti personalizzabili che puoi toccare per eseguire azioni pertinenti nella tua app. Un singolo tocco può eseguire più passaggi o una singola azione.",
        "usagePrompt": "I pulsanti di azione rapida sono pulsanti personalizzabili che puoi toccare per eseguire azioni pertinenti nella tua app. Puoi aggiungerli, rimuoverli o modificarne i nomi dalla pagina principale delle impostazioni dei controlli dell'app.",
        "reorder": "È possibile modificare l'ordine utilizzando i pulsanti \"Sposta su\" e \"Sposta giù\".",
        "emptyTitle": "Nessun pulsante di azione rapida",
        "edit": "Modifica pulsanti di azione rapida",
        "tap": "Tocca {{value}}",
        "copySuffix": "{{name}}_copia",
        "hotkeysOnly": "Pulsanti personalizzati",
        "allControls": "Tutti i controlli delle app",
        "show": "Mostra pulsanti di azione rapida",
        "deprecatedDialog": {
            "title": "I controlli dell'app richiedono un aggiornamento.",
            "description2": "Basta un rapido aggiornamento, letteralmente un secondo, e potrai goderti un'esperienza di personalizzazione dei pulsanti impeccabile. Di' addio ai passaggi aggiuntivi e dai il benvenuto a un'interfaccia più intuitiva. Pronto a cambiare?",
            "confirm": "Facciamolo!",
            "description1": "Sembra che tu stia utilizzando controlli dell'app meno recenti con pulsanti di azione rapida. Abbiamo in serbo per te degli aggiornamenti entusiasmanti! Abbiamo rinnovato il sistema per semplificare la creazione e la modifica dei pulsanti di azione rapida, senza dover più immergersi nelle impostazioni avanzate."
        },
        "demo": {
            "title": "Pulsanti di azione rapida demo",
            "step1": "Attiva i pulsanti di azione rapida",
            "step2": "Utilizzare i prompt di esempio riportati di seguito per controllare il blocco di testo.",
            "command1": "Premere il pulsante 1 per “Ingrandire il testo”",
            "command2": "Premere il pulsante 2 per “mettere in grassetto il testo”",
            "command3": "",
            "continue": "Continua con i pulsanti di azione rapida",
            "description": "L'area demo qui sotto ti permetterà di provare i pulsanti di azione rapida. La demo è limitata al controllo specifico di quest'area di testo qui sotto."
        },
        "example": {
            "title": "Esempi di pulsanti di azione rapida",
            "command1": "Tocca Pausa",
            "example1": "Esempio \"metti in pausa il video\"",
            "command2": "Tocca Avanti",
            "example2": "Esempio \"zoom out\"",
            "command3": "Tocca Stop",
            "example3": "Esempio “chiudi finestra”",
            "description": "Questi esempi mostrano la versatilità dei pulsanti di azione rapida nel controllo del dispositivo o della connessione. Possono essere utilizzati per eseguire comandi, navigare tra le interfacce o eseguire azioni con un semplice tocco."
        },
        "emptySearch": "Non ci sono azioni rapide che corrispondono a questi criteri.",
        "empty": "Sembra che al momento non siano disponibili azioni rapide.",
        "emptyLong": "In questi controlli dell'app non sono configurati pulsanti di azione rapida. Una volta aggiunti pulsanti di azione rapida o scelti controlli dell'app che ne contengono uno, questi appariranno qui."
    },
    "reset": "Reset",
    "info": "Ulteriori informazioni",
    "device": {
        "title": "Connessione",
        "titlePlural": "Connessioni",
        "status": {
            "title": "Stato della connessione:",
            "connected": {
                "application": "Applicazione connessa",
                "connection": "Collegato",
                "device": "Dispositivo connesso",
                "game": "Gioco connesso"
            },
            "disconnected": {
                "application": "Applicazione disconnessa",
                "connection": "Disconnesso",
                "device": "Dispositivo disconnesso",
                "game": "Gioco disconnesso"
            }
        },
        "running": "Corsa",
        "offline": "Fuori linea",
        "otherDevices": "Altre connessioni di uscita",
        "currentStatus": "Stato attuale:",
        "connectionStatus": "Stato della connessione:",
        "profileStatus": "Controlli dell'app corrente:",
        "name": {
            "title": "Nome della connessione",
            "question": "Come vuoi chiamare questa connessione?",
            "description": "Assegna un nome alla tua connessione, così potrai ritrovarla facilmente in seguito.",
            "placeholder": "nome della connessione",
            "edit": "Modifica nome connessione"
        },
        "updates": {
            "title": "Aggiornamenti sulla connessione",
            "settings": "Impostazioni di aggiornamento della connessione",
            "description": "Verificare gli aggiornamenti del firmware di connessione e modificare le impostazioni di aggiornamento automatico",
            "edit": "Modifica impostazioni di aggiornamento",
            "check": {
                "title": "Controlla gli aggiornamenti",
                "processing": "Controllo aggiornamenti in corso! Potrebbero volerci alcuni minuti e la connessione potrebbe riavviarsi durante gli aggiornamenti.",
                "description": "Tocca per verificare la presenza di aggiornamenti per la tua connessione. Se è disponibile un aggiornamento e la tua connessione è attiva, l'aggiornamento inizierà. Gli aggiornamenti possono richiedere alcuni minuti."
            },
            "auto": {
                "title": "Aggiorna automaticamente",
                "description": "Con questa impostazione attivata, la connessione verrà aggiornata automaticamente ogni volta che il dispositivo è collegato alla rete elettrica, connesso al Wi-Fi e disponibile un aggiornamento. Se questa impostazione è disattivata, è necessario toccare il pulsante di aggiornamento per ottenere l'ultima versione.",
                "option": "Utilizzare l'aggiornamento automatico?"
            }
        },
        "delete": {
            "title": "Scollega {{name}}",
            "titleLong": "Scollega dall'account",
            "description": "Scollegando Cephable, lo disconnetti da questo computer o gioco e lo rimuovi dal tuo account. Non potrai più connetterti, inviare comandi o aggiornarlo. Questa operazione non può essere annullata, ma puoi creare una nuova connessione allo stesso computer o gioco se desideri utilizzarlo di nuovo in futuro.",
            "confirm": "Sei sicuro di voler scollegare questa connessione?",
            "confirmLong": "Vuoi davvero annullare la registrazione e reimpostare questa connessione? Non potrai più connetterti, inviare comandi o aggiornarla. Dopo questa operazione di annullamento della registrazione e reimpostazione, chiunque altro potrà configurare questa connessione da zero.",
            "confirmButton": "Sì, rimuovi questa connessione."
        },
        "manage": {
            "title": "Fai clic per visualizzare e gestire i dettagli delle tue connessioni.",
            "description": "",
            "name": "Personalizza il nome della tua connessione per una gestione più semplice."
        },
        "error": {
            "save": "Errore durante il salvataggio della connessione.",
            "load": "Errore durante il caricamento della connessione.",
            "add": "Errore durante l'aggiunta della connessione.",
            "delete": "Errore durante l'eliminazione della connessione.",
            "updates": "Errore durante il controllo degli aggiornamenti.",
            "connection": "La connessione non è stata stabilita. Assicurati che sia connessa prima di riprovare.",
            "deleteLong": "Non siamo riusciti a eliminare questa connessione dal tuo account. Se accedi di nuovo a questo account, potresti dover eliminare manualmente questa connessione nelle impostazioni di connessione."
        },
        "success": {
            "save": "Connessione salvata.",
            "add": "Connessione aggiunta.",
            "delete": "Connessione eliminata."
        },
        "description": "Cephable supporta più dispositivi e connessioni. Puoi gestire le impostazioni o selezionarne una qualsiasi da qui. Questo computer sarà sempre la tua connessione principale. Puoi aggiungere altre connessioni in seguito.",
        "swap": {
            "titlePlural": "Scambia connessioni",
            "description": "Cephable supporta più dispositivi e connessioni. Puoi selezionarne uno qualsiasi da qui. Questo computer sarà sempre la tua connessione principale. Potrai aggiungere altre connessioni in seguito."
        },
        "control": {
            "button": "Controllo {{name}}",
            "description": {
                "application": "Controlla questa applicazione connessa usando la voce, azioni rapide, movimenti della testa e altro ancora. Ad esempio, se dici \"Salva\", l'operazione verrà salvata sull'applicazione in esecuzione.",
                "connection": "Controlla questa connessione tramite la voce, azioni rapide, movimenti della testa e altro ancora. Ad esempio, se dici \"Salva\", questa operazione verrà salvata sulla connessione in esecuzione.",
                "device": "Controlla questo dispositivo connesso usando la voce, azioni rapide, movimenti della testa e altro ancora. Ad esempio, se dici \"Apri Spotify\", Spotify si aprirà sul dispositivo in esecuzione.",
                "game": "Controlla questo gioco interattivo usando la voce, azioni rapide, movimenti della testa e altro ancora. Ad esempio, se dici \"Vai\", il giocatore si muoverà in modalità corsa."
            },
            "generic": "Collegamento di controllo"
        },
        "titleShort": "Collegare",
        "titleLong": "Connessioni ed estensioni",
        "viewAll": "Visualizza tutte le connessioni",
        "add": {
            "short": "Estendere",
            "title": "Aggiungi una nuova connessione o estensione",
            "description": "Connessioni ed estensioni sono ulteriori modi per migliorare la tua esperienza Cephable. Puoi aggiungere nuove connessioni per connetterti a più dispositivi, applicazioni o giochi. Porta la tua esperienza Cephable a un livello superiore aggiungendo connessioni ed estensioni.",
            "action": "Aggiungi una nuova connessione",
            "notAvailable": "Questa connessione o estensione non è attualmente disponibile al pubblico. Questo problema si verifica spesso quando si utilizzano estensioni generate dagli utenti. Riprova più tardi.",
            "isNotPublic": "ANTEPRIMA: Questa estensione è in anteprima per sviluppatori e potrebbe essere incompleta. Gli sviluppatori devono completare tutti i passaggi prima del rilascio pubblico. Gli utenti possono controllare più tardi per la versione completa."
        },
        "new": "Hai una nuova connessione!",
        "newLong": "Hai una nuova connessione! Per iniziare a usarla, selezionala dal menu qui sotto."
    },
    "explore": "Esplorare",
    "shortcuts": {
        "title": "Scorciatoie globali",
        "description": "Personalizza le scorciatoie da tastiera per accedere rapidamente ai controlli Cephable da qualsiasi punto del sistema.",
        "info": "Queste scorciatoie funzionano a livello globale e possono essere utilizzate anche quando Cephable non è la finestra attiva.",
        "shortcut": "Scorciatoia",
        "toggleMicrophone": "Attiva/disattiva microfono",
        "toggleDictation": "Attiva/disattiva la modalità di dettatura",
        "toggleVoiceControl": "Attiva/disattiva la modalità di controllo vocale",
        "togglePanel": "Pannello di attivazione/disattivazione",
        "registrationFailed": "Alcune scorciatoie globali non sono state registrate. Potrebbero essere utilizzate da un'altra applicazione:",
        "record": {
            "title": "Registra scorciatoia",
            "start": "Clicca per registrare",
            "listening": "Premi la combinazione di tasti desiderata...",
            "pressKeys": "Premi i tasti ora"
        },
        "formatHint": "Selezionare almeno un tasto modificatore ({{modifierKey}}, {{modifierKey2}}, Maiusc) e un altro tasto."
    },
    "gamepad": {
        "title": "Supporto per gamepad",
        "description": "Configura l'uscita del gamepad e del joystick per i giochi su PC",
        "driver": {
            "description": "Per supportare le uscite del controller di gioco, Cephable deve scaricare e installare un driver esterno chiamato ViGEm. Questo driver abilita la funzionalità del controller virtuale Xbox 360, riconosciuta in modo nativo dai giochi.",
            "installed": "Driver del controller di gioco installato: ora puoi utilizzare le uscite del gamepad! Se i problemi persistono, puoi provare a reinstallare il driver.",
            "notInstalled": "Driver del controller di gioco non installato",
            "install": "Installa il driver del controller di gioco",
            "reinstall": "Reinstallare il driver del controller di gioco",
            "installing": "Installazione del driver del controller di gioco ViGEm...",
            "installSuccess": "Driver del controller di gioco ViGEm installato correttamente! Ora puoi utilizzare le uscite del gamepad nei tuoi controlli.",
            "installFailed": "Impossibile installare il driver ViGEm. Riprovare o installarlo manualmente dal sito web di ViGEm.",
            "title": "Driver del controller di gioco",
            "disclosure": {
                "title": "Installare driver di terze parti per gamepad?",
                "description": "Il supporto per il gamepad richiede l'installazione di ViGEm, un driver non ufficiale di terze parti che permette a Cephable di emulare un controller Xbox virtuale. Prosegui solo se desideri che Cephable installi questo driver.",
                "confirm": "Installa il driver ViGEm"
            }
        },
        "platform": {
            "unsupported": "Piattaforma non supportata per le funzionalità del gamepad",
            "unsupportedDescription": "La funzionalità di output del gamepad è attualmente supportata solo sui sistemi Windows x64. Il supporto per Mac e Windows ARM64 non è ancora disponibile."
        },
        "usage": "Una volta installato il driver del Game Controller, puoi usare i movimenti del joystick e le pressioni dei pulsanti del gamepad nelle macro e nei comandi vocali per controllare i giochi."
    },
    "youtube": {
        "unavailable": {
            "title": "Video non disponibile",
            "description": "Questo video non è al momento disponibile. Riprova più tardi.",
            "retry": "Riprova"
        },
        "watch": {
            "title": "Ops.",
            "description": "Sembra che si sia verificato un problema durante il caricamento del video. Puoi guardarlo direttamente su YouTube.",
            "button": "Guarda su YouTube"
        },
        "offline": {
            "title": "Video non disponibile",
            "description": "Questo video di YouTube richiede una connessione a Internet per essere caricato. Controlla la tua connessione e riprova."
        }
    },
    "metrics": {
        "download": {
            "success": "Accesso al file delle metriche riuscito.",
            "manualPath": "File delle metriche disponibile all'indirizzo: {{path}}",
            "error": "Errore durante il download del file delle metriche.",
            "noFile": "Nessun file di metriche trovato."
        },
        "clear": {
            "success": "File delle metriche cancellato correttamente.",
            "error": "Errore durante la cancellazione del file delle metriche.",
            "noFile": "Nessun file di metriche trovato da cancellare.",
            "confirm": "Vuoi davvero cancellare tutti i dati delle metriche? Questa operazione non può essere annullata."
        }
    },
    "suggestedPrompts": {
        "title": "Suggerimenti suggeriti",
        "description": "Personalizza i suggerimenti visualizzati nelle attività di intelligenza artificiale per aiutarti a iniziare rapidamente.",
        "edit": "Modifica i prompt suggeriti",
        "generate": "Genera testo",
        "rewrite": "Riscrivi il testo",
        "addGenerate": "Aggiungi un prompt di generazione",
        "addRewrite": "Aggiungi un prompt di riscrittura",
        "remove": "Rimuovi richiesta",
        "generatePlaceholder": "Inserisci un prompt per la generazione del testo...",
        "rewritePlaceholder": "Inserisci un prompt per la riscrittura del testo...",
        "suggested": "Suggerimenti suggeriti",
        "suggestedFor": "Suggerito per {{profileName}}",
        "seeAll": "Visualizza tutti i prompt",
        "showLess": "Mostra meno",
        "allPrompts": "Tutti i prompt",
        "customFor": "Prompt personalizzati per {{profileName}}",
        "defaultPrompts": "Prompt predefiniti",
        "defaultGenerate": [
            "Un'e-mail professionale che presenta il nostro nuovo prodotto",
            "Un ordine del giorno per la discussione di gruppo della prossima settimana",
            "Uno schema di proposta di progetto per una nuova iniziativa",
            "Un modello di lettera commerciale formale",
            "Una sezione di documentazione tecnica",
            "Introduzione al manuale utente",
            "Una panoramica del documento di formazione",
            "Una bozza di documento politico",
            "Un'e-mail di follow-up dopo una riunione",
            "Un messaggio di ringraziamento a un cliente",
            "Un'e-mail di aggiornamento sullo stato del progetto",
            "Un invito a un evento aziendale",
            "Un'e-mail di promemoria per le prossime scadenze",
            "Un'e-mail di benvenuto per i nuovi membri del team",
            "Un'e-mail di scuse per l'interruzione del servizio",
            "Introduzione alla newsletter",
            "Un elenco di brainstorming per campagne di marketing",
            "Soluzioni creative per migliorare la produttività del team",
            "Idee per attività di ritiro aziendale",
            "Concetti per una nuova funzionalità dell'app mobile",
            "Suggerimenti per migliorare l'esperienza del cliente",
            "Idee innovative per lo sviluppo dei nostri prodotti",
            "Idee di contenuti per i post sui social media",
            "Argomenti di workshop per lo sviluppo professionale",
            "Una funzione che convalida l'input dell'utente",
            "Una query di database per la gestione degli utenti",
            "Codice di gestione degli errori per le richieste API",
            "Un modello di file di configurazione",
            "Commenti che spiegano un algoritmo complesso",
            "Casi di test unitari per una nuova funzionalità",
            "Documentazione per gli endpoint API",
            "Uno script per la distribuzione automatizzata"
        ],
        "defaultRewrite": [
            "Rendi questo testo più conciso e diretto",
            "Espandi questo riepilogo con maggiori dettagli",
            "Riformattalo come un elenco numerato",
            "Converti questo in punti elenco",
            "Ristrutturalo in paragrafi chiari",
            "Rendi questo testo più facile da leggere velocemente",
            "Organizzare queste informazioni in modo gerarchico",
            "Formattalo come una guida passo passo",
            "Rendi questo messaggio più professionale e formale",
            "Riscrivilo per renderlo più informale e amichevole",
            "Adatta il tono per renderlo più incoraggiante",
            "Rendi questo suono più sicuro e assertivo",
            "Addolcisci il tono per essere più diplomatico",
            "Aggiungi entusiasmo ed energia a questo testo",
            "Rendilo più empatico e comprensivo",
            "Riscrivi con un tono più collaborativo",
            "Semplificare questo per un pubblico generale",
            "Rendi questa spiegazione più tecnica e dettagliata",
            "Scomporre questo concetto complesso in termini più semplici",
            "Aggiungere più contesto e informazioni di base",
            "Riassumiamo tutto questo in punti chiave",
            "Elaborare i punti principali con esempi",
            "Rendilo più accessibile ai principianti",
            "Condensa questo mantenendo le informazioni essenziali",
            "Migliorare la chiarezza e la leggibilità",
            "Rendi questo più coinvolgente e interessante",
            "Adatta per una grammatica e una fluidità migliori",
            "Riscrivi per enfatizzare i vantaggi"
        ],
        "defaultSummarize": [
            "Riassumi in 3 punti elenco",
            "Estrarre le decisioni chiave",
            "Elenca le principali azioni da intraprendere",
            "Fornisci un riassunto in una frase",
            "Evidenzia i fatti più importanti",
            "Riassumere per un pubblico non tecnico",
            "Estrarre i punti chiave",
            "Riassumi in 5 punti elenco",
            "Individuare il problema principale e proporre una soluzione.",
            "Elenca tutte le conclusioni e le raccomandazioni",
            "Fornire un riepilogo esecutivo",
            "Riassumere la cronologia degli eventi",
            "Estrarre tutte le domande sollevate",
            "Elenca i pro e i contro menzionati",
            "Riassumere gli argomenti principali"
        ]
    },
    "accessibilityService": {
        "error": {
            "generic": "Errore interno. Riprova più tardi.",
            "elementNotFound": "Nessun risultato trovato. Assicurati che la ricerca esista e riprova.",
            "highlightOnConflict": "Sono stati trovati più elementi. Perfeziona il comando per specificare quale vuoi selezionare.",
            "clickNotInitialized": "Al momento, la funzione \"Tocca per nome\" non è disponibile. Se il problema persiste, contatta l'assistenza.",
            "platformUnsupported": "La funzione \"Tocca per nome\" non è supportata su questa piattaforma."
        },
        "clickWait": "Inizializzazione in corso. Attendi un attimo e riprova."
    },
    "deprecated": "Obsoleto",
    "view": "Visualizzazione",
    "aiWorkflows": {
        "settings": {
            "title": "Impostazioni automatiche",
            "description": "Configura i modelli di intelligenza artificiale e i dispositivi utilizzati per i flussi di lavoro di intelligenza artificiale. I flussi di lavoro di intelligenza artificiale consentono di automatizzare le attività su desktop e browser utilizzando l'intelligenza artificiale sul dispositivo.",
            "configType": {
                "title": "Tipo di configurazione del modello",
                "description": "Seleziona il tipo di configurazione del modello da utilizzare per i flussi di lavoro AI. Diverse configurazioni sono ottimizzate per modelli diversi.",
                "label": "Tipo di configurazione"
            },
            "reasoningModel": {
                "title": "Modello di ragionamento",
                "description": "Seleziona il modello di intelligenza artificiale da utilizzare per le attività di ragionamento e pianificazione. Il modello di ragionamento analizza le tue richieste e crea piani d'azione.",
                "label": "Modello di ragionamento"
            },
            "reasoningDevice": {
                "label": "Dispositivo di ragionamento"
            },
            "generationModel": {
                "title": "Modello di generazione",
                "description": "Seleziona il modello di intelligenza artificiale da utilizzare per le attività di generazione del testo. Il modello di generazione crea contenuti testuali quando necessario per i flussi di lavoro.",
                "label": "Modello di generazione"
            },
            "generationDevice": {
                "label": "Dispositivo di generazione"
            },
            "noModelsFound": "Nessun modello trovato",
            "terminate": {
                "title": "Risorse chiare del flusso di lavoro",
                "description": "Fare clic per terminare il workflow worker e liberare risorse. Questo interromperà qualsiasi workflow in esecuzione e libererà la memoria utilizzata dai modelli di intelligenza artificiale.",
                "button": "Termina Workflow Worker",
                "success": "Addetto al flusso di lavoro licenziato.",
                "confirm": {
                    "title": "Termina Workflow Worker",
                    "description": "Vuoi davvero terminare il workflow worker? Questo interromperà qualsiasi workflow in esecuzione e libererà risorse.",
                    "confirm": "Sì, terminare"
                }
            },
            "autoWarm": {
                "title": "Flussi di lavoro AI con avvio automatico",
                "description": "Inizializza automaticamente i modelli di flusso di lavoro AI all'avvio dell'app. I modelli saranno precaricati in modo che i flussi di lavoro possano iniziare immediatamente.",
                "option": "Avvia automaticamente i modelli di flusso di lavoro AI all'avvio dell'app"
            },
            "prompt": {
                "title": "Informazioni aggiuntive per i flussi di lavoro AI",
                "description": "Inserisci dettagli aggiuntivi da utilizzare con l'intelligenza artificiale di Cephable durante l'esecuzione dei flussi di lavoro. Utilizza questo campo per inserire le tue preferenze relative a tono, comportamento o altri dettagli.",
                "field": "Richiesta aggiuntiva",
                "placeholder": "Ad esempio, confermare sempre prima di inviare e-mail. Preferire risposte concise. Utilizzare un linguaggio formale nei documenti."
            },
            "disableButtonNames": {
                "edit": "Interazioni con i pulsanti di blocco",
                "input": {
                    "label": "Nome del pulsante",
                    "question": "Quali pulsanti desideri bloccare? Puoi inserire il nome completo o parziale del pulsante.",
                    "remove": "Rimuovi il nome del pulsante"
                },
                "button": "Pulsanti di blocco",
                "description": "Controlla con quali pulsanti i flussi di lavoro basati sull'IA possono interagire. Per impostazione predefinita, Cephable può fare clic su qualsiasi pulsante sullo schermo. Utilizza questa impostazione per evitare azioni accidentali (ad esempio, \"acquista\", \"elimina\")."
            },
            "remoteWorkflows": {
                "title": "Esegui flussi di lavoro di intelligenza artificiale su tutti i tuoi dispositivi.",
                "option": "Consenti agli altri miei dispositivi di avviarsi e di seguire le automazioni su questo dispositivo",
                "description": "Attivata per impostazione predefinita. Quando è attiva, puoi avviare, monitorare e rispondere alle automazioni di questo dispositivo dagli altri dispositivi a cui hai effettuato l'accesso: l'avanzamento dell'automazione (titoli dei passaggi e ragionamento dell'IA) e le eventuali domande che ti vengono poste vengono inviate in tempo reale a questi dispositivi, consentendoti di rispondere ovunque ti trovi. Queste informazioni vengono condivise solo tra i tuoi dispositivi e non vengono mai memorizzate sui server di Cephable. Disattivala per mantenere le automazioni interamente su questo dispositivo: le automazioni continueranno a essere eseguite qui, ma nulla verrà inviato agli altri dispositivi e questi non potranno avviare un'automazione su questo dispositivo."
            },
            "thinkingLevel": {
                "field": "Sforzo di ragionamento",
                "description": "Quanto l'IA riflette su ogni passaggio prima di agire. Livelli più elevati le consentono di scegliere e ordinare le azioni in modo più affidabile in compiti complessi, ma rendono ogni passaggio leggermente più lento. Il livello medio è consigliato alla maggior parte degli utenti.",
                "low": "Basso (più veloce)",
                "medium": "Medio (consigliato)",
                "high": "Alto",
                "max": "Massimo (il più accurato)"
            }
        }
    },
    "control": "Controllare",
    "automate": "Automatizzare",
    "deviceCommandThrottled": {
        "macroLength": "Questa connessione non consente macro lunghe. La tua macro è stata abbreviata automaticamente.",
        "commandCount": "Questa connessione limita la velocità di invio dei comandi. Attendi e riprova più tardi.",
        "incompatibleActions": "Questo controllo contiene azioni che non possono essere utilizzate insieme e non è stato inviato."
    },
    "tos": {
        "title": "Aggiornamento dei Termini di Servizio",
        "description": "I nostri Termini di servizio sono stati aggiornati. Si prega di leggere e accettare i termini aggiornati per continuare a utilizzare Cephable.",
        "effectiveDate": "Data di entrata in vigore: {{date}}",
        "accept": "Accetta i Termini di Servizio",
        "loadError": "Impossibile caricare i Termini di servizio. Riprova.",
        "viewInBrowser": "Visualizza i Termini di servizio nel browser",
        "acceptCheckbox": "Ho letto e accetto i Termini di servizio"
    },
    "appearance": {
        "title": "Aspetto"
    },
    "troubleshooting": {
        "title": "Risoluzione dei problemi"
    },
    "extensions": {
        "title": "Estensioni",
        "titleShort": "Estensioni",
        "description": "Abilita nuove funzionalità, connetti app complementari ed estendi le capacità di Cephable.",
        "searchPlaceholder": "Estensioni di ricerca",
        "noResults": "Nessuna estensione corrisponde alla tua ricerca.",
        "comingSoon": "Prossimamente",
        "done": "Fatto",
        "getStarted": "Inizia",
        "viewDetails": "Visualizza dettagli e impostazioni",
        "enable": "Abilitare",
        "publisher": {
            "official": "Cefabile",
            "officialTitle": "Ufficiale — creato e gestito da Cephable",
            "byline": "A cura di {{editore}}",
            "thirdPartyTitle": "Integrazione di terze parti da parte di {{publisher}}"
        },
        "category": {
            "inputControls": {
                "title": "Input e controllo",
                "description": "Attiva le modalità di controllo del tuo dispositivo con Cephable."
            },
            "companionApps": {
                "title": "App e strumenti complementari",
                "description": "Amplia le funzionalità di Cephable con la nostra app per dispositivi mobili e i nostri strumenti di creazione basati sul web."
            },
            "buildExtend": {
                "title": "Costruisci ed estendi",
                "description": "Crea le tue estensioni personalizzate con le API e gli SDK di Cephable."
            },
            "marketplace": {
                "title": "Mercato",
                "description": "Nuove competenze, strumenti e contatti sono in arrivo."
            }
        },
        "camera": {
            "title": "Comandi della fotocamera",
            "description": "Controlla il tuo dispositivo con i movimenti del viso e della testa utilizzando la fotocamera.",
            "detail": "I controlli della fotocamera consentono di utilizzare espressioni facciali e movimenti della testa, incluso il movimento della testa come mouse, per controllare il dispositivo. Attivali tramite l'interruttore sulla scheda, quindi personalizza il comportamento qui.",
            "settings": {
                "title": "Espressioni e gesti",
                "description": "Regola le espressioni facciali e i movimenti della testa associati alle azioni nelle Impostazioni."
            },
            "advancedSettings": "Apri le impostazioni della fotocamera"
        },
        "gamepad": {
            "title": "Supporto per gamepad",
            "description": "Emula un controller Xbox in modo che i giochi riconoscano i tuoi input Cephable.",
            "detail": "Il supporto per gamepad richiede l'installazione di ViGEm, un driver non ufficiale di terze parti, per emulare un controller Xbox virtuale riconosciuto nativamente dai giochi. Installa o aggiorna il driver qui sotto. Disponibile per Windows x64."
        },
        "mobile": {
            "title": "Applicazione mobile Cephable",
            "description": "Utilizza il tuo telefono come controller complementare con l'app mobile Cephable.",
            "detail": "Scarica l'app mobile Cephable per utilizzare il tuo telefono come controller aggiuntivo. Scansiona un codice o utilizza i link per scaricarla su iOS o Android, quindi visualizza l'anteprima dell'app qui sotto.",
            "screenshotsTitle": "Anteprima",
            "screenshotPlaceholder": "Screenshot",
            "screenshotAlt": "Screenshot dell'app mobile Cephable {{number}}",
            "scanTitle": "Scansiona per scaricare",
            "ios": "iOS — App Store",
            "android": "Android — Google Play",
            "iosAction": "Scaricala dall'App Store",
            "androidAction": "Scaricalo su Google Play"
        },
        "controllerCreator": {
            "title": "Creatore di controller personalizzati",
            "description": "Progetta i tuoi controller su schermo personalizzati su controller.cephable.com.",
            "detail": "Il Custom Controller Creator consente di progettare e condividere i propri controller su schermo direttamente nel browser.",
            "qrCaption": "controller.cephable.com",
            "action": "Creatore di controller aperti",
            "screenshotsTitle": "Anteprima",
            "screenshotPlaceholder": "Screenshot del creatore del controller",
            "screenshotAlt": "Screenshot del creatore di controller personalizzati {{number}}"
        },
        "developer": {
            "title": "Crea la tua estensione",
            "description": "Utilizza le API e gli SDK di Cephable per creare e condividere le tue estensioni.",
            "detail": "Crea le tue estensioni e integrazioni con Cephable. Esplora le API e gli SDK, poi pubblica e condividi le tue creazioni su developers.cephable.com.",
            "api": {
                "title": "API Cephable",
                "description": "Gestisci a livello di programmazione profili, dispositivi, controlli ed eventi in tempo reale."
            },
            "sdk": {
                "title": "SDK ed esempi",
                "description": "Inizia subito a lavorare con i nostri SDK, esempi e guide all'integrazione."
            },
            "action": "Visita developers.cephable.com"
        },
        "portal": {
            "title": "Progetti e team",
            "description": "Gestisci i tuoi progetti e i tuoi team nel portale Cephable.",
            "detail": "Utilizza il portale Cephable per gestire progetti, team e impostazioni organizzative in un unico luogo.",
            "projects": {
                "title": "Eventi",
                "description": "Crea e gestisci progetti, chiavi API e integrazioni."
            },
            "teams": {
                "title": "Squadre",
                "description": "Invita i membri, assegna i ruoli e gestisci gli accessi in tutta l'organizzazione."
            },
            "action": "Apri il portale cefabile"
        },
        "mcpTools": {
            "title": "Strumenti MCP",
            "description": "Collega gli strumenti del Model Context Protocol per estendere le funzionalità di Cephable."
        },
        "aiSkills": {
            "title": "Competenze di intelligenza artificiale",
            "description": "Aggiungi funzionalità di intelligenza artificiale riutilizzabili che Cephable può attivare su richiesta."
        },
        "workflows": {
            "title": "Flussi di lavoro riutilizzabili",
            "description": "Condividi e installa flussi di lavoro di automazione predefiniti."
        },
        "controlBundles": {
            "title": "Fasci di controllo",
            "description": "Installa pacchetti selezionati di controlli per app e giochi con un solo tocco."
        },
        "connections": {
            "title": "Connessioni tra giochi e app",
            "description": "Scopri giochi e app che puoi controllare con Cephable, come Call of Duty: Black Ops 7."
        }
    },
    "sensitivityValues": {
        "verySensitive": "Molto sensibile",
        "high": "Alto",
        "medium": "Mezzo",
        "low": "Basso",
        "notSensitive": "Non sensibile"
    },
    "summarize": "Riassumere",
    "appControlsPanel": {
        "searchPlaceholder": "Comandi di ricerca...",
        "searchLabel": "Comandi di ricerca",
        "favorites": {
            "title": "Preferiti",
            "description": "I comandi preferiti sono quelli che utilizzi più spesso. Puoi contrassegnare un comando come preferito facendo clic sull'icona a forma di stella accanto ad esso."
        },
        "noCommandsFound": "Nessun comando trovato",
        "globalCommands": "Globale",
        "prefixCommandToast": "Questo è un comando con prefisso: pronuncia o digita il prefisso seguito dalla frase per attivarlo."
    },
    "collapse": "Crollo",
    "intelligentTasks": {
        "loading": {
            "loadingModels": "Caricamento dei modelli di intelligenza artificiale...",
            "extractingModels": "Estrazione di modelli di intelligenza artificiale..."
        }
    },
    "sidebar": {
        "collapse": "Comprimi la barra laterale",
        "expand": "Espandi la barra laterale"
    },
    "workspace": {
        "title": "Spazio di lavoro",
        "badge": "Sul dispositivo · privato",
        "subtitle": "Il tuo assistente AI funziona interamente su questo dispositivo. Avvia i comandi, crea, automatizza o semplicemente chatta.",
        "control": {
            "title": "Controllare",
            "description": "Comandi vocali, scorciatoie da tastiera e pulsanti di azione rapida: funzionano con tutte le app del tuo dispositivo.",
            "voice": {
                "title": "Comandi vocali",
                "description": "Comandi a mani libere"
            },
            "dictation": {
                "title": "Dettatura",
                "description": "Parlare al tipo"
            },
            "computerUse": {
                "title": "Uso del computer",
                "description": "Lascia che l'assistente agisca"
            }
        },
        "create": {
            "title": "Creare",
            "description": "Scrivi, riscrivi, riformatta e traduci, direttamente all'interno dell'app in cui stai lavorando, utilizzando il testo copiato ed evidenziato.",
            "items": {
                "draftEmail": "Redigere una bozza di email",
                "writeDocument": "Scrivi un documento",
                "summarizeNotes": "Riassumere in appunti",
                "polishWriting": "Perfeziona la mia scrittura",
                "translateText": "Traduci il testo",
                "socialPost": "Scrivi un post sui social",
                "cd_brief": "Redigere un brief creativo",
                "cd_caption": "Scrivi una didascalia e un testo alternativo",
                "ar_insights": "Riassumere i risultati in spunti di riflessione",
                "ar_exec": "Scrivi un riassunto esecutivo",
                "cc_followup": "Redigere una bozza di email di follow-up",
                "cc_meetingNotes": "Trasforma gli appunti in verbali di riunione",
                "bd_commit": "Scrivi un messaggio di commit",
                "bd_review": "Riassumere una revisione del codice",
                "gp_bio": "Scrivi una biografia per il tuo stream",
                "gp_recap": "Riepilogo della sessione di ieri sera",
                "lt_lesson": "Delineare un piano di lezione",
                "lt_studyNotes": "Riassumere in appunti di studio",
                "mo_agenda": "Redigere un ordine del giorno della riunione",
                "mo_update": "Scrivi un aggiornamento del progetto",
                "aa_simplify": "Semplificare in linguaggio semplice",
                "aa_describe": "Descrivi un'immagine a parole"
            },
            "contextRow": {
                "highlightedText": "Evidenzia/appunta il testo",
                "output": "Digitazione:",
                "input": "Usi:",
                "background": "Sfondo",
                "currentapp": "Applicazione attuale"
            },
            "prompts": {
                "draftEmail": "Redigi una bozza di email chiara e professionale a riguardo.",
                "writeDocument": "Scrivi un documento a riguardo.",
                "summarizeNotes": "Riassumi il tutto in note concise e ben organizzate, utilizzando elenchi puntati.",
                "polishWriting": "Riscrivi questo testo in modo che sia più chiaro e rifinito, mantenendo però il significato e il tono originali.",
                "socialPost": "Scrivi un breve post coinvolgente sui social media a riguardo.",
                "cd_brief": "Redigere un brief creativo per questo progetto.",
                "ar_insights": "Riassumere i principali risultati e le intuizioni emerse da questi dati.",
                "ar_exec": "Scrivi un riassunto esecutivo conciso di questo documento.",
                "cc_followup": "Scrivi una bozza di email di follow-up in merito.",
                "cc_meetingNotes": "Trasforma questi appunti in verbali di riunione chiari e completi, con punti d'azione da intraprendere.",
                "bd_commit": "Scrivi un messaggio di commit chiaro per queste modifiche:",
                "bd_review": "Riassumi questa revisione del codice evidenziando i punti chiave e le modifiche richieste.",
                "gp_bio": "Scrivi una biografia incisiva per il mio canale/profilo.",
                "lt_lesson": "Elabora un piano di lezione su questo argomento.",
                "lt_studyNotes": "Riassumi questo materiale in appunti di studio che io possa consultare.",
                "mo_agenda": "Redigere un ordine del giorno per la riunione che includa questo argomento.",
                "mo_update": "Sulla base di quanto sopra, redigi un aggiornamento sullo stato di avanzamento del progetto per le parti interessate.",
                "aa_simplify": "Riscrivi questo testo in un linguaggio semplice e di facile lettura."
            }
        },
        "automate": {
            "title": "Automatizzare",
            "description": "Descrivi un'attività in linguaggio semplice e Cephable la eseguirà nelle tue applicazioni, nei tuoi file e persino nella riga di comando.",
            "items": {
                "triage": "Gestisci la mia casella di posta",
                "cd_exportAssets": "Rinominare e archiviare le risorse",
                "cd_moodboard": "Raccogli referenze",
                "cc_triage": "Valutazione e bozze di risposte",
                "cc_recap": "Riepilogo e invia al team",
                "bd_scaffold": "Strutturare un progetto",
                "gp_schedule": "Pianifica un programma di streaming",
                "lt_handout": "Preparare un documento informativo",
                "summarizeSend": "Riassumi e invia via email",
                "researchDoc": "Ricerca e redigi un documento",
                "organizeFiles": "Organizza i miei file",
                "cleanUp": "Pulire una cartella",
                "wordDoc": "Crea un documento Word",
                "ar_summarizeSend": "Riassumi e invia via email",
                "ar_analyzeData": "Analizzare un foglio di calcolo",
                "ar_deck": "Costruisci un mazzo di carte dai dati",
                "cc_summarizeEmail": "Riassumi in un'e-mail",
                "cc_socialPost": "Pubblica da un link",
                "bd_buildTest": "Costruisci e testa un progetto",
                "bd_cleanup": "Suggerisci interventi di pulizia del codice",
                "lt_studyMaterial": "Creare materiale di studio",
                "lt_accommodation": "Prendere appunti in modo accessibile",
                "lt_research": "Ricerca e confronta",
                "mo_meetingActions": "Trasformare gli appunti in azioni",
                "mo_organizeFiles": "Organizza i miei file",
                "mo_cleanup": "Pulizia dei download",
                "aa_translate": "Tradurre un documento"
            },
            "prompts": {
                "summarizeSend": "Riassumi il contenuto della cartella <folder> e invialo via email all'indirizzo <team email>.",
                "researchDoc": "Analizza le tendenze presenti nella cartella o nel documento e trascrivi i risultati in un nuovo documento.",
                "organizeFiles": "Copia i file da<source folder> in<destination folder> .",
                "cleanUp": "Rimuovi tutti i file di tipo <ad esempio, screenshot> dalla mia <cartella>.",
                "wordDoc": "Utilizzo<article or notes> per creare un documento di Microsoft Word che<does what> .",
                "triage": "Esamina la mia casella di posta e dimmi cosa richiede la mia attenzione, poi prepara delle risposte laddove necessario.",
                "cd_exportAssets": "Rinominare le risorse di progettazione in <cartella> utilizzando questo schema — <schema di denominazione> — e ordinarle in cartelle.",
                "cd_moodboard": "Cerca online riferimenti per <idea> e raccoglili in un documento.",
                "ar_summarizeSend": "Riassumi il contenuto della cartella <folder> e invialo via email all'indirizzo <team email>.",
                "ar_analyzeData": "Analizza il foglio di calcolo e individua gli elementi da cercare, ad esempio le perdite di dati chiave.",
                "ar_deck": "Trasforma i risultati contenuti nel <documento o nella cartella> in una presentazione PowerPoint che evidenzi i <punti chiave>.",
                "cc_triage": "Controllo la mia casella di posta e preparo risposte a tutto ciò che ne richiede una.",
                "cc_summarizeEmail": "Redigere una bozza di email riassuntiva<article or document> e indicare i dettagli tecnici principali.",
                "cc_recap": "Scrivi un riepilogo di <note della riunione> e invialo via email a <email del team>.",
                "cc_socialPost": "Leggere<article or website> e scrivere un<platform, e.g. Discord> -pubblica un post amichevole al riguardo, poi salvalo in una nuova nota.",
                "bd_buildTest": "Esamina il codice nella cartella <project folder>, compilalo ed esegui i test. Se qualcosa non funziona, controlla la cronologia di Git e dimmi cosa potrebbe aver causato il problema.",
                "bd_cleanup": "Dai un'occhiata al codice nella cartella <project folder> e dimmi come posso renderlo più pulito.",
                "bd_scaffold": "Crea la struttura di base per un nuovo progetto <tipo di progetto> nella cartella <cartella> con i file iniziali necessari.",
                "gp_schedule": "Pianifica un programma di streaming per<time period> copertura<games or activities> .",
                "lt_studyMaterial": "Utilizzo<article or notes> per creare un documento Word per<grade level> studenti con<reflection questions or a study guide> .",
                "lt_accommodation": "Crea un documento Word con gli appunti della lezione su <argomento> formattato per uno studente con <alloggio>.",
                "lt_handout": "Raccogli i materiali di lettura presenti nella cartella <folder> in un unico documento distribuito.",
                "lt_research": "Cerca online <argomento, ad esempio libri sulla neurodiversità> e crea un documento che riassuma ciascuno di essi, in modo che io possa confrontarli.",
                "mo_meetingActions": "Leggi il verbale della riunione: cosa resta da fare, chi è responsabile e cosa richiede ulteriori ricerche? Suddividi il tutto in file organizzati in una cartella.",
                "mo_organizeFiles": "Copia i file da<source folder> in<destination folder> .",
                "mo_cleanup": "Rimuovi tutti i file di tipo <ad esempio, programmi di installazione> dalla mia cartella Download.",
                "aa_translate": "Traduci <documento> in <lingua> e salvalo in <cartella>."
            }
        },
        "history": {
            "title": "Storia recente dell'IA",
            "description": "Le tue attività intelligenti e automazioni più recenti.",
            "viewAll": "Visualizza tutta la cronologia",
            "empty": "Qui verranno visualizzate le attività e le automazioni di intelligenza artificiale più recenti."
        },
        "badgeRemote": "Dispositivo remoto · sicuro",
        "browser": {
            "openButton": "Open Browser",
            "windowTitle": "Browser Cephable",
            "newTab": "Nuova scheda",
            "reload": "Ricaricare",
            "forward": "Inoltrare",
            "openExternal": "Apri nel browser predefinito",
            "showWindow": "Mostra il browser nascosto",
            "addressPlaceholder": "Cerca su Google o digita un URL",
            "clearData": {
                "description": "Cancella la cronologia, i cookie, i dati memorizzati nella cache e le credenziali di accesso salvate del browser Cephable. In questo modo verrai disconnesso da tutti i siti web nel browser Cephable.",
                "button": "Cancella i dati del browser",
                "cleared": "Dati del browser cancellati.",
                "error": "Impossibile cancellare i dati del browser.",
                "confirmTitle": "Cancellare i dati del browser?",
                "confirmMessage": "Disconnettersi completamente dal browser Cephable?",
                "confirmDetail": "Questa operazione cancella definitivamente cronologia, cookie, dati memorizzati nella cache e credenziali di accesso salvate per il browser Cephable. È un'operazione irreversibile.",
                "confirm": "Dati chiari",
                "cancel": "Cancellare"
            },
            "context": {
                "newTab": "Nuova scheda",
                "reload": "Ricaricare",
                "duplicate": "Scheda duplicata",
                "close": "Chiudi la scheda",
                "closeOthers": "Chiudi le altre schede",
                "closeRight": "Chiudi le schede a destra",
                "back": "Indietro",
                "forward": "Inoltrare",
                "openLinkNewTab": "Apri il link in una nuova scheda",
                "openLinkExternal": "Apri il link nel browser predefinito",
                "openExternal": "Apri nel browser predefinito",
                "openAllExternal": "Apri tutte le schede nel browser predefinito"
            },
            "home": {
                "tabTitle": "Casa",
                "title": "Il browser Cephable",
                "tagline": "Cephable, un browser separato, può essere utilizzato al posto tuo.",
                "description": "È qui che Cephable automatizza le attività web per tuo conto. Funziona indipendentemente dal tuo browser abituale, quindi le tue schede, gli accessi e la navigazione rimangono invariati mentre le automazioni vengono eseguite, anche in background.",
                "searchPlaceholder": "Cerca su Google o digita un URL per iniziare",
                "go": "Andare",
                "features": {
                    "separate": {
                        "title": "Funziona da solo",
                        "description": "Mantenute separate dal browser predefinito, le automazioni non interferiscono mai con la tua navigazione personale."
                    },
                    "automate": {
                        "title": "Progettato per l'automazione",
                        "description": "Cephable può aprire pagine, compilare moduli e raccogliere informazioni qui, senza usare le mani."
                    },
                    "handoff": {
                        "title": "Consegna in qualsiasi momento",
                        "description": "Apri una qualsiasi pagina nel tuo browser predefinito ogni volta che desideri prenderne il controllo."
                    }
                }
            }
        }
    },
    "noResults": "Nessun risultato",
    "noResultsSearch": "Nessun risultato trovato per la tua ricerca.",
    "interrupted": "Interrotto",
    "aiHistory": {
        "title": "Storia dell'IA",
        "description": "Visualizza, cerca e gestisci la cronologia delle tue conversazioni con l'IA a livello locale.",
        "empty": {
            "title": "Nessuna storia di IA ancora",
            "description": "La cronologia delle tue conversazioni con l'IA verrà visualizzata qui dopo aver utilizzato le attività intelligenti."
        },
        "search": {
            "placeholder": "Cerca conversazioni..."
        },
        "pagination": {
            "range": "Visualizzazione di {{inizio}}–{{fine}} di {{totale}}"
        },
        "source": {
            "create": "Creare",
            "automate": "Automatizzare"
        },
        "workflow": {
            "plan": "Piano",
            "steps": "Passaggi",
            "files": "File",
            "folders": "Cartelle"
        },
        "trace": {
            "thinking": "Pensiero",
            "toolCalls": "Chiamate di aggancio",
            "roles": {
                "tool": "Risultato dello strumento"
            },
            "thought": "Pensiero",
            "action": "Azione",
            "parameters": "Parametri",
            "result": "Risultato",
            "reply": "Hai risposto",
            "sources": "Fonti"
        },
        "task": {
            "instructions": "Istruzioni",
            "language": "Lingua",
            "types": {
                "generate": "Generare",
                "rewrite": "Riscrivere",
                "translate": "Tradurre",
                "summarize": "Riassumere"
            }
        },
        "session": {
            "messages": "messaggi",
            "deleteTitle": "Elimina la conversazione",
            "deleteDescription": "Sei sicuro di voler eliminare questa conversazione? Questa operazione è irreversibile.",
            "deleteConfirm": "Eliminare",
            "deleteCancel": "Cancellare"
        },
        "clear": {
            "title": "Cancella la cronologia dell'IA",
            "description": "Elimina tutta la cronologia delle conversazioni AI memorizzate localmente su questo dispositivo.",
            "confirm": {
                "title": "Cancella la cronologia dell'IA",
                "description": "Sei sicuro di voler cancellare tutta la cronologia delle conversazioni con l'IA? Questa operazione è irreversibile.",
                "confirm": "Cancella tutto",
                "cancel": "Cancellare"
            },
            "success": "Cronologia IA cancellata con successo.",
            "error": "Impossibile cancellare la cronologia dell'IA."
        },
        "export": {
            "title": "Esportare",
            "description": "Esporta la cronologia delle tue conversazioni con l'IA in un file JSONL.",
            "success": "Cronologia dell'IA esportata correttamente.",
            "error": "Impossibile esportare la cronologia dell'IA."
        },
        "retention": {
            "note": "Manteniamo le tue {{count}} conversazioni più recenti. I preferiti vengono sempre conservati.",
            "label": "Mantenere"
        },
        "filter": {
            "label": "Filtra per tipo",
            "all": "Tutti i tipi"
        },
        "favorites": {
            "title": "Preferiti",
            "add": "Aggiungi ai preferiti",
            "remove": "Rimuovi dai preferiti"
        },
        "select": {
            "selectOne": "Seleziona la conversazione",
            "selected": "{{count}} selezionati",
            "deleteSelected": "Elimina selezionati",
            "clear": "Chiaro",
            "deleteTitle": "Elimina le conversazioni selezionate",
            "deleteDescription": "Eliminare {{count}} conversazioni selezionate? Questa operazione non può essere annullata."
        },
        "copy": {
            "label": "Copia",
            "success": "Copiato negli appunti.",
            "error": "Impossibile copiare negli appunti."
        },
        "live": "Vivere",
        "keychain": {
            "continue": "Continuare",
            "title": "Proteggere la cronologia dell'IA",
            "message": "Cephable crittografa la cronologia delle tue attività di intelligenza artificiale, inclusa la cronologia dei flussi di lavoro, su questo Mac.",
            "detail": "Successivamente, macOS ti chiederà di autorizzare l'accesso a \"Archiviazione sicura di Cephable\". Questa contiene solo la chiave di crittografia, non il contenuto del tuo flusso di lavoro o delle tue attività. Seleziona \"Consenti sempre\" per mantenere la cronologia crittografata disponibile senza che ti venga chiesto di nuovo. Selezionando \"Consenti\", Cephable potrà accedervi questa volta, ma macOS potrebbe richiederlo nuovamente al successivo avvio."
        }
    },
    "uses": "Usi: {{value}}"
}
